import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, resolveDirective as _resolveDirective, vShow as _vShow, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c7b8ff1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-body py-0 px-lg-6 umt-form" }
const _hoisted_2 = {
  class: "scroll-y pe-3",
  id: "kt_modal_add_customer_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_customer_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_customer_scroll",
  "data-kt-scroll-offset": "300px",
  style: {"min-height":"81vh","overflow-x":"hidden"}
}
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-wrap align-items-center justify-content-end gap-3 mb-2"
}
const _hoisted_4 = { class: "text-danger fs-7 text-uppercase fw-bolder" }
const _hoisted_5 = {
  class: "tab-content mt-4",
  id: "myTabContent"
}
const _hoisted_6 = {
  id: "kt_customer_view_method",
  role: "tabpanel"
}
const _hoisted_7 = {
  key: 0,
  class: "fw-bolder umt-section-hdr text-uppercase fs-5 py-2 px-3 rounded bg-light border-start border-4 border-primary mb-2"
}
const _hoisted_8 = {
  key: 1,
  class: "text-muted fs-8 fst-italic mb-4 ps-3"
}
const _hoisted_9 = { class: "fw-semibold text-gray-700" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning me-2" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Trực tuyến", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "khác Trực tuyến", -1))
const _hoisted_13 = {
  key: 3,
  class: "d-flex flex-column flex-md-row gap-5 justify-content-between"
}
const _hoisted_14 = { class: "mb-3 fv-row w-100" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Nguồn", -1))
const _hoisted_16 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_17 = { class: "mb-3 fv-row w-100" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Ngày tạo", -1))
const _hoisted_19 = { class: "mb-3 fv-row w-100" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Đợt", -1))
const _hoisted_21 = {
  key: 0,
  class: "mb-3 fv-row w-100 d-flex flex-column justify-content-end"
}
const _hoisted_22 = { class: "form-check form-check-custom form-check-solid align-items-center cursor-pointer mb-2" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-label mb-0 cursor-pointer" }, "Là đợt bổ sung", -1))
const _hoisted_25 = {
  key: 4,
  class: "mb-3 fv-row w-100"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "required fw-bolder umt-section-hdr text-uppercase fs-6 py-2 px-3 rounded bg-light border-start border-4 border-primary mb-3" }, "Thông tin cá nhân", -1))
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-lg-4 col-12" }
const _hoisted_29 = { class: "mb-3 fv-row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Họ và tên", -1))
const _hoisted_31 = { class: "col-lg-4 col-12" }
const _hoisted_32 = { class: "mb-3 fv-row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Ngày sinh", -1))
const _hoisted_34 = { class: "col-lg-4 col-12" }
const _hoisted_35 = { class: "mb-3 fv-row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Giới tính", -1))
const _hoisted_37 = { class: "col-lg-4 col" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "required form-label",
  id: "tick-scroll"
}, "CMND/CCCD", -1))
const _hoisted_39 = { class: "col-lg-4 col" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "required form-label",
  id: "tick-scroll"
}, "Ngày cấp", -1))
const _hoisted_41 = { class: "col-lg-4 col" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Nơi cấp", -1))
const _hoisted_43 = { class: "col-lg-4 col" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Nơi sinh", -1))
const _hoisted_45 = { class: "col-lg-4 col" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "required form-label",
  id: "tick-scroll"
}, "Email", -1))
const _hoisted_47 = { class: "col-lg-4 col" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "required form-label",
  id: "tick-scroll"
}, "SĐT", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-md-row gap-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-3 flex-row-fluid" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "Hộ khẩu thường trú")
  ])
], -1))
const _hoisted_51 = { class: "d-flex flex-column flex-md-row gap-5" }
const _hoisted_52 = { class: "mb-3 flex-row-fluid" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tỉnh/Thành phố", -1))
const _hoisted_54 = {
  key: 0,
  class: "mb-3 fv-row flex-row-fluid"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Quận/Huyện", -1))
const _hoisted_56 = { class: "mb-3 fv-row flex-row-fluid" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Phường/Xã", -1))
const _hoisted_58 = { class: "mb-3 fv-row" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Địa chỉ sau sáp nhập (Số nhà, tên đường, khu phố)", -1))
const _hoisted_60 = { class: "d-flex flex-column flex-md-row gap-5" }
const _hoisted_61 = { class: "mb-3 flex-row-fluid" }
const _hoisted_62 = { class: "mb-0" }
const _hoisted_63 = { class: "ms-4 wrap-check-aotufill" }
const _hoisted_64 = ["disabled"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "checkAddress",
  class: "ms-2"
}, [
  /*#__PURE__*/_createElementVNode("i", null, "Giống địa chỉ thường trú")
], -1))
const _hoisted_66 = { class: "d-flex flex-column flex-md-row gap-5" }
const _hoisted_67 = { class: "mb-3 flex-row-fluid" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tỉnh/Thành phố", -1))
const _hoisted_69 = {
  key: 0,
  class: "mb-3 fv-row flex-row-fluid"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Quận/Huyện", -1))
const _hoisted_71 = { class: "mb-3 fv-row flex-row-fluid" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Phường/Xã", -1))
const _hoisted_73 = { class: "mb-3 fv-row" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Địa chỉ sau sáp nhập (Số nhà, tên đường, khu phố)", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning me-2" }, null, -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "Còn thiếu:", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center umt-section-hdr fs-6 text-uppercase mb-4 mt-2 py-2 px-3 rounded bg-light border-start border-4 border-primary" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge me-2 fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "1"),
  /*#__PURE__*/_createTextVNode(" Thông tin đăng ký")
], -1))
const _hoisted_78 = { class: "row mb-2" }
const _hoisted_79 = { class: "col-lg-8 col-12" }
const _hoisted_80 = { class: "mb-3 fv-row" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Ngành đăng ký", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center umt-section-hdr fs-6 text-uppercase mb-4 mt-4 py-2 px-3 rounded bg-light border-start border-4 border-primary" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge me-2 fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "2"),
  /*#__PURE__*/_createTextVNode(" Thông tin công việc")
], -1))
const _hoisted_83 = { class: "row" }
const _hoisted_84 = { class: "col-lg-4 col-12" }
const _hoisted_85 = { class: "mb-3 fv-row" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Nơi làm việc (tên công ty, địa chỉ)", -1))
const _hoisted_87 = { class: "col-lg-4 col-12" }
const _hoisted_88 = { class: "mb-3 fv-row" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Nghề nghiệp", -1))
const _hoisted_90 = { class: "col-lg-4 col-12" }
const _hoisted_91 = { class: "mb-3 fv-row" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Chức vụ", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center umt-section-hdr fs-6 text-uppercase mb-4 mt-4 py-2 px-3 rounded bg-light border-start border-4 border-primary" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge me-2 fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "3"),
  /*#__PURE__*/_createTextVNode(" Thông tin quá trình học tập")
], -1))
const _hoisted_94 = { class: "row" }
const _hoisted_95 = { class: "col-lg-6 col-12" }
const _hoisted_96 = { class: "mb-3 fv-row" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Trường tốt nghiệp", -1))
const _hoisted_98 = { class: "row" }
const _hoisted_99 = { class: "col-lg-3 col-12" }
const _hoisted_100 = { class: "mb-3 fv-row" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Hình thức đào tạo", -1))
const _hoisted_102 = { class: "col-lg-3 col-12" }
const _hoisted_103 = { class: "mb-3 fv-row" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Hệ", -1))
const _hoisted_105 = { class: "col-lg-3 col-12" }
const _hoisted_106 = { class: "mb-3 fv-row" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Điểm trung bình", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Hệ 4", -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Hệ 10", -1))
const _hoisted_110 = { class: "col-lg-3 col-12" }
const _hoisted_111 = { class: "mb-3 fv-row" }
const _hoisted_112 = { class: "required form-label" }
const _hoisted_113 = {
  key: 0,
  class: "text-gray-500 fw-normal ms-1"
}
const _hoisted_114 = {
  key: 1,
  class: "text-gray-500 fw-normal ms-1"
}
const _hoisted_115 = { class: "col-lg-3 col-12" }
const _hoisted_116 = { class: "mb-3 fv-row" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Số hiệu bằng tốt nghiệp", -1))
const _hoisted_118 = { class: "col-lg-3 col-12" }
const _hoisted_119 = { class: "mb-3 fv-row" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Số vào sổ TN", -1))
const _hoisted_121 = { class: "col-lg-3 col-12" }
const _hoisted_122 = { class: "mb-3 fv-row" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Năm tốt nghiệp", -1))
const _hoisted_124 = { class: "col-lg-3 col-12" }
const _hoisted_125 = { class: "mb-3 fv-row" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Ngày cấp bằng", -1))
const _hoisted_127 = { class: "col-12" }
const _hoisted_128 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 cursor-pointer align-items-baseline gap-3" }
const _hoisted_129 = {
  key: 0,
  class: "border border-gray-300 rounded p-4 mt-2 mb-3"
}
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold text-gray-700 fs-7 mb-3" }, "Thông tin tốt nghiệp Trung cấp", -1))
const _hoisted_131 = { class: "row" }
const _hoisted_132 = { class: "col-12" }
const _hoisted_133 = { class: "mb-3 fv-row" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Trường tốt nghiệp", -1))
const _hoisted_135 = { class: "col-lg-3 col-12" }
const _hoisted_136 = { class: "mb-3 fv-row" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Hình thức đào tạo", -1))
const _hoisted_138 = { class: "col-lg-3 col-12" }
const _hoisted_139 = { class: "mb-3 fv-row" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Hệ", -1))
const _hoisted_141 = { class: "col-lg-3 col-12" }
const _hoisted_142 = { class: "mb-3 fv-row" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Số hiệu bằng tốt nghiệp", -1))
const _hoisted_144 = { class: "col-lg-3 col-12" }
const _hoisted_145 = { class: "mb-3 fv-row" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Số vào sổ TN", -1))
const _hoisted_147 = { class: "col-lg-3 col-12" }
const _hoisted_148 = { class: "mb-3 fv-row" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Năm tốt nghiệp", -1))
const _hoisted_150 = { class: "col-lg-3 col-12" }
const _hoisted_151 = { class: "mb-3 fv-row" }
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label" }, "Ngày cấp bằng", -1))
const _hoisted_153 = {
  key: 5,
  class: "mb-3 fv-row w-100"
}
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "d-flex align-items-center required fw-bolder umt-section-hdr text-uppercase fs-6 py-2 px-3 rounded bg-light border-start border-4 border-primary mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge me-2 fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "1"),
  /*#__PURE__*/_createTextVNode("Phương thức xét tuyển")
], -1))
const _hoisted_155 = { class: "row" }
const _hoisted_156 = { class: "col-md-6" }
const _hoisted_157 = {
  key: 0,
  class: "ps-10 fv-row mb-6 col-12 mt-3"
}
const _hoisted_158 = ["innerHTML"]
const _hoisted_159 = {
  key: 6,
  class: "separator separator-dashed my-8"
}
const _hoisted_160 = {
  key: 7,
  class: "row mb-8"
}
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder umt-section-hdr text-uppercase fs-6 py-2 px-3 rounded bg-light border-start border-4 border-primary mb-4 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-patch-check-fill me-2" }),
    /*#__PURE__*/_createTextVNode("Chứng chỉ & Điểm khuyến khích (2026) ")
  ])
], -1))
const _hoisted_162 = { class: "col-12" }
const _hoisted_163 = { class: "row" }
const _hoisted_164 = { class: "col-md-8" }
const _hoisted_165 = { class: "row mb-8 p-4 bg-light-primary rounded border border-primary border-dashed" }
const _hoisted_166 = { class: "col-12" }
const _hoisted_167 = { class: "d-flex align-items-center cursor-pointer mb-2" }
const _hoisted_168 = { class: "form-check form-check-custom form-check-sm me-3" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-6 text-gray-900" }, "Sử dụng chứng chỉ Tiếng Anh (IELTS, TOEIC, TOEFL, PTE) để quy đổi điểm hoặc cộng điểm ưu tiên", -1))
const _hoisted_170 = {
  key: 0,
  class: "row mt-4 pt-4 border-top border-gray-300"
}
const _hoisted_171 = { class: "col-md-6 mb-6" }
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold form-label required" }, "Loại chứng chỉ", -1))
const _hoisted_173 = { class: "col-md-6 mb-6" }
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold form-label required" }, "Ngày hết hạn", -1))
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-gray-600 mt-1" }, "Hạn tối thiểu: 31/10/2026.", -1))
const _hoisted_176 = { class: "col-md-6 mb-6" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold form-label required" }, "Điểm Nghe & Đọc", -1))
const _hoisted_178 = { class: "col-md-6 mb-6" }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold form-label required" }, "Điểm Nói & Viết", -1))
const _hoisted_180 = {
  key: 1,
  class: "col-md-6 mb-6"
}
const _hoisted_181 = { class: "fw-bold form-label required" }
const _hoisted_182 = {
  key: 0,
  class: "text-gray-600 fw-normal"
}
const _hoisted_183 = { class: "row mb-4 p-4 bg-light-warning rounded border border-warning border-dashed" }
const _hoisted_184 = { class: "col-12" }
const _hoisted_185 = { class: "d-flex align-items-center cursor-pointer mb-2" }
const _hoisted_186 = { class: "form-check form-check-custom form-check-sm me-3" }
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-6 text-gray-900" }, "Cộng điểm khuyến khích khác (MOS, Ngoại ngữ khác, Công nghệ...)", -1))
const _hoisted_188 = {
  key: 0,
  class: "row mt-4 pt-4 border-top border-gray-300"
}
const _hoisted_189 = { class: "col-12 mb-6" }
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "fw-bolder text-gray-800 mb-4" }, "Chứng chỉ MOS", -1))
const _hoisted_191 = { class: "row" }
const _hoisted_192 = { class: "col-md-3 mb-4" }
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold form-label fs-8" }, "Word", -1))
const _hoisted_194 = { class: "col-md-3 mb-4" }
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold form-label fs-8" }, "Excel", -1))
const _hoisted_196 = { class: "col-md-3 mb-4" }
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold form-label fs-8" }, "PowerPoint", -1))
const _hoisted_198 = { class: "col-md-3 mb-6" }
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold form-label small" }, "Nhật (JLPT)", -1))
const _hoisted_200 = { class: "col-md-3 mb-6" }
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold form-label small" }, "Trung (HSK)", -1))
const _hoisted_202 = { class: "col-md-3 mb-6" }
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold form-label small" }, "Hàn (TOPIK)", -1))
const _hoisted_204 = { class: "col-md-3 mb-6" }
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold form-label small" }, "Pháp (DELF)", -1))
const _hoisted_206 = { class: "col-md-3 mb-6" }
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold form-label small" }, "VSTEP", -1))
const _hoisted_208 = { class: "col-md-3 mb-6" }
const _hoisted_209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold form-label small" }, "Aptis ESOL", -1))
const _hoisted_210 = { class: "col-12 mt-2" }
const _hoisted_211 = { class: "d-flex align-items-center cursor-pointer mb-4" }
const _hoisted_212 = { class: "form-check form-check-custom form-check-sm me-3" }
const _hoisted_213 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold fs-7" }, "Chứng chỉ quốc tế khác (Microsoft, Cisco, ARENA...)", -1))
const _hoisted_214 = {
  key: 0,
  class: "row pt-2"
}
const _hoisted_215 = { class: "col-md-6 mb-6" }
const _hoisted_216 = { class: "col-md-4" }
const _hoisted_217 = {
  key: 0,
  class: "h-100"
}
const _hoisted_218 = {
  class: "sticky-top",
  style: {"top":"115px","z-index":"2"}
}
const _hoisted_219 = { class: "notice d-flex bg-light-success rounded border-success border border-dashed p-6" }
const _hoisted_220 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_221 = { class: "fw-bold" }
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-gray-900 fw-bolder m-0 mb-5 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calculator text-success me-3" }),
  /*#__PURE__*/_createTextVNode(" Kết quả dự kiến: ")
], -1))
const _hoisted_223 = { class: "fs-6 text-gray-800" }
const _hoisted_224 = {
  key: 0,
  class: "mb-4 p-3 bg-white bg-opacity-50 rounded"
}
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 mb-1 small uppercase fw-bolder" }, "Quy đổi Tiếng Anh:", -1))
const _hoisted_226 = { class: "text-success fs-3 fw-bolder" }
const _hoisted_227 = {
  key: 1,
  class: "mb-4 p-3 bg-white bg-opacity-50 rounded"
}
const _hoisted_228 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 mb-1 small uppercase fw-bolder" }, "Tổng điểm khuyến khích:", -1))
const _hoisted_229 = { class: "text-primary fs-3 fw-bolder" }
const _hoisted_230 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-danger mt-2 italic" }, "* Đã áp dụng mức trần tối đa 1.5 theo quy định.", -1))
const _hoisted_231 = {
  key: 2,
  class: "p-3 bg-white rounded border border-success border-dotted"
}
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-danger fw-bold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle text-danger me-2" }),
  /*#__PURE__*/_createTextVNode(" Chứng chỉ tiếng Anh đã hết hạn!")
], -1))
const _hoisted_233 = [
  _hoisted_232
]
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-6 pt-6 border-top border-gray-300" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs-8 text-gray-600 italic" }, "Các điểm số trên sẽ được hệ thống tự động ưu tiên áp dụng mức có lợi nhất cho thí sinh trong từng nguyện vọng.")
], -1))
const _hoisted_235 = {
  key: 1,
  class: "h-100 d-flex align-items-center justify-content-center p-6 bg-light rounded border border-dotted border-gray-400"
}
const _hoisted_236 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-gray-500" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle fs-2 mb-3" }),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-7" }, "Vui lòng nhập thông tin chứng chỉ để xem kết quả tính toán dự kiến.")
], -1))
const _hoisted_237 = [
  _hoisted_236
]
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-8" }, null, -1))
const _hoisted_239 = {
  key: 8,
  class: "method-score-block"
}
const _hoisted_240 = { class: "d-flex flex-column flex-md-row gap-5 pt-3" }
const _hoisted_241 = { class: "mb-3 flex-row-fluid" }
const _hoisted_242 = { class: "d-flex align-items-center mb-0 fw-bolder umt-section-hdr text-uppercase fs-6 py-2 px-3 rounded bg-light border-start border-4 border-primary" }
const _hoisted_243 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}, "2", -1))
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "(Nhập điểm môn học vào ô tương ứng đúng với điểm thi THPT, không làm tròn điểm)", -1))
const _hoisted_245 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning me-2" }, null, -1))
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "khác", -1))
const _hoisted_247 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "có môn chưa có", -1))
const _hoisted_248 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "tự động ghi lại", -1))
const _hoisted_249 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Lưu hồ sơ", -1))
const _hoisted_250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted mx-1" }, "·", -1))
const _hoisted_251 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Bảng điểm thi TN THPT", -1))
const _hoisted_253 = { class: "score-grid" }
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Ngữ văn ", -1))
const _hoisted_255 = {
  key: 0,
  class: "ms-4 fw-bolder text-danger"
}
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Toán ", -1))
const _hoisted_257 = {
  key: 0,
  class: "ms-4 fw-bolder text-danger"
}
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Tiếng Anh ", -1))
const _hoisted_259 = {
  key: 0,
  class: "ms-4 fw-bolder text-danger"
}
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Tiếng Pháp ", -1))
const _hoisted_261 = {
  key: 0,
  class: "ms-4 fw-bolder text-danger"
}
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Vật lý ", -1))
const _hoisted_263 = {
  key: 0,
  class: "ms-4 fw-bolder text-danger"
}
const _hoisted_264 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Hóa học ", -1))
const _hoisted_265 = {
  key: 0,
  class: "ms-4 fw-bolder text-danger"
}
const _hoisted_266 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Sinh học ", -1))
const _hoisted_267 = {
  key: 0,
  class: "ms-4 fw-bolder text-danger"
}
const _hoisted_268 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Lịch sử ", -1))
const _hoisted_269 = {
  key: 0,
  class: "ms-4 fw-bolder text-danger"
}
const _hoisted_270 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Địa lý ", -1))
const _hoisted_271 = {
  key: 0,
  class: "ms-4 fw-bolder text-danger"
}
const _hoisted_272 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Tin học ", -1))
const _hoisted_273 = {
  key: 0,
  class: "ms-4 fw-bolder text-danger"
}
const _hoisted_274 = {
  key: 1,
  class: "fv-row flex-row-fluid"
}
const _hoisted_275 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Vẽ ", -1))
const _hoisted_276 = {
  key: 0,
  class: "ms-4 fw-bolder text-danger"
}
const _hoisted_277 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "GD K.tế và P.luật ", -1))
const _hoisted_278 = {
  key: 0,
  class: "ms-4 fw-bolder text-danger"
}
const _hoisted_279 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-md-row gap-5 my-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-row-fluid" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "d-flex align-items-center fw-bolder umt-section-hdr text-uppercase fs-6 py-2 px-3 rounded bg-light border-start border-4 border-primary mb-3" }, [
      /*#__PURE__*/_createElementVNode("span", {
        class: "badge badge-circle hdr-num-badge me-2 fs-8",
        style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
      }, "3"),
      /*#__PURE__*/_createTextVNode("Ngành đăng ký xét tuyển")
    ]),
    /*#__PURE__*/_createElementVNode("i", null, "Ứng viên lựa chọn tối đa 3 ngành để đăng ký xét tuyển với độ ưu tiên từ cao xuống thấp.")
  ])
], -1))
const _hoisted_280 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning me-2" }, null, -1))
const _hoisted_281 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "Còn thiếu điểm:", -1))
const _hoisted_282 = { class: "col-12" }
const _hoisted_283 = { class: "row p-0 mb-2" }
const _hoisted_284 = { class: "col-md-4 fv-row mb-4" }
const _hoisted_285 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_286 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Ưu tiên 1", -1))
const _hoisted_287 = { class: "col-md-5 fv-row mb-4" }
const _hoisted_288 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_289 = { class: "form-label required d-flex align-items-center justify-content-between w-100" }
const _hoisted_290 = {
  key: 0,
  class: "c-umt3rd ms-1"
}
const _hoisted_291 = {
  key: 0,
  class: "form-check form-check-custom form-check-sm"
}
const _hoisted_292 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fs-9 text-gray-600 cursor-pointer",
  for: "isUseEnglish1_thpt"
}, "Áp dụng quy đổi Tiếng Anh", -1))
const _hoisted_293 = {
  key: 0,
  class: "col-md-3 fv-row mb-2 text-left"
}
const _hoisted_294 = { class: "mb-1" }
const _hoisted_295 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_296 = { class: "d-flex align-items-center" }
const _hoisted_297 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Tổng điểm 3 môn:", -1))
const _hoisted_298 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_299 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-success" }
const _hoisted_300 = { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-success rounded border-success border border-dashed p-2" }
const _hoisted_301 = { class: "fs-6" }
const _hoisted_302 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mb-1"
}
const _hoisted_303 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Điểm khuyến khích:", -1))
const _hoisted_304 = { class: "text-primary fs-6" }
const _hoisted_305 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_306 = { class: "d-flex align-items-center" }
const _hoisted_307 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fw-bold text-gray-700" }, "Điểm ưu tiên tạm tính:", -1))
const _hoisted_308 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_309 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_310 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-warning rounded border-warning border border-dashed p-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("Điểm ưu tiên đối với thí sinh đạt tổng điểm từ 22,5 trở lên được xác định theo công thức: "),
    /*#__PURE__*/_createElementVNode("strong", null, "[(30 - Tổng điểm)/7,5] x Điểm ưu tiên thông thường")
  ])
], -1))
const _hoisted_311 = { class: "fs-6" }
const _hoisted_312 = { class: "border-top border-gray-300 mt-1 pt-2 d-flex justify-content-between align-items-center" }
const _hoisted_313 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-800" }, "Tổng điểm xét tuyển:", -1))
const _hoisted_314 = { class: "text-danger fs-4" }
const _hoisted_315 = { class: "row p-0 mb-2" }
const _hoisted_316 = { class: "col-md-4 fv-row mb-4" }
const _hoisted_317 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_318 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Ưu tiên 2", -1))
const _hoisted_319 = { class: "col-md-5 fv-row mb-4" }
const _hoisted_320 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_321 = { class: "form-label d-flex align-items-center justify-content-between w-100" }
const _hoisted_322 = {
  key: 0,
  class: "c-umt3rd ms-1"
}
const _hoisted_323 = {
  key: 0,
  class: "form-check form-check-custom form-check-sm"
}
const _hoisted_324 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fs-9 text-gray-600 cursor-pointer",
  for: "isUseEnglish2_thpt"
}, "Áp dụng quy đổi Tiếng Anh", -1))
const _hoisted_325 = {
  key: 0,
  class: "col-md-3 fv-row mb-2 text-left"
}
const _hoisted_326 = { class: "mb-1" }
const _hoisted_327 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_328 = { class: "d-flex align-items-center" }
const _hoisted_329 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Tổng điểm 3 môn:", -1))
const _hoisted_330 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_331 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-success" }
const _hoisted_332 = { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-success rounded border-success border border-dashed p-2" }
const _hoisted_333 = { class: "fs-6" }
const _hoisted_334 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mb-1"
}
const _hoisted_335 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Điểm khuyến khích:", -1))
const _hoisted_336 = { class: "text-primary fs-6" }
const _hoisted_337 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_338 = { class: "d-flex align-items-center" }
const _hoisted_339 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fw-bold text-gray-700" }, "Điểm ưu tiên tạm tính:", -1))
const _hoisted_340 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_341 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_342 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-warning rounded border-warning border border-dashed p-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("Điểm ưu tiên đối với thí sinh đạt tổng điểm từ 22,5 trở lên được xác định theo công thức: "),
    /*#__PURE__*/_createElementVNode("strong", null, "[(30 - Tổng điểm)/7,5] x Điểm ưu tiên thông thường")
  ])
], -1))
const _hoisted_343 = { class: "fs-6" }
const _hoisted_344 = { class: "border-top border-gray-300 mt-1 pt-2 d-flex justify-content-between align-items-center" }
const _hoisted_345 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-800" }, "Tổng điểm xét tuyển:", -1))
const _hoisted_346 = { class: "text-danger fs-4" }
const _hoisted_347 = { class: "row p-0 mb-2" }
const _hoisted_348 = { class: "col-md-4 fv-row mb-4" }
const _hoisted_349 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_350 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Ưu tiên 3", -1))
const _hoisted_351 = { class: "col-md-5 fv-row mb-4" }
const _hoisted_352 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_353 = { class: "form-label d-flex align-items-center justify-content-between w-100" }
const _hoisted_354 = {
  key: 0,
  class: "c-umt3rd ms-1"
}
const _hoisted_355 = {
  key: 0,
  class: "form-check form-check-custom form-check-sm"
}
const _hoisted_356 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fs-9 text-gray-600 cursor-pointer",
  for: "isUseEnglish3_thpt"
}, "Áp dụng quy đổi Tiếng Anh", -1))
const _hoisted_357 = {
  key: 0,
  class: "col-md-3 fv-row mb-2 text-left"
}
const _hoisted_358 = { class: "mb-1" }
const _hoisted_359 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_360 = { class: "d-flex align-items-center" }
const _hoisted_361 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Tổng điểm 3 môn:", -1))
const _hoisted_362 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_363 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-success" }
const _hoisted_364 = { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-success rounded border-success border border-dashed p-2" }
const _hoisted_365 = { class: "fs-6" }
const _hoisted_366 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mb-1"
}
const _hoisted_367 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Điểm khuyến khích:", -1))
const _hoisted_368 = { class: "text-primary fs-6" }
const _hoisted_369 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_370 = { class: "d-flex align-items-center" }
const _hoisted_371 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fw-bold text-gray-700" }, "Điểm ưu tiên tạm tính:", -1))
const _hoisted_372 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_373 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_374 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-warning rounded border-warning border border-dashed p-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("Điểm ưu tiên đối với thí sinh đạt tổng điểm từ 22,5 trở lên được xác định theo công thức: "),
    /*#__PURE__*/_createElementVNode("strong", null, "[(30 - Tổng điểm)/7,5] x Điểm ưu tiên thông thường")
  ])
], -1))
const _hoisted_375 = { class: "fs-6" }
const _hoisted_376 = { class: "border-top border-gray-300 mt-1 pt-2 d-flex justify-content-between align-items-center" }
const _hoisted_377 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-800" }, "Tổng điểm xét tuyển:", -1))
const _hoisted_378 = { class: "text-danger fs-4" }
const _hoisted_379 = {
  key: 9,
  class: "method-score-block"
}
const _hoisted_380 = { class: "row pt-3" }
const _hoisted_381 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "d-flex align-items-center fw-bolder umt-section-hdr text-uppercase fs-6 py-2 px-3 rounded bg-light border-start border-4 border-primary mb-3" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "badge badge-circle hdr-num-badge me-2 fs-8",
      style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
    }, "2"),
    /*#__PURE__*/_createTextVNode("Kết quả thi (thang điểm 150)")
  ]),
  /*#__PURE__*/_createElementVNode("i", { class: "fs-7 text-gray-600" }, "Nhập điểm các môn thi vào ô tương ứng bên dưới. Hệ thống sẽ tự động chọn 3 môn có điểm cao nhất để xét tuyển.")
], -1))
const _hoisted_382 = { class: "col-md-8" }
const _hoisted_383 = { class: "row g-3" }
const _hoisted_384 = { class: "col-md-3" }
const _hoisted_385 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Toán", -1))
const _hoisted_386 = { class: "col-md-3" }
const _hoisted_387 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Ngữ văn", -1))
const _hoisted_388 = { class: "col-md-3" }
const _hoisted_389 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Tiếng Anh", -1))
const _hoisted_390 = { class: "col-md-3" }
const _hoisted_391 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Vật lý", -1))
const _hoisted_392 = { class: "col-md-3" }
const _hoisted_393 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Hóa học", -1))
const _hoisted_394 = { class: "col-md-3" }
const _hoisted_395 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Sinh học", -1))
const _hoisted_396 = { class: "col-md-3" }
const _hoisted_397 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Lịch sử", -1))
const _hoisted_398 = { class: "col-md-3" }
const _hoisted_399 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Địa lý", -1))
const _hoisted_400 = { class: "col-md-4" }
const _hoisted_401 = { class: "p-5 rounded border border-info border-dashed bg-light-info min-h-150px d-flex flex-column justify-content-center" }
const _hoisted_402 = { class: "d-flex flex-stack mb-2" }
const _hoisted_403 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-7" }, "Điểm quy đổi (thang 30):", -1))
const _hoisted_404 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_405 = { class: "d-flex flex-stack mb-2" }
const _hoisted_406 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-7" }, "Điểm ưu tiên tạm tính:", -1))
const _hoisted_407 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_408 = { class: "d-flex flex-stack mb-2" }
const _hoisted_409 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-7" }, "Điểm cộng (Điểm khuyến khích):", -1))
const _hoisted_410 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_411 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-2" }, null, -1))
const _hoisted_412 = { class: "d-flex flex-stack" }
const _hoisted_413 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 fs-6" }, "Tổng điểm xét tuyển:", -1))
const _hoisted_414 = { class: "fw-bolder fs-3 text-danger" }
const _hoisted_415 = { class: "col-12 mt-8" }
const _hoisted_416 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "d-flex align-items-center fw-bolder umt-section-hdr text-uppercase fs-6 py-2 px-3 rounded bg-light border-start border-4 border-primary mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge me-2 fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "3"),
  /*#__PURE__*/_createTextVNode("Ngành đăng ký xét tuyển")
], -1))
const _hoisted_417 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-7 text-gray-600 mb-4" }, "Ứng viên lựa chọn tối đa 3 ngành để đăng ký xét tuyển với độ ưu tiên từ cao xuống thấp.", -1))
const _hoisted_418 = { class: "row" }
const _hoisted_419 = { class: "col-md-4 mb-4" }
const _hoisted_420 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold required" }, "Ưu tiên 1", -1))
const _hoisted_421 = { class: "col-md-4 mb-4" }
const _hoisted_422 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Ưu tiên 2", -1))
const _hoisted_423 = { class: "col-md-4 mb-4" }
const _hoisted_424 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Ưu tiên 3", -1))
const _hoisted_425 = {
  key: 10,
  class: "method-score-block"
}
const _hoisted_426 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-md-row gap-5 pt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-3 flex-row-fluid" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "d-flex align-items-center fw-bolder umt-section-hdr text-uppercase fs-6 py-2 px-3 rounded bg-light border-start border-4 border-primary mb-3" }, [
      /*#__PURE__*/_createElementVNode("span", {
        class: "badge badge-circle hdr-num-badge me-2 fs-8",
        style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
      }, "2"),
      /*#__PURE__*/_createTextVNode("Kết quả học tập 3 năm THPT")
    ]),
    /*#__PURE__*/_createElementVNode("i", null, "*Vui lòng điền đầy đủ thông tin và hệ thống sẽ tự động đề xuất cho bạn LỰA CHỌN TỐT NHẤT khi đăng ký xét tuyển")
  ])
], -1))
const _hoisted_427 = { class: "d-flex flex-column flex-md-row gap-5" }
const _hoisted_428 = { class: "mb-3 flex-row-fluid" }
const _hoisted_429 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-1" }, "Cả năm lớp 10", -1))
const _hoisted_430 = { class: "mb-3 fv-row flex-row-fluid" }
const _hoisted_431 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-1" }, "Cả năm lớp 11", -1))
const _hoisted_432 = { class: "mb-3 fv-row flex-row-fluid" }
const _hoisted_433 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-1" }, "Cả năm lớp 12", -1))
const _hoisted_434 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-md-row gap-5 pt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-3 flex-row-fluid" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "Điểm trung bình cộng cả năm lớp 12:"),
    /*#__PURE__*/_createElementVNode("i", null, "(Nhập điểm trung bình môn học vào ô tương ứng đúng với điểm trong học bạ, không làm tròn điểm)")
  ])
], -1))
const _hoisted_435 = { class: "d-flex flex-column flex-md-row gap-2" }
const _hoisted_436 = { class: "flex-row-fluid" }
const _hoisted_437 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Toán", -1))
const _hoisted_438 = { class: "fv-row flex-row-fluid" }
const _hoisted_439 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Vật lý", -1))
const _hoisted_440 = { class: "fv-row flex-row-fluid" }
const _hoisted_441 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Hóa học", -1))
const _hoisted_442 = { class: "fv-row flex-row-fluid" }
const _hoisted_443 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Tiếng Anh", -1))
const _hoisted_444 = { class: "fv-row flex-row-fluid" }
const _hoisted_445 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Tiếng Pháp", -1))
const _hoisted_446 = { class: "fv-row flex-row-fluid" }
const _hoisted_447 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Ngữ văn", -1))
const _hoisted_448 = { class: "fv-row flex-row-fluid" }
const _hoisted_449 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Lịch sử", -1))
const _hoisted_450 = { class: "fv-row flex-row-fluid" }
const _hoisted_451 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Địa lý", -1))
const _hoisted_452 = { class: "fv-row flex-row-fluid" }
const _hoisted_453 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-7 fw-bold mb-1" }, "Sinh học", -1))
const _hoisted_454 = { class: "fv-row flex-row-fluid" }
const _hoisted_455 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "fs-7 fw-bold mb-1",
  style: {"white-space":"nowrap"}
}, "GDCD", -1))
const _hoisted_456 = { class: "fv-row flex-row-fluid" }
const _hoisted_457 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "fs-7 fw-bold mb-1",
  style: {"white-space":"nowrap"}
}, "Tin học", -1))
const _hoisted_458 = { class: "fv-row flex-row-fluid" }
const _hoisted_459 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "fs-7 fw-bold mb-1",
  style: {"white-space":"nowrap"}
}, "Vẽ", -1))
const _hoisted_460 = { class: "fv-row flex-row-fluid" }
const _hoisted_461 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "fs-7 fw-bold mb-1",
  style: {"white-space":"nowrap"}
}, "GD K.tế và P.luật", -1))
const _hoisted_462 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-md-row gap-5 my-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-row-fluid" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "d-flex align-items-center fw-bolder umt-section-hdr text-uppercase fs-6 py-2 px-3 rounded bg-light border-start border-4 border-primary mb-3" }, [
      /*#__PURE__*/_createElementVNode("span", {
        class: "badge badge-circle hdr-num-badge me-2 fs-8",
        style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
      }, "3"),
      /*#__PURE__*/_createTextVNode("Ngành đăng ký xét tuyển")
    ]),
    /*#__PURE__*/_createElementVNode("i", null, "Ứng viên lựa chọn tối đa 3 ngành để đăng ký xét tuyển với độ ưu tiên từ cao xuống thấp.")
  ])
], -1))
const _hoisted_463 = {
  key: 1,
  class: "col-12"
}
const _hoisted_464 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning me-2" }, null, -1))
const _hoisted_465 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "khác", -1))
const _hoisted_466 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "tự động ghi lại", -1))
const _hoisted_467 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Lưu hồ sơ", -1))
const _hoisted_468 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted mx-1" }, "·", -1))
const _hoisted_469 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-droplet-half text-warning me-2" }, null, -1))
const _hoisted_470 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "trống/thiếu điểm", -1))
const _hoisted_471 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Bảng điểm học bạ", -1))
const _hoisted_472 = {
  key: 2,
  class: "mb-2"
}
const _hoisted_473 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Bảng điểm học bạ", -1))
const _hoisted_474 = { class: "row p-0 mb-2" }
const _hoisted_475 = { class: "col-md-4 fv-row mb-2" }
const _hoisted_476 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Ưu tiên 1")
], -1))
const _hoisted_477 = { class: "col-md-5 fv-row mb-6" }
const _hoisted_478 = { class: "d-flex align-items-center fw-bold mb-2 justify-content-between w-100" }
const _hoisted_479 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Hình thức xét", -1))
const _hoisted_480 = {
  key: 0,
  class: "c-umt3rd ms-1"
}
const _hoisted_481 = {
  key: 0,
  class: "form-check form-check-custom form-check-sm"
}
const _hoisted_482 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fs-9 text-gray-600 cursor-pointer",
  for: "isUseEnglish1_9cr"
}, "Áp dụng quy đổi Tiếng Anh", -1))
const _hoisted_483 = {
  key: 0,
  class: "col-md-3 fv-row mb-2 text-left ps-xl-45px mobile-box-highlight"
}
const _hoisted_484 = { class: "mb-2" }
const _hoisted_485 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_486 = { class: "d-flex align-items-center" }
const _hoisted_487 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Điểm trung bình cộng:", -1))
const _hoisted_488 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_489 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-success" }
const _hoisted_490 = { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-success rounded border-success border border-dashed p-2" }
const _hoisted_491 = { class: "fs-6" }
const _hoisted_492 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mb-1"
}
const _hoisted_493 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Điểm khuyến khích:", -1))
const _hoisted_494 = { class: "text-primary fs-6" }
const _hoisted_495 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_496 = { class: "d-flex align-items-center" }
const _hoisted_497 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fw-bold text-gray-700" }, "Điểm ưu tiên tạm tính:", -1))
const _hoisted_498 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_499 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_500 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-warning rounded border-warning border border-dashed p-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("Điểm ưu tiên đối với thí sinh đạt tổng điểm từ 22,5 trở lên được xác định theo công thức: "),
    /*#__PURE__*/_createElementVNode("strong", null, "[(30 - Tổng điểm)/7,5] x Điểm ưu tiên thông thường")
  ])
], -1))
const _hoisted_501 = { class: "fs-6" }
const _hoisted_502 = { class: "border-top border-gray-300 mt-1 pt-2 d-flex justify-content-between align-items-center" }
const _hoisted_503 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-800" }, "Tổng điểm xét tuyển:", -1))
const _hoisted_504 = { class: "text-danger fs-4" }
const _hoisted_505 = {
  key: 1,
  class: "col-md-9 col-12 fv-row"
}
const _hoisted_506 = { class: "p-3 bg-light-warning border border-dashed border-warning rounded" }
const _hoisted_507 = {
  key: 0,
  class: "alert alert-danger py-2 px-3 mb-3 fs-8"
}
const _hoisted_508 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Điểm đang lưu lệch tổ hợp — kiểm tra lại từng môn trước khi lưu:", -1))
const _hoisted_509 = {
  key: 1,
  class: "alert alert-warning py-2 px-3 mb-3 fs-8 d-flex align-items-center"
}
const _hoisted_510 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lightbulb-fill text-warning me-2" }, null, -1))
const _hoisted_511 = { class: "d-flex gap-2 flex- w-100" }
const _hoisted_512 = { class: "align-items-center fw-bold mb-2 min-w-100px pt-3" }
const _hoisted_513 = { class: "" }
const _hoisted_514 = { key: 3 }
const _hoisted_515 = { class: "col-md-4 fv-row mb-2" }
const _hoisted_516 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Ưu tiên 2")
], -1))
const _hoisted_517 = { class: "col-md-5 fv-row mb-6" }
const _hoisted_518 = { class: "d-flex align-items-center fw-bold mb-2 justify-content-between w-100" }
const _hoisted_519 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "" }, "Hình thức xét", -1))
const _hoisted_520 = {
  key: 0,
  class: "c-umt3rd ms-1"
}
const _hoisted_521 = {
  key: 0,
  class: "form-check form-check-custom form-check-sm"
}
const _hoisted_522 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fs-9 text-gray-600 cursor-pointer",
  for: "isUseEnglish2_9cr"
}, "Áp dụng quy đổi Tiếng Anh", -1))
const _hoisted_523 = {
  key: 0,
  class: "col-md-3 fv-row mb-2 text-left ps-xl-45px mobile-box-highlight"
}
const _hoisted_524 = { class: "mb-2" }
const _hoisted_525 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_526 = { class: "d-flex align-items-center" }
const _hoisted_527 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Điểm trung bình cộng:", -1))
const _hoisted_528 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_529 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-success" }
const _hoisted_530 = { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-success rounded border-success border border-dashed p-2" }
const _hoisted_531 = { class: "fs-6" }
const _hoisted_532 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mb-1"
}
const _hoisted_533 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Điểm khuyến khích:", -1))
const _hoisted_534 = { class: "text-primary fs-6" }
const _hoisted_535 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_536 = { class: "d-flex align-items-center" }
const _hoisted_537 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fw-bold text-gray-700" }, "Điểm ưu tiên tạm tính:", -1))
const _hoisted_538 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_539 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_540 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-warning rounded border-warning border border-dashed p-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("Điểm ưu tiên đối với thí sinh đạt tổng điểm từ 22,5 trở lên được xác định theo công thức: "),
    /*#__PURE__*/_createElementVNode("strong", null, "[(30 - Tổng điểm)/7,5] x Điểm ưu tiên thông thường")
  ])
], -1))
const _hoisted_541 = { class: "fs-6" }
const _hoisted_542 = { class: "border-top border-gray-300 mt-1 pt-2 d-flex justify-content-between align-items-center" }
const _hoisted_543 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-800" }, "Tổng điểm xét tuyển:", -1))
const _hoisted_544 = { class: "text-danger fs-4" }
const _hoisted_545 = {
  key: 1,
  class: "col-md-9 col-12 fv-row"
}
const _hoisted_546 = { class: "p-3 bg-light-warning border border-dashed border-warning rounded" }
const _hoisted_547 = {
  key: 0,
  class: "alert alert-danger py-2 px-3 mb-3 fs-8"
}
const _hoisted_548 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Điểm đang lưu lệch tổ hợp — kiểm tra lại từng môn trước khi lưu:", -1))
const _hoisted_549 = {
  key: 1,
  class: "alert alert-warning py-2 px-3 mb-3 fs-8 d-flex align-items-center"
}
const _hoisted_550 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lightbulb-fill text-warning me-2" }, null, -1))
const _hoisted_551 = { class: "d-flex gap-2 flex-center w-100" }
const _hoisted_552 = { class: "align-items-center fw-bold mb-2 min-w-100px" }
const _hoisted_553 = { class: "" }
const _hoisted_554 = { key: 4 }
const _hoisted_555 = { class: "col-md-4 fv-row mb-2" }
const _hoisted_556 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Ưu tiên 3")
], -1))
const _hoisted_557 = { class: "col-md-5 fv-row mb-6" }
const _hoisted_558 = { class: "d-flex align-items-center fw-bold mb-2 justify-content-between w-100" }
const _hoisted_559 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "" }, "Hình thức xét", -1))
const _hoisted_560 = {
  key: 0,
  class: "c-umt3rd ms-1"
}
const _hoisted_561 = {
  key: 0,
  class: "form-check form-check-custom form-check-sm"
}
const _hoisted_562 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fs-9 text-gray-600 cursor-pointer",
  for: "isUseEnglish3_9cr"
}, "Áp dụng quy đổi Tiếng Anh", -1))
const _hoisted_563 = {
  key: 0,
  class: "col-md-3 fv-row mb-2 text-left ps-xl-45px mobile-box-highlight"
}
const _hoisted_564 = { class: "mb-2" }
const _hoisted_565 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_566 = { class: "d-flex align-items-center" }
const _hoisted_567 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Điểm trung bình cộng:", -1))
const _hoisted_568 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_569 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-success" }
const _hoisted_570 = { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-success rounded border-success border border-dashed p-2" }
const _hoisted_571 = { class: "fs-6" }
const _hoisted_572 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mb-1"
}
const _hoisted_573 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Điểm khuyến khích:", -1))
const _hoisted_574 = { class: "text-primary fs-6" }
const _hoisted_575 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_576 = { class: "d-flex align-items-center" }
const _hoisted_577 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fw-bold text-gray-700" }, "Điểm ưu tiên tạm tính:", -1))
const _hoisted_578 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_579 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_580 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-warning rounded border-warning border border-dashed p-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("Điểm ưu tiên đối với thí sinh đạt tổng điểm từ 22,5 trở lên được xác định theo công thức: "),
    /*#__PURE__*/_createElementVNode("strong", null, "[(30 - Tổng điểm)/7,5] x Điểm ưu tiên thông thường")
  ])
], -1))
const _hoisted_581 = { class: "fs-6" }
const _hoisted_582 = { class: "border-top border-gray-300 mt-1 pt-2 d-flex justify-content-between align-items-center" }
const _hoisted_583 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-800" }, "Tổng điểm xét tuyển:", -1))
const _hoisted_584 = { class: "text-danger fs-4" }
const _hoisted_585 = {
  key: 1,
  class: "col-md-9 col-12 fv-row"
}
const _hoisted_586 = { class: "p-3 bg-light-warning border border-dashed border-warning rounded" }
const _hoisted_587 = {
  key: 0,
  class: "alert alert-danger py-2 px-3 mb-3 fs-8"
}
const _hoisted_588 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Điểm đang lưu lệch tổ hợp — kiểm tra lại từng môn trước khi lưu:", -1))
const _hoisted_589 = {
  key: 1,
  class: "alert alert-warning py-2 px-3 mb-3 fs-8 d-flex align-items-center"
}
const _hoisted_590 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lightbulb-fill text-warning me-2" }, null, -1))
const _hoisted_591 = { class: "d-flex gap-2 flex-center w-100" }
const _hoisted_592 = { class: "align-items-center fw-bold mb-2 min-w-100px" }
const _hoisted_593 = { class: "" }
const _hoisted_594 = {
  key: 2,
  class: "col-12"
}
const _hoisted_595 = { class: "row p-0 mb-2" }
const _hoisted_596 = { class: "col-md-4 fv-row mb-4" }
const _hoisted_597 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_598 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Ưu tiên 1", -1))
const _hoisted_599 = { class: "col-md-5 fv-row mb-4" }
const _hoisted_600 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_601 = { class: "form-label required d-flex align-items-center justify-content-between w-100" }
const _hoisted_602 = {
  key: 0,
  class: "c-umt3rd ms-1"
}
const _hoisted_603 = {
  key: 0,
  class: "form-check form-check-custom form-check-sm"
}
const _hoisted_604 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fs-9 text-gray-600 cursor-pointer",
  for: "isUseEnglish1_hb"
}, "Áp dụng quy đổi Tiếng Anh", -1))
const _hoisted_605 = {
  key: 0,
  class: "col-md-3 fv-row mb-2 text-left"
}
const _hoisted_606 = { class: "mb-1" }
const _hoisted_607 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_608 = { class: "d-flex align-items-center" }
const _hoisted_609 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Điểm trung bình cộng:", -1))
const _hoisted_610 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_611 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-success" }
const _hoisted_612 = { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-success rounded border-success border border-dashed p-2" }
const _hoisted_613 = { class: "fs-6" }
const _hoisted_614 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mb-1"
}
const _hoisted_615 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Điểm khuyến khích:", -1))
const _hoisted_616 = { class: "text-primary fs-6" }
const _hoisted_617 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_618 = { class: "d-flex align-items-center" }
const _hoisted_619 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fw-bold text-gray-700" }, "Điểm ưu tiên tạm tính:", -1))
const _hoisted_620 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_621 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_622 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-warning rounded border-warning border border-dashed p-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("Điểm ưu tiên đối với thí sinh đạt tổng điểm từ 22,5 trở lên được xác định theo công thức: "),
    /*#__PURE__*/_createElementVNode("strong", null, "[(30 - Tổng điểm)/7,5] x Điểm ưu tiên thông thường")
  ])
], -1))
const _hoisted_623 = { class: "fs-6" }
const _hoisted_624 = { class: "border-top border-gray-300 mt-1 pt-2 d-flex justify-content-between align-items-center" }
const _hoisted_625 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-800" }, "Tổng điểm xét tuyển:", -1))
const _hoisted_626 = { class: "text-danger fs-4" }
const _hoisted_627 = { class: "row p-0 mb-2" }
const _hoisted_628 = { class: "col-md-4 fv-row mb-4" }
const _hoisted_629 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_630 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Ưu tiên 2", -1))
const _hoisted_631 = { class: "col-md-5 fv-row mb-4" }
const _hoisted_632 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_633 = { class: "form-label d-flex align-items-center justify-content-between w-100" }
const _hoisted_634 = {
  key: 0,
  class: "c-umt3rd ms-1"
}
const _hoisted_635 = {
  key: 0,
  class: "form-check form-check-custom form-check-sm"
}
const _hoisted_636 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fs-9 text-gray-600 cursor-pointer",
  for: "isUseEnglish2_hb"
}, "Áp dụng quy đổi Tiếng Anh", -1))
const _hoisted_637 = {
  key: 0,
  class: "col-md-3 fv-row mb-2 text-left"
}
const _hoisted_638 = { class: "mb-1" }
const _hoisted_639 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_640 = { class: "d-flex align-items-center" }
const _hoisted_641 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Điểm trung bình cộng:", -1))
const _hoisted_642 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_643 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-success" }
const _hoisted_644 = { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-success rounded border-success border border-dashed p-2" }
const _hoisted_645 = { class: "fs-6" }
const _hoisted_646 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mb-1"
}
const _hoisted_647 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Điểm khuyến khích:", -1))
const _hoisted_648 = { class: "text-primary fs-6" }
const _hoisted_649 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_650 = { class: "d-flex align-items-center" }
const _hoisted_651 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fw-bold text-gray-700" }, "Điểm ưu tiên tạm tính:", -1))
const _hoisted_652 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_653 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_654 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-warning rounded border-warning border border-dashed p-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("Điểm ưu tiên đối với thí sinh đạt tổng điểm từ 22,5 trở lên được xác định theo công thức: "),
    /*#__PURE__*/_createElementVNode("strong", null, "[(30 - Tổng điểm)/7,5] x Điểm ưu tiên thông thường")
  ])
], -1))
const _hoisted_655 = { class: "fs-6" }
const _hoisted_656 = { class: "border-top border-gray-300 mt-1 pt-2 d-flex justify-content-between align-items-center" }
const _hoisted_657 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-800" }, "Tổng điểm xét tuyển:", -1))
const _hoisted_658 = { class: "text-danger fs-4" }
const _hoisted_659 = { class: "row p-0 mb-2" }
const _hoisted_660 = { class: "col-md-4 fv-row mb-4" }
const _hoisted_661 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_662 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Ưu tiên 3", -1))
const _hoisted_663 = { class: "col-md-5 fv-row mb-4" }
const _hoisted_664 = { class: "fv-row w-100 flex-md-root" }
const _hoisted_665 = { class: "form-label d-flex align-items-center justify-content-between w-100" }
const _hoisted_666 = {
  key: 0,
  class: "c-umt3rd ms-1"
}
const _hoisted_667 = {
  key: 0,
  class: "form-check form-check-custom form-check-sm"
}
const _hoisted_668 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fs-9 text-gray-600 cursor-pointer",
  for: "isUseEnglish3_hb"
}, "Áp dụng quy đổi Tiếng Anh", -1))
const _hoisted_669 = {
  key: 0,
  class: "col-md-3 fv-row mb-2 text-left"
}
const _hoisted_670 = { class: "mb-1" }
const _hoisted_671 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_672 = { class: "d-flex align-items-center" }
const _hoisted_673 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Điểm trung bình cộng:", -1))
const _hoisted_674 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_675 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-success" }
const _hoisted_676 = { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-success rounded border-success border border-dashed p-2" }
const _hoisted_677 = { class: "fs-6" }
const _hoisted_678 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mb-1"
}
const _hoisted_679 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold w-xl-140px" }, "Điểm khuyến khích:", -1))
const _hoisted_680 = { class: "text-primary fs-6" }
const _hoisted_681 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_682 = { class: "d-flex align-items-center" }
const _hoisted_683 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fw-bold text-gray-700" }, "Điểm ưu tiên tạm tính:", -1))
const _hoisted_684 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_685 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_686 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-warning rounded border-warning border border-dashed p-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("Điểm ưu tiên đối với thí sinh đạt tổng điểm từ 22,5 trở lên được xác định theo công thức: "),
    /*#__PURE__*/_createElementVNode("strong", null, "[(30 - Tổng điểm)/7,5] x Điểm ưu tiên thông thường")
  ])
], -1))
const _hoisted_687 = { class: "fs-6" }
const _hoisted_688 = { class: "border-top border-gray-300 mt-1 pt-2 d-flex justify-content-between align-items-center" }
const _hoisted_689 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-800" }, "Tổng điểm xét tuyển:", -1))
const _hoisted_690 = { class: "text-danger fs-4" }
const _hoisted_691 = {
  key: 11,
  class: "method-score-block"
}
const _hoisted_692 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-md-row gap-5 pt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-3 flex-row-fluid" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "d-flex align-items-center fw-bolder umt-section-hdr text-uppercase fs-6 py-2 px-3 rounded bg-light border-start border-4 border-primary mb-3" }, [
      /*#__PURE__*/_createElementVNode("span", {
        class: "badge badge-circle hdr-num-badge me-2 fs-8",
        style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
      }, "2"),
      /*#__PURE__*/_createTextVNode("Kết quả thi năng lực Quốc Gia")
    ])
  ])
], -1))
const _hoisted_693 = { class: "d-flex flex-column flex-md-row gap-5 col-12" }
const _hoisted_694 = { class: "col-md-7 mb-2" }
const _hoisted_695 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-1" }, "Tổng số điểm (Thang điểm 1200)", -1))
const _hoisted_696 = { class: "d-flex gap-5 align-items-center" }
const _hoisted_697 = {
  key: 0,
  class: "fs-6 fw-bold mb-1"
}
const _hoisted_698 = { class: "text-danger" }
const _hoisted_699 = {
  key: 0,
  class: "col-md-5 mb-2"
}
const _hoisted_700 = { class: "p-4 rounded border border-info border-dashed bg-light-info min-h-100px d-flex flex-column justify-content-center" }
const _hoisted_701 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_702 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-7" }, "Điểm quy đổi (thang 30):", -1))
const _hoisted_703 = { class: "fs-6" }
const _hoisted_704 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_705 = { class: "d-flex align-items-center" }
const _hoisted_706 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fw-bold text-gray-700 fs-7" }, "Điểm ưu tiên tạm tính:", -1))
const _hoisted_707 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_708 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_709 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-tooltip text-tooltip-custom fs-7 text-start mw-250px notice d-flex bg-light-warning rounded border-warning border border-dashed p-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("Điểm ưu tiên đối với thí sinh đạt tổng điểm từ 22,5 trở lên được xác định theo công thức: "),
    /*#__PURE__*/_createElementVNode("strong", null, "[(30 - Tổng điểm)/7,5] x Điểm ưu tiên thông thường")
  ])
], -1))
const _hoisted_710 = { class: "fs-6" }
const _hoisted_711 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_712 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-7" }, "Điểm khuyến khích:", -1))
const _hoisted_713 = { class: "text-primary fs-6" }
const _hoisted_714 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-2" }, null, -1))
const _hoisted_715 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_716 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 fs-6" }, "Tổng điểm xét tuyển:", -1))
const _hoisted_717 = { class: "text-danger fs-3" }
const _hoisted_718 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-md-row gap-5 pt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-3 flex-row-fluid" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "d-flex align-items-center fw-bolder umt-section-hdr text-uppercase fs-6 py-2 px-3 rounded bg-light border-start border-4 border-primary mb-3" }, [
      /*#__PURE__*/_createElementVNode("span", {
        class: "badge badge-circle hdr-num-badge me-2 fs-8",
        style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
      }, "3"),
      /*#__PURE__*/_createTextVNode("Ngành đăng ký xét tuyển")
    ]),
    /*#__PURE__*/_createElementVNode("i", null, "Ứng viên lựa chọn tối đa 3 ngành để đăng ký xét tuyển với độ ưu tiên từ cao xuống thấp.")
  ])
], -1))
const _hoisted_719 = { class: "d-flex flex-column flex-md-row gap-5" }
const _hoisted_720 = { class: "mb-3 flex-row-fluid" }
const _hoisted_721 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-1" }, "Ưu tiên 1", -1))
const _hoisted_722 = { class: "mb-3 fv-row flex-row-fluid" }
const _hoisted_723 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-1" }, "Ưu tiên 2", -1))
const _hoisted_724 = { class: "mb-3 fv-row flex-row-fluid" }
const _hoisted_725 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-1" }, "Ưu tiên 3", -1))
const _hoisted_726 = {
  key: 12,
  class: "method-score-block"
}
const _hoisted_727 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-md-row gap-5 pt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-3 flex-row-fluid" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "d-flex align-items-center fw-bolder umt-section-hdr text-uppercase fs-6 py-2 px-3 rounded bg-light border-start border-4 border-primary mb-3" }, [
      /*#__PURE__*/_createElementVNode("span", {
        class: "badge badge-circle hdr-num-badge me-2 fs-8",
        style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
      }, "2"),
      /*#__PURE__*/_createTextVNode("Điều kiện")
    ])
  ])
], -1))
const _hoisted_728 = {
  class: "border p-5",
  style: {"box-shadow":"1px 1px 6px #c8c8c8"}
}
const _hoisted_729 = { class: "item-condition" }
const _hoisted_730 = { class: "d-flex flex-stack cursor-pointer mb-2" }
const _hoisted_731 = { class: "d-flex align-items-start me-2" }
const _hoisted_732 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "d-flex flex-column",
  for: "isEnglishCertificate"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, [
    /*#__PURE__*/_createTextVNode("Chứng chỉ Tiếng Anh quốc tế ( "),
    /*#__PURE__*/_createElementVNode("i", { class: "c-umt3rd" }, "IELTS từ 5,0 hoặc TOEFL iBT từ 61 hoặc TOEIC từ 600, Chứng chỉ SAT (800/1600)."),
    /*#__PURE__*/_createTextVNode(" )")
  ])
], -1))
const _hoisted_733 = { class: "col-md-3 fv-row d-flex align-items-center mb-2 col-4" }
const _hoisted_734 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold mb-2 w-70px" }, [
  /*#__PURE__*/_createElementVNode("i", null, [
    /*#__PURE__*/_createElementVNode("strong", { class: "text-en-title" }, "IELTS")
  ])
], -1))
const _hoisted_735 = { class: "el-input w-md-75" }
const _hoisted_736 = { class: "col-md-4 fv-row d-flex align-items-center mb-2 col-4" }
const _hoisted_737 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold mb-2 w-150px" }, [
  /*#__PURE__*/_createElementVNode("i", null, [
    /*#__PURE__*/_createElementVNode("strong", { class: "text-en-title" }, "TOEFL iBT")
  ])
], -1))
const _hoisted_738 = { class: "el-input w-md-75" }
const _hoisted_739 = { class: "col-md-3 fv-row d-flex align-items-center mb-2 col-4" }
const _hoisted_740 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold mb-2 w-70px" }, [
  /*#__PURE__*/_createElementVNode("i", null, [
    /*#__PURE__*/_createElementVNode("strong", { class: "text-en-title" }, "TOEIC")
  ])
], -1))
const _hoisted_741 = { class: "el-input w-md-75" }
const _hoisted_742 = { class: "col-md-3 fv-row d-flex align-items-center mb-2 col-4" }
const _hoisted_743 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold mb-2 w-70px" }, [
  /*#__PURE__*/_createElementVNode("i", null, [
    /*#__PURE__*/_createElementVNode("strong", { class: "text-en-title" }, "SAT")
  ])
], -1))
const _hoisted_744 = { class: "el-input w-md-75" }
const _hoisted_745 = { class: "item-condition" }
const _hoisted_746 = { class: "d-flex flex-stack cursor-pointer mb-2" }
const _hoisted_747 = { class: "d-flex align-items-start me-2" }
const _hoisted_748 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "d-flex flex-column ms-2",
  for: "isCollegeOrInterDegree"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, " Có bằng Cao đẳng/ trung cấp (hoặc tương đương theo quy định của Bộ GD&ĐT) của cùng ngành hoặc ngành gần với ngành đăng ký xét tuyển. ")
], -1))
const _hoisted_749 = { class: "item-condition" }
const _hoisted_750 = { class: "d-flex flex-stack cursor-pointer mb-2" }
const _hoisted_751 = { class: "d-flex align-items-start me-2" }
const _hoisted_752 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "d-flex flex-column ms-2",
  for: "isInternationalCertificate"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, " Có chứng chỉ quốc tế hoặc văn bằng quốc tế liên quan đến lĩnh vực, ngành đăng ký xét tuyển của các đơn vị như Bộ khoa học và Công nghệ, Microsoft, Cisco, ARENA, APTECH. ")
], -1))
const _hoisted_753 = { class: "item-condition" }
const _hoisted_754 = { class: "d-flex flex-stack cursor-pointer mb-2" }
const _hoisted_755 = { class: "d-flex align-items-start me-2" }
const _hoisted_756 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "d-flex flex-column ms-2",
  for: "isAthleteCertOrPreMaster"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, " Có chứng nhận Vận động viên (VĐV) cấp I quốc gia hoặc đẳng cấp dự bị kiện tướng quốc gia, quốc tế; hoặc đạt huy chương tại Đại hội TDTT toàn quốc, Hội khỏe Phù đổng khu vực/toàn quốc, các giải thể thao học sinh toàn quốc, các giải trẻ quốc gia và quốc tế; Huấn luyện viên đội tuyển quốc gia, đội tuyển trẻ quốc gia được Tổng cục TDTT xác nhận đã hoàn thành nhiệm vụ các giải thi đấu trong và ngoài nước. ")
], -1))
const _hoisted_757 = { class: "item-condition" }
const _hoisted_758 = { class: "d-flex flex-stack cursor-pointer mb-2" }
const _hoisted_759 = { class: "d-flex align-items-start me-2" }
const _hoisted_760 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "d-flex flex-column ms-2",
  for: "isPrize"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, " Đạt giải Khuyến khích trở lên trong các cuộc thi Học sinh giỏi cấp tỉnh/TP, Khoa học Kỹ thuật cấp tỉnh/TP, Olympic truyền thống 30-4. ")
], -1))
const _hoisted_761 = { class: "item-condition" }
const _hoisted_762 = { class: "d-flex flex-stack cursor-pointer mb-2" }
const _hoisted_763 = { class: "d-flex align-items-start me-2" }
const _hoisted_764 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "d-flex flex-column ms-2",
  for: "isGoodStanding"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, " Học lực 3 năm THPT (lớp 10, lớp 11, lớp 12) được xếp loại Giỏi ")
], -1))
const _hoisted_765 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-md-row gap-5 pt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-3 flex-row-fluid" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "d-flex align-items-center fw-bolder umt-section-hdr text-uppercase fs-6 py-2 px-3 rounded bg-light border-start border-4 border-primary mb-3" }, [
      /*#__PURE__*/_createElementVNode("span", {
        class: "badge badge-circle hdr-num-badge me-2 fs-8",
        style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
      }, "3"),
      /*#__PURE__*/_createTextVNode("Ngành đăng ký xét tuyển")
    ]),
    /*#__PURE__*/_createElementVNode("i", null, "Thí sinh chọn tối thiểu 1 ngành xét tuyển")
  ])
], -1))
const _hoisted_766 = { class: "d-flex flex-column flex-md-row gap-5" }
const _hoisted_767 = { class: "mb-3 flex-row-fluid" }
const _hoisted_768 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-1" }, "Ưu tiên 1", -1))
const _hoisted_769 = { class: "mb-3 fv-row flex-row-fluid" }
const _hoisted_770 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-1" }, "Ưu tiên 2", -1))
const _hoisted_771 = { class: "mb-3 fv-row flex-row-fluid" }
const _hoisted_772 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-1" }, "Ưu tiên 3", -1))
const _hoisted_773 = {
  key: 13,
  class: "method-score-block"
}
const _hoisted_774 = { class: "row pt-3" }
const _hoisted_775 = { class: "col-12 mb-5" }
const _hoisted_776 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "d-flex align-items-center fw-bolder umt-section-hdr text-uppercase fs-6 py-2 px-3 rounded bg-light border-start border-4 border-primary mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge me-2 fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "2"),
  /*#__PURE__*/_createTextVNode("Kết quả xét tuyển theo phương thức riêng (2026)")
], -1))
const _hoisted_777 = { class: "card shadow-none border-dashed p-4" }
const _hoisted_778 = { class: "row g-3 align-items-end" }
const _hoisted_779 = { class: "col-md-4" }
const _hoisted_780 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-7 fw-bold required" }, "Tiêu chí xét tuyển", -1))
const _hoisted_781 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_782 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-7 fw-bold required" }, "Điểm SAT", -1))
const _hoisted_783 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_784 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-7 fw-bold required" }, "Điểm ACT", -1))
const _hoisted_785 = {
  key: 2,
  class: "col-md-4"
}
const _hoisted_786 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-7 fw-bold required" }, "Ngày cấp/Ngày thi", -1))
const _hoisted_787 = {
  key: 0,
  class: "col-12 mb-5"
}
const _hoisted_788 = { class: "mb-4" }
const _hoisted_789 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold mb-2 required" }, "Tiêu chí xét tuyển (TC01)", -1))
const _hoisted_790 = { class: "d-flex gap-10" }
const _hoisted_791 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_792 = {
  key: 0,
  class: "card shadow-none border-dashed p-4 bg-light-warning"
}
const _hoisted_793 = { class: "mb-3 text-primary" }
const _hoisted_794 = { class: "row g-2" }
const _hoisted_795 = { class: "fs-8 fw-bold mb-1" }
const _hoisted_796 = {
  key: 1,
  class: "col-12 mt-3"
}
const _hoisted_797 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "d-flex align-items-center fw-bolder umt-section-hdr text-uppercase fs-6 py-2 px-3 rounded bg-light border-start border-4 border-primary mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge me-2 fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "3"),
  /*#__PURE__*/_createTextVNode("Ngành đăng ký xét tuyển")
], -1))
const _hoisted_798 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Ứng viên lựa chọn tối đa 3 ngành để đăng ký xét tuyển với độ ưu tiên từ cao xuống thấp.", -1))
const _hoisted_799 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning me-2" }, null, -1))
const _hoisted_800 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "Còn thiếu điểm:", -1))
const _hoisted_801 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Ưu tiên 1", -1))
const _hoisted_802 = {
  key: 0,
  class: "col-md-5 mb-4 pe-2"
}
const _hoisted_803 = { class: "form-label required d-flex align-items-center justify-content-between w-100" }
const _hoisted_804 = {
  key: 0,
  class: "c-umt3rd ms-1"
}
const _hoisted_805 = {
  key: 0,
  class: "form-check form-check-custom form-check-sm"
}
const _hoisted_806 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fs-9 text-gray-600 cursor-pointer",
  for: "isUseEnglish1_tc01"
}, "Áp dụng quy đổi Tiếng Anh", -1))
const _hoisted_807 = { class: "d-flex flex-column pt-1 border border-dashed border-gray-300 p-3 rounded bg-white w-100" }
const _hoisted_808 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_809 = { class: "d-flex align-items-center" }
const _hoisted_810 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm trung bình cộng:", -1))
const _hoisted_811 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_812 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-success" }
const _hoisted_813 = { class: "text-tooltip text-tooltip-custom fs-8 text-start mw-250px notice d-flex bg-light-success rounded border-success border border-dashed p-2" }
const _hoisted_814 = { class: "text-dark fs-8" }
const _hoisted_815 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_816 = { class: "d-flex align-items-center" }
const _hoisted_817 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm ưu tiên tạm tính:", -1))
const _hoisted_818 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_819 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_820 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-tooltip text-tooltip-custom fs-8 text-start mw-250px notice d-flex bg-light-warning rounded border-warning border border-dashed p-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("Điểm ưu tiên đối với thí sinh đạt tổng điểm từ 22,5 trở lên được xác định theo công thức: "),
    /*#__PURE__*/_createElementVNode("strong", null, "[(30 - Tổng điểm)/7,5] x Điểm ưu tiên thông thường")
  ])
], -1))
const _hoisted_821 = { class: "text-dark fs-8" }
const _hoisted_822 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_823 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm khuyến khích:", -1))
const _hoisted_824 = { class: "text-primary fs-8" }
const _hoisted_825 = { class: "border-top border-gray-300 mt-1 pt-2 d-flex justify-content-between align-items-center" }
const _hoisted_826 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-800" }, "Tổng điểm xét tuyển:", -1))
const _hoisted_827 = { class: "text-danger fs-4" }
const _hoisted_828 = {
  key: 0,
  class: "fs-9 text-muted mt-1 italic"
}
const _hoisted_829 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_830 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm quy đổi (30):", -1))
const _hoisted_831 = { class: "text-dark fs-8" }
const _hoisted_832 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_833 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm ưu tiên tạm tính:", -1))
const _hoisted_834 = { class: "text-dark fs-8" }
const _hoisted_835 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_836 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm khuyến khích:", -1))
const _hoisted_837 = { class: "text-primary fs-8" }
const _hoisted_838 = { class: "border-top border-gray-300 mt-1 pt-2 d-flex justify-content-between align-items-center" }
const _hoisted_839 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-800" }, "Tổng điểm xét tuyển:", -1))
const _hoisted_840 = { class: "text-danger fs-4" }
const _hoisted_841 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Ưu tiên 2", -1))
const _hoisted_842 = {
  key: 0,
  class: "col-md-5 mb-4 pe-2"
}
const _hoisted_843 = { class: "form-label d-flex align-items-center justify-content-between w-100" }
const _hoisted_844 = {
  key: 0,
  class: "c-umt3rd ms-1"
}
const _hoisted_845 = {
  key: 0,
  class: "form-check form-check-custom form-check-sm"
}
const _hoisted_846 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fs-9 text-gray-600 cursor-pointer",
  for: "isUseEnglish2_tc01"
}, "Áp dụng quy đổi Tiếng Anh", -1))
const _hoisted_847 = { class: "d-flex flex-column pt-1 border border-dashed border-gray-300 p-3 rounded bg-white w-100" }
const _hoisted_848 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_849 = { class: "d-flex align-items-center" }
const _hoisted_850 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm trung bình cộng:", -1))
const _hoisted_851 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_852 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-success" }
const _hoisted_853 = { class: "text-tooltip text-tooltip-custom fs-8 text-start mw-250px notice d-flex bg-light-success rounded border-success border border-dashed p-2" }
const _hoisted_854 = { class: "text-dark fs-8" }
const _hoisted_855 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_856 = { class: "d-flex align-items-center" }
const _hoisted_857 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm ưu tiên tạm tính:", -1))
const _hoisted_858 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_859 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_860 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-tooltip text-tooltip-custom fs-8 text-start mw-250px notice d-flex bg-light-warning rounded border-warning border border-dashed p-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("Điểm ưu tiên đối với thí sinh đạt tổng điểm từ 22,5 trở lên được xác định theo công thức: "),
    /*#__PURE__*/_createElementVNode("strong", null, "[(30 - Tổng điểm)/7,5] x Điểm ưu tiên thông thường")
  ])
], -1))
const _hoisted_861 = { class: "text-dark fs-8" }
const _hoisted_862 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_863 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm khuyến khích:", -1))
const _hoisted_864 = { class: "text-primary fs-8" }
const _hoisted_865 = { class: "border-top border-gray-300 mt-1 pt-2 d-flex justify-content-between align-items-center" }
const _hoisted_866 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-800" }, "Tổng điểm xét tuyển:", -1))
const _hoisted_867 = { class: "text-danger fs-4" }
const _hoisted_868 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_869 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm quy đổi (30):", -1))
const _hoisted_870 = { class: "text-dark fs-8" }
const _hoisted_871 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_872 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm ưu tiên tạm tính:", -1))
const _hoisted_873 = { class: "text-dark fs-8" }
const _hoisted_874 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_875 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm khuyến khích:", -1))
const _hoisted_876 = { class: "text-primary fs-8" }
const _hoisted_877 = { class: "border-top border-gray-300 mt-1 pt-2 d-flex justify-content-between align-items-center" }
const _hoisted_878 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-800" }, "Tổng điểm xét tuyển:", -1))
const _hoisted_879 = { class: "text-danger fs-4" }
const _hoisted_880 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Ưu tiên 3", -1))
const _hoisted_881 = {
  key: 0,
  class: "col-md-5 mb-4 pe-2"
}
const _hoisted_882 = { class: "form-label d-flex align-items-center justify-content-between w-100" }
const _hoisted_883 = {
  key: 0,
  class: "c-umt3rd ms-1"
}
const _hoisted_884 = {
  key: 0,
  class: "form-check form-check-custom form-check-sm"
}
const _hoisted_885 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fs-9 text-gray-600 cursor-pointer",
  for: "isUseEnglish3_tc01"
}, "Áp dụng quy đổi Tiếng Anh", -1))
const _hoisted_886 = { class: "d-flex flex-column pt-1 border border-dashed border-gray-300 p-3 rounded bg-white w-100" }
const _hoisted_887 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_888 = { class: "d-flex align-items-center" }
const _hoisted_889 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm trung bình cộng:", -1))
const _hoisted_890 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_891 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-success" }
const _hoisted_892 = { class: "text-tooltip text-tooltip-custom fs-8 text-start mw-250px notice d-flex bg-light-success rounded border-success border border-dashed p-2" }
const _hoisted_893 = { class: "text-dark fs-8" }
const _hoisted_894 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_895 = { class: "d-flex align-items-center" }
const _hoisted_896 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm ưu tiên tạm tính:", -1))
const _hoisted_897 = {
  key: 0,
  class: "position-relative wrap-tooltip-custom tooltip-custom ms-1"
}
const _hoisted_898 = { class: "cursor-pointer svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_899 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-tooltip text-tooltip-custom fs-8 text-start mw-250px notice d-flex bg-light-warning rounded border-warning border border-dashed p-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("Điểm ưu tiên đối với thí sinh đạt tổng điểm từ 22,5 trở lên được xác định theo công thức: "),
    /*#__PURE__*/_createElementVNode("strong", null, "[(30 - Tổng điểm)/7,5] x Điểm ưu tiên thông thường")
  ])
], -1))
const _hoisted_900 = { class: "text-dark fs-8" }
const _hoisted_901 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_902 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm khuyến khích:", -1))
const _hoisted_903 = { class: "text-primary fs-8" }
const _hoisted_904 = { class: "border-top border-gray-300 mt-1 pt-2 d-flex justify-content-between align-items-center" }
const _hoisted_905 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-800" }, "Tổng điểm xét tuyển:", -1))
const _hoisted_906 = { class: "text-danger fs-4" }
const _hoisted_907 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_908 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm quy đổi (30):", -1))
const _hoisted_909 = { class: "text-dark fs-8" }
const _hoisted_910 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_911 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm ưu tiên tạm tính:", -1))
const _hoisted_912 = { class: "text-dark fs-8" }
const _hoisted_913 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_914 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-700 fs-8" }, "Điểm khuyến khích:", -1))
const _hoisted_915 = { class: "text-primary fs-8" }
const _hoisted_916 = { class: "border-top border-gray-300 mt-1 pt-2 d-flex justify-content-between align-items-center" }
const _hoisted_917 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-800" }, "Tổng điểm xét tuyển:", -1))
const _hoisted_918 = { class: "text-danger fs-4" }
const _hoisted_919 = { class: "col" }
const _hoisted_920 = { class: "row p-0 mb-2" }
const _hoisted_921 = { class: "col-md-4 fv-row mb-4" }
const _hoisted_922 = { class: "w-100 fv-row flex-row-fluid" }
const _hoisted_923 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "required me-3" }, "Xác thực hồ sơ", -1))
const _hoisted_924 = {
  key: 0,
  class: "col-md-5 fv-row flex-row-fluid"
}
const _hoisted_925 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "required me-3" }, "Lý do", -1))
const _hoisted_926 = {
  id: "kt_customer_view_files_profile",
  role: "tabpanel"
}
const _hoisted_927 = {
  key: 0,
  class: "d-flex align-items-center umt-section-hdr fs-6 text-uppercase mb-4 mt-6 py-2 px-3 rounded bg-light border-start border-4 border-primary"
}
const _hoisted_928 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}, "4", -1))
const _hoisted_929 = {
  key: 1,
  class: "d-flex align-items-center fw-bolder umt-section-hdr text-uppercase fs-5 py-2 px-3 rounded bg-light border-start border-4 border-primary mb-4 mt-6"
}
const _hoisted_930 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}, "4", -1))
const _hoisted_931 = { class: "wrap-view-files" }
const _hoisted_932 = { class: "row" }
const _hoisted_933 = { class: "col-12 mb-4 mt-xl-0" }
const _hoisted_934 = { class: "notice d-flex align-items-start bg-light-primary border border-primary border-dashed rounded p-4" }
const _hoisted_935 = { class: "svg-icon svg-icon-2x svg-icon-primary me-3 mt-1" }
const _hoisted_936 = { class: "flex-grow-1" }
const _hoisted_937 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-gray-900 fs-6 mb-2" }, "Các tệp cần đính kèm", -1))
const _hoisted_938 = { class: "svg-icon svg-icon-4 svg-icon-success me-2 mt-1" }
const _hoisted_939 = { class: "text-gray-700 fs-7" }
const _hoisted_940 = { class: "svg-icon svg-icon-4 svg-icon-success me-2 mt-1" }
const _hoisted_941 = { class: "text-gray-700 fs-7" }
const _hoisted_942 = {
  key: 2,
  class: "text-muted fs-7"
}
const _hoisted_943 = { class: "d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3 mt-2" }
const _hoisted_944 = { class: "mb-0" }
const _hoisted_945 = { class: "text-muted fs-8 fw-normal" }
const _hoisted_946 = {
  key: 0,
  class: "text-muted fst-italic fs-8"
}
const _hoisted_947 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Lưu hồ sơ", -1))
const _hoisted_948 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_949 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_950 = { class: "text-gray-700 fw-semibold fs-7 mb-2" }
const _hoisted_951 = { class: "badge badge-light-primary ms-1" }
const _hoisted_952 = { class: "d-flex gap-5 flex-wrap" }
const _hoisted_953 = {
  key: 0,
  class: "wrap-img-file"
}
const _hoisted_954 = { class: "symbol mb-5" }
const _hoisted_955 = ["src"]
const _hoisted_956 = { class: "progress" }
const _hoisted_957 = ["id"]
const _hoisted_958 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "progress-text" }, null, -1))
const _hoisted_959 = [
  _hoisted_958
]
const _hoisted_960 = { key: 1 }
const _hoisted_961 = { class: "wrap-img-file position-relative" }
const _hoisted_962 = ["src", "alt", "title"]
const _hoisted_963 = {
  key: 1,
  class: "symbol mb-5"
}
const _hoisted_964 = ["src"]
const _hoisted_965 = {
  key: 2,
  class: "abs-close-img flex-column"
}
const _hoisted_966 = ["onClick"]
const _hoisted_967 = { class: "svg-icon svg-icon-danger svg-icon-2x" }
const _hoisted_968 = { class: "abs-view-img flex-column" }
const _hoisted_969 = ["href"]
const _hoisted_970 = {
  class: "svg-icon svg-icon-2",
  style: {"opacity":".8"}
}
const _hoisted_971 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_972 = { class: "text-gray-700 fw-semibold fs-7 mb-2" }
const _hoisted_973 = { class: "badge badge-light-warning ms-1" }
const _hoisted_974 = { class: "d-flex gap-5 flex-wrap" }
const _hoisted_975 = {
  key: 0,
  class: "wrap-img-file"
}
const _hoisted_976 = { class: "symbol mb-5" }
const _hoisted_977 = ["src"]
const _hoisted_978 = { class: "progress" }
const _hoisted_979 = ["id"]
const _hoisted_980 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "progress-text" }, null, -1))
const _hoisted_981 = [
  _hoisted_980
]
const _hoisted_982 = { key: 1 }
const _hoisted_983 = { class: "wrap-img-file position-relative" }
const _hoisted_984 = ["src", "alt", "title"]
const _hoisted_985 = {
  key: 1,
  class: "symbol mb-5"
}
const _hoisted_986 = ["src"]
const _hoisted_987 = {
  key: 2,
  class: "abs-close-img flex-column"
}
const _hoisted_988 = ["onClick"]
const _hoisted_989 = { class: "svg-icon svg-icon-danger svg-icon-2x" }
const _hoisted_990 = { class: "abs-view-img flex-column" }
const _hoisted_991 = ["href"]
const _hoisted_992 = {
  class: "svg-icon svg-icon-2",
  style: {"opacity":".8"}
}
const _hoisted_993 = {
  key: 3,
  class: "text-muted fs-8 py-4 text-center border border-gray-300 border-dashed rounded"
}
const _hoisted_994 = { key: 0 }
const _hoisted_995 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "\"Cập nhật tệp đính kèm\"", -1))
const _hoisted_996 = { class: "adm-file-popup" }
const _hoisted_997 = { class: "adm-file-popup__card" }
const _hoisted_998 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_999 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold m-0" }, "Cập nhật tệp đính kèm", -1))
const _hoisted_1000 = { class: "svg-icon svg-icon-2" }
const _hoisted_1001 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold text-gray-700 fs-7 mb-2" }, "1. Chọn loại tệp cần tải lên", -1))
const _hoisted_1002 = { class: "d-flex flex-wrap gap-2 mb-5" }
const _hoisted_1003 = ["onClick"]
const _hoisted_1004 = { class: "fw-semibold text-gray-700 fs-7 mb-2" }
const _hoisted_1005 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_1006 = {
  key: 1,
  class: "text-danger fs-8 fw-normal"
}
const _hoisted_1007 = { class: "form-group" }
const _hoisted_1008 = {
  id: "id_dropzone",
  class: "dropzone"
}
const _hoisted_1009 = {
  key: 0,
  type: "text",
  class: "hide",
  name: "isarticulationprogram",
  value: true
}
const _hoisted_1010 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_1011 = { class: "fw-semibold text-gray-700 fs-7 mb-2" }
const _hoisted_1012 = { class: "badge badge-light-primary" }
const _hoisted_1013 = { class: "d-flex gap-5 flex-wrap" }
const _hoisted_1014 = {
  key: 0,
  class: "wrap-img-file"
}
const _hoisted_1015 = { class: "symbol mb-5" }
const _hoisted_1016 = ["src"]
const _hoisted_1017 = { class: "progress" }
const _hoisted_1018 = ["id"]
const _hoisted_1019 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "progress-text" }, null, -1))
const _hoisted_1020 = [
  _hoisted_1019
]
const _hoisted_1021 = { key: 1 }
const _hoisted_1022 = { class: "wrap-img-file position-relative" }
const _hoisted_1023 = ["src", "alt", "title"]
const _hoisted_1024 = {
  key: 1,
  class: "symbol mb-5"
}
const _hoisted_1025 = ["src"]
const _hoisted_1026 = {
  key: 2,
  class: "abs-close-img flex-column"
}
const _hoisted_1027 = ["onClick"]
const _hoisted_1028 = { class: "svg-icon svg-icon-danger svg-icon-2x" }
const _hoisted_1029 = { class: "abs-view-img flex-column" }
const _hoisted_1030 = ["href"]
const _hoisted_1031 = {
  class: "svg-icon svg-icon-2",
  style: {"opacity":".8"}
}
const _hoisted_1032 = {
  key: 0,
  class: "text-muted fs-8 py-3"
}
const _hoisted_1033 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-warning me-1" }, "Lưu ngay"),
  /*#__PURE__*/_createTextVNode("Thêm/xóa tệp được lưu NGAY (≤6MB/tệp) — không cần bấm nút lưu.")
], -1))
const _hoisted_1034 = { class: "text-end mt-3 pt-3 border-top" }
const _hoisted_1035 = { class: "d-flex flex-column align-items-center gap-3 py-4 mt-4 border-top" }
const _hoisted_1036 = { class: "fs-8 text-center mw-700px text-gray-800 bg-light-primary rounded px-4 py-3" }
const _hoisted_1037 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-primary" }, "Lưu hồ sơ", -1))
const _hoisted_1038 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "liên thông", -1))
const _hoisted_1039 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "tệp minh chứng", -1))
const _hoisted_1040 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Hoàn tất", -1))
const _hoisted_1041 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Hủy bỏ", -1))
const _hoisted_1042 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-primary" }, "Lưu và tiếp tục…", -1))
const _hoisted_1043 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "điểm & ngành", -1))
const _hoisted_1044 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Hoàn tất", -1))
const _hoisted_1045 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Hủy bỏ", -1))
const _hoisted_1046 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-primary" }, "Lưu hồ sơ", -1))
const _hoisted_1047 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-primary" }, "Lưu và tiếp tục…", -1))
const _hoisted_1048 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "điểm & ngành", -1))
const _hoisted_1049 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Hoàn tất", -1))
const _hoisted_1050 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Hủy bỏ", -1))
const _hoisted_1051 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Hồ sơ đã thẩm định", -1))
const _hoisted_1052 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-primary" }, "Đóng", -1))
const _hoisted_1053 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-primary" }, "Lưu hồ sơ", -1))
const _hoisted_1054 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "điểm & ngành", -1))
const _hoisted_1055 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Hủy bỏ", -1))
const _hoisted_1056 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-primary" }, "Tệp đính kèm", -1))
const _hoisted_1057 = { class: "d-flex align-items-center justify-content-center gap-3" }
const _hoisted_1058 = ["data-kt-indicator", "disabled"]
const _hoisted_1059 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_1060 = { key: 0 }
const _hoisted_1061 = { key: 1 }
const _hoisted_1062 = { class: "svg-icon svg-icon-3 ms-2 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_el_form, {
    onSubmit: _cache[239] || (_cache[239] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
    model: _ctx.formData,
    rules: _ctx.rules,
    ref: "formRef"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.fromProfile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, "MHS: " + _toDisplayString(_ctx.dataAdm?.adRegister?.profileCode), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (!_ctx.fromProfile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Thông tin xét tuyển"))
                : _createCommentVNode("", true),
              (!_ctx.fromProfile && _ctx.dataAdm?.adRegister?.lastModifiedBy)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createTextVNode(" Chỉnh sửa lần cuối bởi "),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.dataAdm.adRegister.lastModifiedBy.split('_')[0]), 1),
                    _createTextVNode(" · " + _toDisplayString(_ctx.dataAdm.adRegister.updatedAt), 1)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.fromProfile && _ctx.existingOnlineDraft)
                ? (_openBlock(), _createBlock(_component_el_alert, {
                    key: 2,
                    type: "warning",
                    closable: false,
                    class: "umt-warn-banner mb-4"
                  }, {
                    title: _withCtx(() => [
                      _hoisted_10,
                      _createTextVNode(" Ứng viên đã có hồ sơ nguồn "),
                      _hoisted_11,
                      _createTextVNode(" (mã "),
                      _createElementVNode("b", null, _toDisplayString(_ctx.existingOnlineDraft.profileCode || '—'), 1),
                      _createTextVNode(") đang ở trạng thái Mới — chỉ có thể tạo thêm hồ sơ nguồn "),
                      _hoisted_12,
                      _createTextVNode(" (Trực tiếp / Bưu điện / Email). ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.fromProfile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode(_component_el_form_item, { prop: "source" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            "popper-class": "umt-form-dd",
                            class: "form-select-solid w-100",
                            placeholder: "Nguồn",
                            disabled: !_ctx.isPermission,
                            modelValue: _ctx.formData.source,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.source) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrResource, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value,
                                  disabled: item.value === 'online' && !!_ctx.existingOnlineDraft
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.label), 1),
                                    (item.value === 'online' && _ctx.existingOnlineDraft)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, " — đã có"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value", "disabled"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode(_component_el_form_item, { prop: "createdAt" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            class: "w-100",
                            modelValue: _ctx.formData.createdAt,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.createdAt) = $event)),
                            name: "createdAt",
                            placeholder: "Ngày/tháng/năm",
                            disabled: !_ctx.isPermission,
                            format: "DD/MM/YYYY"
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createVNode(_component_el_form_item, { prop: "phase" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            "popper-class": "umt-form-dd",
                            class: "form-select-solid w-100",
                            placeholder: "Đợt xét tuyển",
                            disabled: !_ctx.isPermission,
                            modelValue: _ctx.formData.phase,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.phase) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrPhase, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    (_ctx.formData.source !='online')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("label", _hoisted_22, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input me-2",
                              type: "checkbox",
                              value: true,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.additionalPhase) = $event)),
                              disabled: !_ctx.isPermission,
                              id: "checkbox4"
                            }, null, 8, _hoisted_23), [
                              [_vModelCheckbox, _ctx.additionalPhase]
                            ]),
                            _hoisted_24
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.arpros && _ctx.isEdit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    false
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_26,
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _hoisted_30,
                                _createVNode(_component_el_form_item, { prop: "fullName" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      type: "text",
                                      disabled: !_ctx.isEdit,
                                      class: "mb-2",
                                      name: "workplace",
                                      modelValue: _ctx.formData_arp.student.fullName,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData_arp.student.fullName) = $event)),
                                      placeholder: "Nhập đầy đủ họ tên"
                                    }, null, 8, ["disabled", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _hoisted_33,
                                _createVNode(_component_el_form_item, { prop: "dateOfBirth" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_date_picker, {
                                      class: "w-100",
                                      modelValue: _ctx.formData_arp.student.dateOfBirth,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData_arp.student.dateOfBirth) = $event)),
                                      name: "birthday",
                                      placeholder: "Ngày/tháng/năm",
                                      format: "DD/MM/YYYY",
                                      "default-value": new Date('01/01/2005'),
                                      disabled: !_ctx.isEdit
                                    }, null, 8, ["modelValue", "default-value", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                _hoisted_36,
                                _createVNode(_component_el_select, {
                                  "popper-class": "umt-form-dd",
                                  class: "form-select-solid w-100",
                                  placeholder: "Giới tính",
                                  modelValue: _ctx.formData_arp.student.gender,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData_arp.student.gender) = $event)),
                                  filterable: true,
                                  disabled: !_ctx.isEdit
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: "Nam",
                                      value: true
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Nam")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "Nữ",
                                      value: false
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Nữ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _hoisted_38,
                              _createVNode(_component_el_form_item, {
                                prop: "idCard",
                                style: {"line-height":"18px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    disabled: !_ctx.isEdit,
                                    class: "",
                                    name: "idCard",
                                    modelValue: _ctx.formData_arp.student.idCard,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData_arp.student.idCard) = $event)),
                                    placeholder: "CMND/CCCD"
                                  }, null, 8, ["disabled", "modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                              _hoisted_40,
                              _createVNode(_component_el_date_picker, {
                                class: "w-100",
                                modelValue: _ctx.formData_arp.student.dateOfIssue,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData_arp.student.dateOfIssue) = $event)),
                                disabled: !_ctx.isEdit,
                                name: "dateOfIssue",
                                placeholder: "Ngày/tháng/năm",
                                format: "DD/MM/YYYY"
                              }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _hoisted_42,
                              _createVNode(_component_el_select, {
                                "popper-class": "umt-form-dd",
                                class: "form-select-solid w-100",
                                placeholder: "Nơi cấp",
                                modelValue: _ctx.formData_arp.student.issuePlace,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData_arp.student.issuePlace) = $event)),
                                filterable: true,
                                disabled: !_ctx.isEdit
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "Bộ công an",
                                    value: "Bộ công an"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Bộ công an")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Cục trưởng Cục cảnh sát quản lý hành chính về trật tự xã hội",
                                    value: "Cục trưởng Cục cảnh sát quản lý hành chính về trật tự xã hội"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Cục trưởng Cục cảnh sát quản lý hành chính về trật tự xã hội")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled"])
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _hoisted_44,
                              _createVNode(_component_el_select, {
                                "popper-class": "umt-form-dd",
                                class: "form-select-solid w-100",
                                placeholder: "Nơi sinh",
                                modelValue: _ctx.formData_arp.student.birthplace,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData_arp.student.birthplace) = $event)),
                                filterable: true,
                                disabled: !_ctx.isEdit
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataProvince, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.name,
                                      value: item.code
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled"])
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _hoisted_46,
                              _createVNode(_component_el_form_item, { prop: "email" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    disabled: !_ctx.isEdit,
                                    class: "",
                                    name: "email",
                                    modelValue: _ctx.formData_arp.student.email,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData_arp.student.email) = $event)),
                                    placeholder: "email"
                                  }, null, 8, ["disabled", "modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              _hoisted_48,
                              _createVNode(_component_el_form_item, { prop: "phone" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    disabled: !_ctx.isEdit,
                                    class: "",
                                    name: "phone",
                                    modelValue: _ctx.formData_arp.student.phone,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData_arp.student.phone) = $event)),
                                    placeholder: "Sđt"
                                  }, null, 8, ["disabled", "modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _hoisted_49,
                            _hoisted_50,
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                _hoisted_53,
                                _createVNode(_component_el_form_item, { prop: "prProvinceId" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      "popper-class": "umt-form-dd",
                                      class: "form-select-solid w-100",
                                      placeholder: "Tỉnh/Thành phố",
                                      modelValue: _ctx.formData_arp.student.prProvinceId,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData_arp.student.prProvinceId) = $event)),
                                      onChange: _ctx.residenceProvinceChange,
                                      filterable: true,
                                      disabled: !_ctx.isEdit
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataProvince, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.id,
                                            label: item.name,
                                            value: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onChange", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              false
                                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                    _hoisted_55,
                                    _createVNode(_component_el_form_item, { prop: "prDistrictId" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          "popper-class": "umt-form-dd",
                                          class: "form-select-solid w-100",
                                          placeholder: "Quận/Huyện",
                                          modelValue: _ctx.formData_arp.student.prDistrictId,
                                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData_arp.student.prDistrictId) = $event)),
                                          onChange: _ctx.residenceDistrictChange,
                                          filterable: true,
                                          disabled: !_ctx.isEdit
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataResidenceDistrict, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.id,
                                                label: item.name,
                                                value: item.id
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "onChange", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_56, [
                                _hoisted_57,
                                _createVNode(_component_el_form_item, { prop: "prDistrictId" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      "popper-class": "umt-form-dd",
                                      class: "form-select-solid w-100",
                                      placeholder: "Phường/Xã",
                                      modelValue: _ctx.formData_arp.student.prWardId,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData_arp.student.prWardId) = $event)),
                                      filterable: true,
                                      disabled: !_ctx.isEdit
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataResidenceWard, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.id,
                                            label: item.name,
                                            value: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_58, [
                              _hoisted_59,
                              _createVNode(_component_el_form_item, { prop: "prAddress" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    disabled: !_ctx.isEdit,
                                    class: "mb-2",
                                    name: "prAddress",
                                    modelValue: _ctx.formData_arp.student.prAddress,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData_arp.student.prAddress) = $event)),
                                    placeholder: "Hộ khẩu thường trú (sau sáp nhập)"
                                  }, null, 8, ["disabled", "modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("h5", _hoisted_62, [
                                  _createTextVNode("Địa chỉ liên lạc "),
                                  _createElementVNode("span", _hoisted_63, [
                                    _createElementVNode("input", {
                                      type: "checkbox",
                                      disabled: !_ctx.isEdit,
                                      id: "checkAddress",
                                      onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.autofillAddress && _ctx.autofillAddress(...args)))
                                    }, null, 40, _hoisted_64),
                                    _hoisted_65
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("div", _hoisted_67, [
                                _hoisted_68,
                                _createVNode(_component_el_select, {
                                  "popper-class": "umt-form-dd",
                                  class: "form-select-solid w-100",
                                  placeholder: "Tỉnh/Thành phố",
                                  modelValue: _ctx.formData_arp.student.contactProvinceId,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData_arp.student.contactProvinceId) = $event)),
                                  onChange: _ctx.provinceChange,
                                  filterable: true,
                                  disabled: !_ctx.isEdit
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataProvince, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.name,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "onChange", "disabled"])
                              ]),
                              false
                                ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                    _hoisted_70,
                                    _createVNode(_component_el_form_item, { prop: "contactDistrictId" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          "popper-class": "umt-form-dd",
                                          class: "form-select-solid w-100",
                                          placeholder: "Quận/Huyện",
                                          onChange: _ctx.districtChange,
                                          modelValue: _ctx.formData_arp.student.contactDistrictId,
                                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData_arp.student.contactDistrictId) = $event)),
                                          filterable: true,
                                          disabled: !_ctx.isEdit
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataDistrict, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.id,
                                                label: item.name,
                                                value: item.id
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["onChange", "modelValue", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_71, [
                                _hoisted_72,
                                _createVNode(_component_el_form_item, { prop: "contactWardId" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      "popper-class": "umt-form-dd",
                                      class: "form-select-solid w-100",
                                      placeholder: "Phường/Xã",
                                      modelValue: _ctx.formData_arp.student.contactWardId,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData_arp.student.contactWardId) = $event)),
                                      filterable: true,
                                      disabled: !_ctx.isEdit
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataWard, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.id,
                                            label: item.name,
                                            value: item.id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_73, [
                              _hoisted_74,
                              _createVNode(_component_el_form_item, { prop: "contactAddress" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    disabled: !_ctx.isEdit,
                                    class: "mb-2",
                                    name: "contactAddress",
                                    modelValue: _ctx.formData_arp.student.contactAddress,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData_arp.student.contactAddress) = $event)),
                                    placeholder: "Địa chỉ liên lạc (sau sáp nhập)"
                                  }, null, 8, ["disabled", "modelValue"])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.isEdit && _ctx.missingArpFields.length)
                      ? (_openBlock(), _createBlock(_component_el_alert, {
                          key: 1,
                          type: "warning",
                          closable: false,
                          class: "umt-warn-banner mb-4"
                        }, {
                          title: _withCtx(() => [
                            _hoisted_75,
                            _hoisted_76,
                            _createTextVNode(" " + _toDisplayString(_ctx.missingArpFields.join(', ')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_77,
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("div", _hoisted_80, [
                          _hoisted_81,
                          _createVNode(_component_el_form_item, { prop: "registeredmajor" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                "popper-class": "umt-form-dd",
                                class: "form-select-solid w-100",
                                placeholder: "Chọn ngành đăng ký",
                                modelValue: _ctx.formData_arp.registeredmajor,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData_arp.registeredmajor) = $event)),
                                disabled: !_ctx.isEdit,
                                filterable: true
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajorsArticulation, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _hoisted_82,
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          _hoisted_86,
                          _createVNode(_component_el_form_item, { prop: "workplace" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                type: "text",
                                disabled: !_ctx.isEdit,
                                class: "mb-2",
                                name: "workplace",
                                modelValue: _ctx.formData_arp.workplace,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData_arp.workplace) = $event)),
                                placeholder: "Nơi làm việc"
                              }, null, 8, ["disabled", "modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _hoisted_89,
                          _createVNode(_component_el_form_item, { prop: "job" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                type: "text",
                                disabled: !_ctx.isEdit,
                                class: "mb-2",
                                name: "job",
                                modelValue: _ctx.formData_arp.job,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData_arp.job) = $event)),
                                placeholder: "Nghề nghiệp"
                              }, null, 8, ["disabled", "modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, [
                          _hoisted_92,
                          _createVNode(_component_el_form_item, { prop: "jobtitle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                type: "text",
                                disabled: !_ctx.isEdit,
                                class: "mb-2",
                                name: "jobtitle",
                                modelValue: _ctx.formData_arp.jobtitle,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData_arp.jobtitle) = $event)),
                                placeholder: "Chức vụ"
                              }, null, 8, ["disabled", "modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _hoisted_93,
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("div", _hoisted_95, [
                        _createElementVNode("div", _hoisted_96, [
                          _hoisted_97,
                          _createVNode(_component_el_form_item, { prop: "graduationschool" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                type: "text",
                                disabled: !_ctx.isEdit,
                                class: "mb-2",
                                name: "graduationschool",
                                modelValue: _ctx.formData_arp.college.graduationschool,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData_arp.college.graduationschool) = $event)),
                                placeholder: "Trường tốt nghiệp"
                              }, null, 8, ["disabled", "modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("div", _hoisted_99, [
                          _createElementVNode("div", _hoisted_100, [
                            _hoisted_101,
                            _createVNode(_component_el_form_item, { prop: "trainingform" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  "popper-class": "umt-form-dd",
                                  class: "form-select-solid w-100",
                                  placeholder: "Hình thức đào tạo",
                                  modelValue: _ctx.formData_arp.college.trainingform,
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData_arp.college.trainingform) = $event)),
                                  disabled: !_ctx.isEdit,
                                  filterable: true
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                              {label: 'Chính quy',value: 'chinhquy'},
                              {label: 'Nghề', value: 'nghe'}
                              ], (item) => {
                                      return _createVNode(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"])
                                    }), 64))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("div", _hoisted_103, [
                            _hoisted_104,
                            _createVNode(_component_el_form_item, { prop: "graduationsys" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  "popper-class": "umt-form-dd",
                                  class: "form-select-solid w-100",
                                  placeholder: "Hệ",
                                  modelValue: _ctx.formData_arp.college.graduationsys,
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData_arp.college.graduationsys) = $event)),
                                  disabled: !_ctx.isEdit,
                                  filterable: true
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                              {label: 'Trung cấp',value: 'trungcap'},
                              {label: 'Cao đẳng', value: 'caodang'}
                              ], (item) => {
                                      return _createVNode(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"])
                                    }), 64))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_105, [
                          _createElementVNode("div", _hoisted_106, [
                            _hoisted_107,
                            _createVNode(_component_el_form_item, { prop: "gpafor" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio_group, {
                                  disabled: !_ctx.isEdit,
                                  modelValue: _ctx.formData_arp.college.gpafor,
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData_arp.college.gpafor) = $event)),
                                  class: "ml-4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_radio, {
                                      name: "formOfMethod",
                                      label: "gpa4",
                                      size: "large"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_108
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_radio, {
                                      name: "formOfMethod",
                                      label: "gpa10",
                                      size: "large"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_109
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["disabled", "modelValue"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_110, [
                          _createElementVNode("div", _hoisted_111, [
                            _createElementVNode("label", _hoisted_112, [
                              _createTextVNode("Điểm"),
                              (_ctx.formData_arp.college.gpafor === 'gpa4')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_113, "(thang 0 – 4)"))
                                : (_ctx.formData_arp.college.gpafor === 'gpa10')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_114, "(thang 0 – 10)"))
                                  : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_el_form_item, { prop: "gpa" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  disabled: !_ctx.isEdit,
                                  class: "mb-2",
                                  name: "gpa",
                                  modelValue: _ctx.formData_arp.college.gpa,
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formData_arp.college.gpa) = $event)),
                                  placeholder: _ctx.formData_arp.college.gpafor === 'gpa4' ? 'Điểm (0 - 4)' : _ctx.formData_arp.college.gpafor === 'gpa10' ? 'Điểm (0 - 10)' : 'Điểm'
                                }, null, 8, ["disabled", "modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_115, [
                          _createElementVNode("div", _hoisted_116, [
                            _hoisted_117,
                            _createVNode(_component_el_form_item, { prop: "graduationnumber" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  disabled: !_ctx.isEdit,
                                  class: "mb-2",
                                  name: "graduationnumber",
                                  modelValue: _ctx.formData_arp.college.graduationnumber,
                                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formData_arp.college.graduationnumber) = $event)),
                                  placeholder: "Số hiệu bằng tốt nghiệp"
                                }, null, 8, ["disabled", "modelValue"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_118, [
                          _createElementVNode("div", _hoisted_119, [
                            _hoisted_120,
                            _createVNode(_component_el_form_item, { prop: "graduationentrynumber" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  disabled: !_ctx.isEdit,
                                  class: "mb-2",
                                  name: "graduationentrynumber",
                                  modelValue: _ctx.formData_arp.college.graduationentrynumber,
                                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.formData_arp.college.graduationentrynumber) = $event)),
                                  placeholder: "Số vào sổ TN"
                                }, null, 8, ["disabled", "modelValue"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_121, [
                          _createElementVNode("div", _hoisted_122, [
                            _hoisted_123,
                            _createVNode(_component_el_form_item, { prop: "graduationyear" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  disabled: !_ctx.isEdit,
                                  class: "mb-2",
                                  name: "graduationyear",
                                  modelValue: _ctx.formData_arp.college.graduationyear,
                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formData_arp.college.graduationyear) = $event)),
                                  placeholder: "Năm tốt nghiệp"
                                }, null, 8, ["disabled", "modelValue"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_124, [
                          _createElementVNode("div", _hoisted_125, [
                            _hoisted_126,
                            _createVNode(_component_el_form_item, { prop: "graduationday" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_date_picker, {
                                  class: "w-100",
                                  modelValue: _ctx.formData_arp.college.graduationday,
                                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formData_arp.college.graduationday) = $event)),
                                  name: "createdAt",
                                  placeholder: "Ngày/tháng/năm",
                                  disabled: !_ctx.isEdit,
                                  format: "DD/MM/YYYY"
                                }, null, 8, ["modelValue", "disabled"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_127, [
                          _createElementVNode("label", _hoisted_128, [
                            _createVNode(_component_el_checkbox, {
                              disabled: !_ctx.isEdit,
                              class: "",
                              modelValue: _ctx.formData_arp.isintermediate,
                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.formData_arp.isintermediate) = $event)),
                              onChange: _cache[36] || (_cache[36] = e=>{
                            
                          }),
                              value: true
                            }, null, 8, ["disabled", "modelValue"]),
                            _createTextVNode(" Thí sinh tốt nghiệp cao đẳng theo hình thức liên thông từ Trung cấp ")
                          ])
                        ])
                      ]),
                      (_ctx.formData_arp.isintermediate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                            _hoisted_130,
                            _createElementVNode("div", _hoisted_131, [
                              _createElementVNode("div", _hoisted_132, [
                                _createElementVNode("div", _hoisted_133, [
                                  _hoisted_134,
                                  _createVNode(_component_el_form_item, { prop: "inter_graduationschool" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        type: "text",
                                        disabled: !_ctx.isEdit,
                                        class: "mb-2",
                                        name: "inter_graduationschool",
                                        modelValue: _ctx.formData_arp.intermediate.graduationschool,
                                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.formData_arp.intermediate.graduationschool) = $event)),
                                        placeholder: "Trường tốt nghiệp Trung cấp"
                                      }, null, 8, ["disabled", "modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_135, [
                                _createElementVNode("div", _hoisted_136, [
                                  _hoisted_137,
                                  _createVNode(_component_el_form_item, { prop: "inter_trainingform" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        "popper-class": "umt-form-dd",
                                        class: "form-select-solid w-100",
                                        placeholder: "Hình thức đào tạo",
                                        modelValue: _ctx.formData_arp.intermediate.trainingform,
                                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.formData_arp.intermediate.trainingform) = $event)),
                                        disabled: !_ctx.isEdit,
                                        filterable: true
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                              {label: 'Chính quy',value: 'chinhquy'},
                              {label: 'Nghề', value: 'nghe'}
                              ], (item) => {
                                            return _createVNode(_component_el_option, {
                                              key: item.value,
                                              label: item.label,
                                              value: item.value
                                            }, null, 8, ["label", "value"])
                                          }), 64))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_138, [
                                _createElementVNode("div", _hoisted_139, [
                                  _hoisted_140,
                                  _createVNode(_component_el_form_item, { prop: "inter_graduationsys" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        "popper-class": "umt-form-dd",
                                        class: "form-select-solid w-100",
                                        placeholder: "Hệ",
                                        modelValue: _ctx.formData_arp.intermediate.graduationsys,
                                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.formData_arp.intermediate.graduationsys) = $event)),
                                        disabled: !_ctx.isEdit,
                                        filterable: true
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                              {label: 'Trung cấp',value: 'trungcap'},
                              {label: 'Cao đẳng', value: 'caodang'}
                              ], (item) => {
                                            return _createVNode(_component_el_option, {
                                              key: item.value,
                                              label: item.label,
                                              value: item.value
                                            }, null, 8, ["label", "value"])
                                          }), 64))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_141, [
                                _createElementVNode("div", _hoisted_142, [
                                  _hoisted_143,
                                  _createVNode(_component_el_form_item, { prop: "inter_graduationnumber" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        type: "text",
                                        disabled: !_ctx.isEdit,
                                        class: "mb-2",
                                        name: "graduationnumber",
                                        modelValue: _ctx.formData_arp.intermediate.graduationnumber,
                                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.formData_arp.intermediate.graduationnumber) = $event)),
                                        placeholder: "Số hiệu bằng tốt nghiệp"
                                      }, null, 8, ["disabled", "modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_144, [
                                _createElementVNode("div", _hoisted_145, [
                                  _hoisted_146,
                                  _createVNode(_component_el_form_item, { prop: "inter_graduationentrynumber" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        type: "text",
                                        disabled: !_ctx.isEdit,
                                        class: "mb-2",
                                        name: "inter_graduationentrynumber",
                                        modelValue: _ctx.formData_arp.intermediate.graduationentrynumber,
                                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.formData_arp.intermediate.graduationentrynumber) = $event)),
                                        placeholder: "Số vào sổ TN"
                                      }, null, 8, ["disabled", "modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_147, [
                                _createElementVNode("div", _hoisted_148, [
                                  _hoisted_149,
                                  _createVNode(_component_el_form_item, { prop: "inter_graduationyear" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        type: "text",
                                        disabled: !_ctx.isEdit,
                                        class: "mb-2",
                                        name: "inter_graduationyear",
                                        modelValue: _ctx.formData_arp.intermediate.graduationyear,
                                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.formData_arp.intermediate.graduationyear) = $event)),
                                        placeholder: "Năm tốt nghiệp"
                                      }, null, 8, ["disabled", "modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_150, [
                                _createElementVNode("div", _hoisted_151, [
                                  _hoisted_152,
                                  _createVNode(_component_el_form_item, { prop: "inter_graduationday" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_date_picker, {
                                        class: "w-100",
                                        modelValue: _ctx.formData_arp.intermediate.graduationday,
                                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.formData_arp.intermediate.graduationday) = $event)),
                                        name: "createdAt",
                                        placeholder: "Ngày/tháng/năm",
                                        disabled: !_ctx.isEdit,
                                        format: "DD/MM/YYYY"
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_153, [
                    _hoisted_154,
                    _createElementVNode("div", _hoisted_155, [
                      _createElementVNode("div", _hoisted_156, [
                        _createVNode(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          class: "form-select-solid w-100",
                          placeholder: "Chọn phương thức xét tuyển",
                          modelValue: _ctx.formData.method,
                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.formData.method) = $event)),
                          onChange: _ctx.funcChangeMethod,
                          disabled: _ctx.isEdit,
                          filterable: true
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrAdmissionMethod, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange", "disabled"])
                      ])
                    ]),
                    (_ctx.formData.method == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                          _createVNode(_component_el_radio_group, {
                            onChange: _ctx.funcChangeFormofMethod,
                            modelValue: _ctx.formData.formOfMethod,
                            "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.formData.formOfMethod) = $event)),
                            class: "ml-4",
                            disabled: !_ctx.isPermission
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formOptions, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "mb-2"
                                }, [
                                  _createVNode(_component_el_radio, {
                                    name: "formOfMethod",
                                    label: item.value,
                                    size: "large"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        innerHTML: item.label
                                      }, null, 8, _hoisted_158)
                                    ]),
                                    _: 2
                                  }, 1032, ["label"])
                                ]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue", "disabled"])
                        ]))
                      : _createCommentVNode("", true)
                  ])),
              (!_ctx.arpros)
                ? (_openBlock(), _createElementBlock("div", _hoisted_159))
                : _createCommentVNode("", true),
              (!_ctx.arpros)
                ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                    _hoisted_161,
                    _createElementVNode("div", _hoisted_162, [
                      _createElementVNode("div", _hoisted_163, [
                        _createElementVNode("div", _hoisted_164, [
                          _createElementVNode("div", _hoisted_165, [
                            _createElementVNode("div", _hoisted_166, [
                              _createElementVNode("label", _hoisted_167, [
                                _createElementVNode("span", _hoisted_168, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.formData.hasEnglishCert) = $event)),
                                    onChange: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_ctx.handleHasEnglishCertChange && _ctx.handleHasEnglishCertChange(...args))),
                                    id: "hasEnglishCertAdmin"
                                  }, null, 544), [
                                    [_vModelCheckbox, _ctx.formData.hasEnglishCert]
                                  ])
                                ]),
                                _hoisted_169
                              ]),
                              (_ctx.formData.hasEnglishCert)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                                    _createElementVNode("div", _hoisted_171, [
                                      _hoisted_172,
                                      _createVNode(_component_el_select, {
                                        "popper-class": "umt-form-dd",
                                        modelValue: _ctx.formData.englishCertType,
                                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.formData.englishCertType) = $event)),
                                        placeholder: "Chọn chứng chỉ",
                                        class: "w-100",
                                        onChange: _ctx.handleEnglishCertTypeChange
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "IELTS",
                                            value: "IELTS"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "TOEIC",
                                            value: "TOEIC"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "TOEFL iBT",
                                            value: "TOEFL iBT"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "PTE",
                                            value: "PTE"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "onChange"])
                                    ]),
                                    _createElementVNode("div", _hoisted_173, [
                                      _hoisted_174,
                                      _createVNode(_component_el_date_picker, {
                                        modelValue: _ctx.formData.englishCertDate,
                                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.formData.englishCertDate) = $event)),
                                        type: "date",
                                        placeholder: "Ngày hết hạn",
                                        format: "DD/MM/YYYY",
                                        class: "w-100"
                                      }, null, 8, ["modelValue"]),
                                      _hoisted_175
                                    ]),
                                    (_ctx.formData.englishCertType === 'TOEIC')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createElementVNode("div", _hoisted_176, [
                                            _hoisted_177,
                                            _createVNode(_component_el_input, {
                                              type: "number",
                                              modelValue: _ctx.formData.toeicLRScore,
                                              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.formData.toeicLRScore) = $event)),
                                              onKeypress: _cache[51] || (_cache[51] = ($event: any) => (_ctx.isNumber($event))),
                                              placeholder: "Nhập điểm"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _createElementVNode("div", _hoisted_178, [
                                            _hoisted_179,
                                            _createVNode(_component_el_input, {
                                              type: "number",
                                              modelValue: _ctx.formData.toeicSWScore,
                                              "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.formData.toeicSWScore) = $event)),
                                              onKeypress: _cache[53] || (_cache[53] = ($event: any) => (_ctx.isNumber($event))),
                                              placeholder: "Nhập điểm"
                                            }, null, 8, ["modelValue"])
                                          ])
                                        ], 64))
                                      : (_ctx.formData.englishCertType)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                                            _createElementVNode("label", _hoisted_181, [
                                              _createTextVNode("Điểm số "),
                                              (_ctx.formData.englishCertType === 'TOEFL iBT')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_182, "(Thang điểm 1-6)"))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createVNode(_component_el_input, {
                                              type: "text",
                                              modelValue: _ctx.formData.englishCertScore,
                                              "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.formData.englishCertScore) = $event)),
                                              placeholder: "Nhập điểm hoặc cấp độ"
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_183, [
                            _createElementVNode("div", _hoisted_184, [
                              _createElementVNode("label", _hoisted_185, [
                                _createElementVNode("span", _hoisted_186, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.formData.hasIncentiveOther) = $event)),
                                    onChange: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.handleHasIncentiveOtherChange && _ctx.handleHasIncentiveOtherChange(...args)))
                                  }, null, 544), [
                                    [_vModelCheckbox, _ctx.formData.hasIncentiveOther]
                                  ])
                                ]),
                                _hoisted_187
                              ]),
                              (_ctx.formData.hasIncentiveOther)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_188, [
                                    _createElementVNode("div", _hoisted_189, [
                                      _hoisted_190,
                                      _createElementVNode("div", _hoisted_191, [
                                        _createElementVNode("div", _hoisted_192, [
                                          _hoisted_193,
                                          _createVNode(_component_el_input, {
                                            type: "number",
                                            modelValue: _ctx.formData.mosWordScore,
                                            "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.formData.mosWordScore) = $event)),
                                            placeholder: "700",
                                            onKeypress: _cache[58] || (_cache[58] = ($event: any) => (_ctx.isNumber($event)))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_194, [
                                          _hoisted_195,
                                          _createVNode(_component_el_input, {
                                            type: "number",
                                            modelValue: _ctx.formData.mosExcelScore,
                                            "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.formData.mosExcelScore) = $event)),
                                            placeholder: "700",
                                            onKeypress: _cache[60] || (_cache[60] = ($event: any) => (_ctx.isNumber($event)))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_196, [
                                          _hoisted_197,
                                          _createVNode(_component_el_input, {
                                            type: "number",
                                            modelValue: _ctx.formData.mosPPTScore,
                                            "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.formData.mosPPTScore) = $event)),
                                            placeholder: "700",
                                            onKeypress: _cache[62] || (_cache[62] = ($event: any) => (_ctx.isNumber($event)))
                                          }, null, 8, ["modelValue"])
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_198, [
                                      _hoisted_199,
                                      _createVNode(_component_el_select, {
                                        "popper-class": "umt-form-dd",
                                        modelValue: _ctx.formData.jlptLevel,
                                        "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.formData.jlptLevel) = $event)),
                                        placeholder: "Cấp độ",
                                        class: "w-100",
                                        clearable: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "N4",
                                            value: "N4"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "N3",
                                            value: "N3"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "N2",
                                            value: "N2"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_200, [
                                      _hoisted_201,
                                      _createVNode(_component_el_select, {
                                        "popper-class": "umt-form-dd",
                                        modelValue: _ctx.formData.hskLevel,
                                        "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.formData.hskLevel) = $event)),
                                        placeholder: "Cấp độ",
                                        class: "w-100",
                                        clearable: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "HSK 3",
                                            value: "HSK 3"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "HSK 4",
                                            value: "HSK 4"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "HSK 5",
                                            value: "HSK 5"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_202, [
                                      _hoisted_203,
                                      _createVNode(_component_el_select, {
                                        "popper-class": "umt-form-dd",
                                        modelValue: _ctx.formData.topikLevel,
                                        "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.formData.topikLevel) = $event)),
                                        placeholder: "Cấp độ",
                                        class: "w-100",
                                        clearable: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "B1",
                                            value: "B1"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "B2",
                                            value: "B2"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "C1",
                                            value: "C1"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_204, [
                                      _hoisted_205,
                                      _createVNode(_component_el_select, {
                                        "popper-class": "umt-form-dd",
                                        modelValue: _ctx.formData.delfTcfLevel,
                                        "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.formData.delfTcfLevel) = $event)),
                                        placeholder: "Cấp độ",
                                        class: "w-100",
                                        clearable: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "B1",
                                            value: "B1"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "B2",
                                            value: "B2"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "C1",
                                            value: "C1"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_206, [
                                      _hoisted_207,
                                      _createVNode(_component_el_select, {
                                        "popper-class": "umt-form-dd",
                                        modelValue: _ctx.formData.vstepLevel,
                                        "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.formData.vstepLevel) = $event)),
                                        placeholder: "Cấp độ",
                                        class: "w-100",
                                        clearable: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "Bậc 3",
                                            value: "Bậc 3"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "Bậc 4",
                                            value: "Bậc 4"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "Bậc 5(C1)",
                                            value: "Bậc 5(C1)"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_208, [
                                      _hoisted_209,
                                      _createVNode(_component_el_select, {
                                        "popper-class": "umt-form-dd",
                                        modelValue: _ctx.formData.aptisLevel,
                                        "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.formData.aptisLevel) = $event)),
                                        placeholder: "Cấp độ",
                                        class: "w-100",
                                        clearable: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "B1",
                                            value: "B1"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "B2",
                                            value: "B2"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "C1",
                                            value: "C1"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_210, [
                                      _createElementVNode("label", _hoisted_211, [
                                        _createElementVNode("span", _hoisted_212, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.formData.hasOtherCert) = $event))
                                          }, null, 512), [
                                            [_vModelCheckbox, _ctx.formData.hasOtherCert]
                                          ])
                                        ]),
                                        _hoisted_213
                                      ]),
                                      (_ctx.formData.hasOtherCert)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_214, [
                                            _createElementVNode("div", _hoisted_215, [
                                              _createVNode(_component_el_select, {
                                                "popper-class": "umt-form-dd",
                                                modelValue: _ctx.formData.otherIntCertType,
                                                "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.formData.otherIntCertType) = $event)),
                                                placeholder: "Tổ chức",
                                                class: "w-100",
                                                clearable: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_option, {
                                                    label: "Microsoft",
                                                    value: "Microsoft"
                                                  }),
                                                  _createVNode(_component_el_option, {
                                                    label: "Cisco",
                                                    value: "Cisco"
                                                  }),
                                                  _createVNode(_component_el_option, {
                                                    label: "ARENA",
                                                    value: "ARENA"
                                                  }),
                                                  _createVNode(_component_el_option, {
                                                    label: "APTECH",
                                                    value: "APTECH"
                                                  })
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue"])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_216, [
                          (_ctx.englishCertResult.valid || _ctx.certIncentiveResult.total > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_217, [
                                _createElementVNode("div", _hoisted_218, [
                                  _createElementVNode("div", _hoisted_219, [
                                    _createElementVNode("div", _hoisted_220, [
                                      _createElementVNode("div", _hoisted_221, [
                                        _hoisted_222,
                                        _createElementVNode("div", _hoisted_223, [
                                          (_ctx.englishCertResult.convertedScore > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
                                                _hoisted_225,
                                                _createElementVNode("div", _hoisted_226, _toDisplayString(_ctx.englishCertResult.convertedScore) + " / 10.0", 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.certIncentiveResult.total > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_227, [
                                                _hoisted_228,
                                                _createElementVNode("div", _hoisted_229, "+" + _toDisplayString(_ctx.certIncentiveResult.total), 1),
                                                _hoisted_230
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.formData.englishCertDate && !_ctx.englishCertResult.valid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_231, _hoisted_233))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_234
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_235, _hoisted_237))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_238,
              (_ctx.formData.method == 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_239, [
                    _createElementVNode("div", _hoisted_240, [
                      _createElementVNode("div", _hoisted_241, [
                        _createElementVNode("h5", _hoisted_242, [
                          _hoisted_243,
                          _createTextVNode("Điểm thi THPT " + _toDisplayString(new Date().getFullYear()) + ":", 1)
                        ]),
                        _hoisted_244
                      ])
                    ]),
                    (_ctx.gradScoreMismatch)
                      ? (_openBlock(), _createBlock(_component_el_alert, {
                          key: 0,
                          type: "warning",
                          closable: false,
                          class: "umt-warn-banner mb-4"
                        }, {
                          title: _withCtx(() => [
                            _hoisted_245,
                            _createTextVNode(" Điểm thi trong hồ sơ "),
                            _hoisted_246,
                            _createTextVNode(" hoặc "),
                            _hoisted_247,
                            _createTextVNode(" trong Bảng điểm thi TN THPT (mục 6 tab Thông tin học tập). "),
                            (_ctx.gradScoreDirty)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("Điểm sẽ được "),
                                  _hoisted_248,
                                  _createTextVNode(" vào bảng điểm khi "),
                                  _hoisted_249,
                                  _createTextVNode(".")
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.isPermission && !_ctx.isAppraised && !_ctx.gradScoreDirty)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("span", {
                                    class: "text-primary fw-bold cursor-pointer text-decoration-underline ms-1",
                                    onClick: _cache[71] || (_cache[71] = 
//@ts-ignore
(...args) => (_ctx.syncFromGradScore && _ctx.syncFromGradScore(...args)))
                                  }, "Đồng bộ theo bảng điểm"),
                                  _hoisted_250,
                                  _createElementVNode("span", {
                                    class: "text-primary fw-bold cursor-pointer text-decoration-underline",
                                    onClick: _cache[72] || (_cache[72] = 
//@ts-ignore
(...args) => (_ctx.writeFormScoresToGradScore && _ctx.writeFormScoresToGradScore(...args)))
                                  }, "Ghi điểm hồ sơ vào bảng điểm")
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : (!_ctx.studentGradScore)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_251, [
                            _createVNode(_component_el_alert, {
                              type: "error",
                              closable: false,
                              "show-icon": "",
                              class: "umt-hint-banner"
                            }, {
                              title: _withCtx(() => [
                                _createTextVNode(" Chưa có "),
                                _hoisted_252,
                                _createTextVNode(" (mục 6 tab Thông tin học tập) — nhập để hệ tự đổ điểm khi tạo hồ sơ PT1. "),
                                (_ctx.isPermission && !_ctx.isAppraised)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: "text-primary fw-bold cursor-pointer text-decoration-underline ms-1",
                                      onClick: _cache[73] || (_cache[73] = 
//@ts-ignore
(...args) => (_ctx.writeFormScoresToGradScore && _ctx.writeFormScoresToGradScore(...args)))
                                    }, "Ghi điểm trong hồ sơ vào bảng điểm"))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_253, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row flex-row-fluid", _ctx.formData.literatureTHPT != _ctx.objectScore.literatureTHPT && _ctx.formData.literatureTHPT && _ctx.objectScore.literatureTHPT?'err-point':''])
                      }, [
                        _hoisted_254,
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.literatureTHPT,
                              "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.formData.literatureTHPT) = $event)),
                              type: "text",
                              onKeypress: _cache[75] || (_cache[75] = ($event: any) => (_ctx.isNumber($event))),
                              disabled: !_ctx.isPermission,
                              onChange: _ctx.methosIndustryAutoChangeTHPT,
                              placeholder: "Điểm THPT"
                            }, null, 8, ["modelValue", "disabled", "onChange"])
                          ]),
                          _: 1
                        }),
                        (_ctx.objectScore.literatureTHPT)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_255, _toDisplayString(_ctx.objectScore.literatureTHPT), 1))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex-row-fluid", _ctx.formData.mathTHPT != _ctx.objectScore.mathTHPT && _ctx.formData.mathTHPT && _ctx.objectScore.mathTHPT?'err-point':''])
                      }, [
                        _hoisted_256,
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.mathTHPT,
                              "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.formData.mathTHPT) = $event)),
                              type: "text",
                              onKeypress: _cache[77] || (_cache[77] = ($event: any) => (_ctx.isNumber($event))),
                              disabled: !_ctx.isPermission,
                              onChange: _ctx.methosIndustryAutoChangeTHPT,
                              placeholder: "Điểm THPT"
                            }, null, 8, ["modelValue", "disabled", "onChange"])
                          ]),
                          _: 1
                        }),
                        (_ctx.objectScore.mathTHPT)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_257, _toDisplayString(_ctx.objectScore.mathTHPT), 1))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row flex-row-fluid", _ctx.formData.englishTHPT != _ctx.objectScore.englishTHPT && _ctx.formData.englishTHPT && _ctx.objectScore.englishTHPT?'err-point':''])
                      }, [
                        _hoisted_258,
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.englishTHPT,
                              "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.formData.englishTHPT) = $event)),
                              type: "text",
                              onKeypress: _cache[79] || (_cache[79] = ($event: any) => (_ctx.isNumber($event))),
                              disabled: !_ctx.isPermission,
                              onChange: _ctx.methosIndustryAutoChangeTHPT,
                              placeholder: "Điểm THPT"
                            }, null, 8, ["modelValue", "disabled", "onChange"])
                          ]),
                          _: 1
                        }),
                        (_ctx.objectScore.englishTHPT)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_259, _toDisplayString(_ctx.objectScore.englishTHPT), 1))
                          : _createCommentVNode("", true)
                      ], 2),
                      false
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["fv-row flex-row-fluid", _ctx.formData.frenchTHPT != _ctx.objectScore.frenchTHPT && _ctx.formData.frenchTHPT && _ctx.objectScore.frenchTHPT?'err-point':''])
                          }, [
                            _hoisted_260,
                            _createVNode(_component_el_form_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formData.frenchTHPT,
                                  "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.formData.frenchTHPT) = $event)),
                                  type: "text",
                                  onKeypress: _cache[81] || (_cache[81] = ($event: any) => (_ctx.isNumber($event))),
                                  disabled: !_ctx.isPermission,
                                  onChange: _ctx.methosIndustryAutoChangeTHPT,
                                  placeholder: "Điểm THPT"
                                }, null, 8, ["modelValue", "disabled", "onChange"])
                              ]),
                              _: 1
                            }),
                            (_ctx.objectScore.frenchTHPT)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_261, _toDisplayString(_ctx.objectScore.frenchTHPT), 1))
                              : _createCommentVNode("", true)
                          ], 2))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row flex-row-fluid", _ctx.formData.physicsTHPT != _ctx.objectScore.physicsTHPT && _ctx.formData.physicsTHPT && _ctx.objectScore.physicsTHPT?'err-point':''])
                      }, [
                        _hoisted_262,
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.physicsTHPT,
                              "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.formData.physicsTHPT) = $event)),
                              type: "text",
                              onKeypress: _cache[83] || (_cache[83] = ($event: any) => (_ctx.isNumber($event))),
                              disabled: !_ctx.isPermission,
                              onChange: _ctx.methosIndustryAutoChangeTHPT,
                              placeholder: "Điểm THPT"
                            }, null, 8, ["modelValue", "disabled", "onChange"])
                          ]),
                          _: 1
                        }),
                        (_ctx.objectScore.physicsTHPT)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_263, _toDisplayString(_ctx.objectScore.physicsTHPT), 1))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row flex-row-fluid", _ctx.formData.chemistryTHPT != _ctx.objectScore.chemistryTHPT && _ctx.formData.chemistryTHPT && _ctx.objectScore.chemistryTHPT?'err-point':''])
                      }, [
                        _hoisted_264,
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.chemistryTHPT,
                              "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.formData.chemistryTHPT) = $event)),
                              type: "text",
                              onKeypress: _cache[85] || (_cache[85] = ($event: any) => (_ctx.isNumber($event))),
                              disabled: !_ctx.isPermission,
                              onChange: _ctx.methosIndustryAutoChangeTHPT,
                              placeholder: "Điểm THPT"
                            }, null, 8, ["modelValue", "disabled", "onChange"])
                          ]),
                          _: 1
                        }),
                        (_ctx.objectScore.chemistryTHPT)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_265, _toDisplayString(_ctx.objectScore.chemistryTHPT), 1))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row flex-row-fluid", _ctx.formData.biologicalTHPT != _ctx.objectScore.biologicalTHPT && _ctx.formData.biologicalTHPT && _ctx.objectScore.biologicalTHPT?'err-point':''])
                      }, [
                        _hoisted_266,
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.biologicalTHPT,
                              "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.formData.biologicalTHPT) = $event)),
                              type: "text",
                              onKeypress: _cache[87] || (_cache[87] = ($event: any) => (_ctx.isNumber($event))),
                              disabled: !_ctx.isPermission,
                              onChange: _ctx.methosIndustryAutoChangeTHPT,
                              placeholder: "Điểm THPT"
                            }, null, 8, ["modelValue", "disabled", "onChange"])
                          ]),
                          _: 1
                        }),
                        (_ctx.objectScore.biologicalTHPT)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_267, _toDisplayString(_ctx.objectScore.biologicalTHPT), 1))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row flex-row-fluid", _ctx.formData.historyTHPT != _ctx.objectScore.historyTHPT && _ctx.formData.historyTHPT && _ctx.objectScore.historyTHPT?'err-point':''])
                      }, [
                        _hoisted_268,
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.historyTHPT,
                              "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.formData.historyTHPT) = $event)),
                              type: "text",
                              onKeypress: _cache[89] || (_cache[89] = ($event: any) => (_ctx.isNumber($event))),
                              disabled: !_ctx.isPermission,
                              onChange: _ctx.methosIndustryAutoChangeTHPT,
                              placeholder: "Điểm THPT"
                            }, null, 8, ["modelValue", "disabled", "onChange"])
                          ]),
                          _: 1
                        }),
                        (_ctx.objectScore.historyTHPT)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_269, _toDisplayString(_ctx.objectScore.historyTHPT), 1))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row flex-row-fluid", _ctx.formData.geographyTHPT != _ctx.objectScore.geographyTHPT && _ctx.formData.geographyTHPT && _ctx.objectScore.geographyTHPT?'err-point':''])
                      }, [
                        _hoisted_270,
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.geographyTHPT,
                              "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((_ctx.formData.geographyTHPT) = $event)),
                              type: "text",
                              onKeypress: _cache[91] || (_cache[91] = ($event: any) => (_ctx.isNumber($event))),
                              disabled: !_ctx.isPermission,
                              onChange: _ctx.methosIndustryAutoChangeTHPT,
                              placeholder: "Điểm THPT"
                            }, null, 8, ["modelValue", "disabled", "onChange"])
                          ]),
                          _: 1
                        }),
                        (_ctx.objectScore.geographyTHPT)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_271, _toDisplayString(_ctx.objectScore.geographyTHPT), 1))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row flex-row-fluid", _ctx.formData.informationTechnologyTHPT != _ctx.objectScore.informationTechnologyTHPT && _ctx.formData.informationTechnologyTHPT && _ctx.objectScore.informationTechnologyTHPT?'err-point':''])
                      }, [
                        _hoisted_272,
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.informationTechnologyTHPT,
                              "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.formData.informationTechnologyTHPT) = $event)),
                              type: "text",
                              onKeypress: _cache[93] || (_cache[93] = ($event: any) => (_ctx.isNumber($event))),
                              disabled: !_ctx.isPermission,
                              onChange: _ctx.methosIndustryAutoChangeTHPT,
                              placeholder: "Điểm THPT"
                            }, null, 8, ["modelValue", "disabled", "onChange"])
                          ]),
                          _: 1
                        }),
                        (_ctx.objectScore.informationTechnologyTHPT)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_273, _toDisplayString(_ctx.objectScore.informationTechnologyTHPT), 1))
                          : _createCommentVNode("", true)
                      ], 2),
                      false
                        ? (_openBlock(), _createElementBlock("div", _hoisted_274, [
                            _hoisted_275,
                            _createVNode(_component_el_form_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formData.artTHPT,
                                  "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => ((_ctx.formData.artTHPT) = $event)),
                                  type: "text",
                                  onKeypress: _cache[95] || (_cache[95] = ($event: any) => (_ctx.isNumber($event))),
                                  disabled: !_ctx.isPermission,
                                  onChange: _ctx.methosIndustryAutoChangeTHPT,
                                  placeholder: "Điểm THPT"
                                }, null, 8, ["modelValue", "disabled", "onChange"])
                              ]),
                              _: 1
                            }),
                            (_ctx.objectScore.artTHPT)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_276, _toDisplayString(_ctx.objectScore.artTHPT), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["fv-row flex-row-fluid", _ctx.formData.economicsAndLawEducationTHPT != _ctx.objectScore.economicsAndLawEducationTHPT && _ctx.formData.economicsAndLawEducationTHPT && _ctx.objectScore.economicsAndLawEducationTHPT?'err-point':''])
                      }, [
                        _hoisted_277,
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.economicsAndLawEducationTHPT,
                              "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => ((_ctx.formData.economicsAndLawEducationTHPT) = $event)),
                              type: "text",
                              onKeypress: _cache[97] || (_cache[97] = ($event: any) => (_ctx.isNumber($event))),
                              disabled: !_ctx.isPermission,
                              onChange: _ctx.methosIndustryAutoChangeTHPT,
                              placeholder: "Điểm THPT"
                            }, null, 8, ["modelValue", "disabled", "onChange"])
                          ]),
                          _: 1
                        }),
                        (_ctx.objectScore.economicsAndLawEducationTHPT)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_278, _toDisplayString(_ctx.objectScore.economicsAndLawEducationTHPT), 1))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _hoisted_279,
                    (_ctx.missingComboScores.length)
                      ? (_openBlock(), _createBlock(_component_el_alert, {
                          key: 2,
                          type: "warning",
                          closable: false,
                          class: "umt-warn-banner mb-4"
                        }, {
                          title: _withCtx(() => [
                            _hoisted_280,
                            _hoisted_281,
                            _createTextVNode(" tổ hợp ở " + _toDisplayString(_ctx.missingComboScores.join(', ')) + " chưa nhập đủ điểm các môn — hồ sơ vẫn lưu được nhưng chưa tính được điểm xét tuyển.", 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_282, [
                      _createElementVNode("div", _hoisted_283, [
                        _createElementVNode("div", _hoisted_284, [
                          _createElementVNode("div", _hoisted_285, [
                            _hoisted_286,
                            _createVNode(_component_el_form_item, { prop: "admissionsIndustryTHPT" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  "popper-class": "umt-form-dd",
                                  class: "form-select-solid w-100",
                                  modelValue: _ctx.formData.admissionsIndustryTHPT,
                                  "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event: any) => ((_ctx.formData.admissionsIndustryTHPT) = $event)),
                                  placeholder: "Ưu tiên 1",
                                  disabled: !_ctx.isPermission,
                                  onChange: _ctx.admissionsIndustryChangeTHPT,
                                  filterable: true
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajors, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled", "onChange"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_287, [
                          _createElementVNode("div", _hoisted_288, [
                            _createElementVNode("label", _hoisted_289, [
                              _createElementVNode("div", null, [
                                _createTextVNode(" Hình thức xét "),
                                (_ctx.isMaxGPATHPT)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_290, "(Đây là lựa chọn tốt nhất)"))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.getEnglishConvertedScoreForDisplay(_ctx.formData.methosIndustryTHPT, 4, 1) > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_291, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-check-input me-2",
                                      type: "checkbox",
                                      "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event: any) => ((_ctx.formData.isUseEnglish1) = $event)),
                                      id: "isUseEnglish1_thpt"
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.formData.isUseEnglish1]
                                    ]),
                                    _hoisted_292
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_el_form_item, { prop: "methosIndustryTHPT" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  "popper-class": "umt-form-dd",
                                  class: "form-select-solid w-100",
                                  placeholder: "Hình thức xét",
                                  filterable: true,
                                  modelValue: _ctx.formData.methosIndustryTHPT,
                                  "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => ((_ctx.formData.methosIndustryTHPT) = $event)),
                                  disabled: _ctx.arrMethosIndustryTHPT.length == 0 || !_ctx.isPermission || !_ctx.formData.admissionsIndustryTHPT,
                                  onChange: _ctx.methosIndustryManualChangeTHPT
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMethosIndustryTHPT, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled", "onChange"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        (_ctx.getGPAForDisplay(_ctx.GPAIndustryTHPT, _ctx.formData.methosIndustryTHPT, 4, 1) > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_293, [
                              _createElementVNode("div", _hoisted_294, [
                                _createElementVNode("div", _hoisted_295, [
                                  _createElementVNode("div", _hoisted_296, [
                                    _hoisted_297,
                                    (_ctx.getConversionUsedForDisplay(_ctx.formData.methosIndustryTHPT, 4, 1))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_298, [
                                          _createElementVNode("span", _hoisted_299, [
                                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                          ]),
                                          _createElementVNode("div", _hoisted_300, [
                                            _createElementVNode("div", null, " Đã áp dụng quy đổi điểm Tiếng Anh (" + _toDisplayString(_ctx.englishCertResult.convertedScore) + " điểm) có lợi hơn điểm thi thực tế. ", 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("strong", _hoisted_301, _toDisplayString(_ctx.getGPAForDisplay(_ctx.GPAIndustryTHPT, _ctx.formData.methosIndustryTHPT, 4, 1)), 1)
                                ]),
                                (_ctx.getIncentiveForDisplay(_ctx.GPAIndustryTHPT, _ctx.formData.methosIndustryTHPT, 4, 1) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_302, [
                                      _hoisted_303,
                                      _createElementVNode("strong", _hoisted_304, "+" + _toDisplayString(_ctx.getIncentiveForDisplay(_ctx.GPAIndustryTHPT, _ctx.formData.methosIndustryTHPT, 4, 1)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_305, [
                                  _createElementVNode("div", _hoisted_306, [
                                    _hoisted_307,
                                    (_ctx.isPriorityReducedForDisplay(_ctx.formData.methosIndustryTHPT, 4, 1))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_308, [
                                          _createElementVNode("span", _hoisted_309, [
                                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                          ]),
                                          _hoisted_310
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("strong", _hoisted_311, _toDisplayString(_ctx.getPriorityForDisplay(_ctx.GPAIndustryTHPT, _ctx.formData.methosIndustryTHPT, 4, 1)), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_312, [
                                _hoisted_313,
                                _createElementVNode("span", _hoisted_314, [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.getTotalForDisplay(_ctx.GPAIndustryTHPT, _ctx.formData.methosIndustryTHPT, 4, 1)), 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_315, [
                        _createElementVNode("div", _hoisted_316, [
                          _createElementVNode("div", _hoisted_317, [
                            _hoisted_318,
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "form-select-solid w-100",
                              modelValue: _ctx.formData.admissionsIndustryTHPT2,
                              "onUpdate:modelValue": _cache[101] || (_cache[101] = ($event: any) => ((_ctx.formData.admissionsIndustryTHPT2) = $event)),
                              placeholder: "Ưu tiên 2",
                              disabled: !_ctx.isPermission,
                              onChange: _ctx.admissionsIndustryChangeTHPT2,
                              filterable: true
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajorsTHPT2, (major) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: major.value,
                                    label: `${major.label}`,
                                    value: major.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled", "onChange"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_319, [
                          _createElementVNode("div", _hoisted_320, [
                            _createElementVNode("label", _hoisted_321, [
                              _createElementVNode("div", null, [
                                _createTextVNode(" Hình thức xét "),
                                (_ctx.isMaxGPATHPT2)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_322, "(Đây là lựa chọn tốt nhất)"))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.getEnglishConvertedScoreForDisplay(_ctx.formData.methosIndustryTHPT2, 4, 2) > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_323, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-check-input me-2",
                                      type: "checkbox",
                                      "onUpdate:modelValue": _cache[102] || (_cache[102] = ($event: any) => ((_ctx.formData.isUseEnglish2) = $event)),
                                      id: "isUseEnglish2_thpt"
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.formData.isUseEnglish2]
                                    ]),
                                    _hoisted_324
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "form-select-solid w-100",
                              placeholder: "Hình thức xét",
                              filterable: true,
                              modelValue: _ctx.formData.methosIndustryTHPT2,
                              "onUpdate:modelValue": _cache[103] || (_cache[103] = ($event: any) => ((_ctx.formData.methosIndustryTHPT2) = $event)),
                              disabled: _ctx.arrMethosIndustryTHPT2.length == 0 || !_ctx.isPermission || !_ctx.formData.admissionsIndustryTHPT2
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMethosIndustryTHPT2, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled"])
                          ])
                        ]),
                        (_ctx.getGPAForDisplay(_ctx.GPAIndustryTHPT2, _ctx.formData.methosIndustryTHPT2, 4, 2) > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_325, [
                              _createElementVNode("div", _hoisted_326, [
                                _createElementVNode("div", _hoisted_327, [
                                  _createElementVNode("div", _hoisted_328, [
                                    _hoisted_329,
                                    (_ctx.getConversionUsedForDisplay(_ctx.formData.methosIndustryTHPT2, 4, 2))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_330, [
                                          _createElementVNode("span", _hoisted_331, [
                                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                          ]),
                                          _createElementVNode("div", _hoisted_332, [
                                            _createElementVNode("div", null, " Đã áp dụng quy đổi điểm Tiếng Anh (" + _toDisplayString(_ctx.englishCertResult.convertedScore) + " điểm) có lợi hơn điểm thi thực tế. ", 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("strong", _hoisted_333, _toDisplayString(_ctx.getGPAForDisplay(_ctx.GPAIndustryTHPT2, _ctx.formData.methosIndustryTHPT2, 4, 2)), 1)
                                ]),
                                (_ctx.getIncentiveForDisplay(_ctx.GPAIndustryTHPT2, _ctx.formData.methosIndustryTHPT2, 4, 2) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_334, [
                                      _hoisted_335,
                                      _createElementVNode("strong", _hoisted_336, "+" + _toDisplayString(_ctx.getIncentiveForDisplay(_ctx.GPAIndustryTHPT2, _ctx.formData.methosIndustryTHPT2, 4, 2)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_337, [
                                  _createElementVNode("div", _hoisted_338, [
                                    _hoisted_339,
                                    (_ctx.isPriorityReducedForDisplay(_ctx.formData.methosIndustryTHPT2, 4, 2))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_340, [
                                          _createElementVNode("span", _hoisted_341, [
                                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                          ]),
                                          _hoisted_342
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("strong", _hoisted_343, _toDisplayString(_ctx.getPriorityForDisplay(_ctx.GPAIndustryTHPT2, _ctx.formData.methosIndustryTHPT2, 4, 2)), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_344, [
                                _hoisted_345,
                                _createElementVNode("span", _hoisted_346, [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.getTotalForDisplay(_ctx.GPAIndustryTHPT2, _ctx.formData.methosIndustryTHPT2, 4, 2)), 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_347, [
                        _createElementVNode("div", _hoisted_348, [
                          _createElementVNode("div", _hoisted_349, [
                            _hoisted_350,
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "form-select-solid w-100",
                              modelValue: _ctx.formData.admissionsIndustryTHPT3,
                              "onUpdate:modelValue": _cache[104] || (_cache[104] = ($event: any) => ((_ctx.formData.admissionsIndustryTHPT3) = $event)),
                              placeholder: "Ưu tiên 3",
                              disabled: !_ctx.isPermission,
                              onChange: _ctx.admissionsIndustryChangeTHPT3,
                              filterable: true
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajorsTHPT3, (major) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: major.value,
                                    label: `${major.label}`,
                                    value: major.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled", "onChange"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_351, [
                          _createElementVNode("div", _hoisted_352, [
                            _createElementVNode("label", _hoisted_353, [
                              _createElementVNode("div", null, [
                                _createTextVNode(" Hình thức xét "),
                                (_ctx.isMaxGPATHPT3)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_354, "(Đây là lựa chọn tốt nhất)"))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.getEnglishConvertedScoreForDisplay(_ctx.formData.methosIndustryTHPT3, 4, 3) > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_355, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-check-input me-2",
                                      type: "checkbox",
                                      "onUpdate:modelValue": _cache[105] || (_cache[105] = ($event: any) => ((_ctx.formData.isUseEnglish3) = $event)),
                                      id: "isUseEnglish3_thpt"
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.formData.isUseEnglish3]
                                    ]),
                                    _hoisted_356
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "form-select-solid w-100",
                              placeholder: "Hình thức xét",
                              filterable: true,
                              modelValue: _ctx.formData.methosIndustryTHPT3,
                              "onUpdate:modelValue": _cache[106] || (_cache[106] = ($event: any) => ((_ctx.formData.methosIndustryTHPT3) = $event)),
                              disabled: _ctx.arrMethosIndustryTHPT3.length == 0 || !_ctx.isPermission || !_ctx.formData.admissionsIndustryTHPT3
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMethosIndustryTHPT3, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled"])
                          ])
                        ]),
                        (_ctx.getGPAForDisplay(_ctx.GPAIndustryTHPT3, _ctx.formData.methosIndustryTHPT3, 4, 3) > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_357, [
                              _createElementVNode("div", _hoisted_358, [
                                _createElementVNode("div", _hoisted_359, [
                                  _createElementVNode("div", _hoisted_360, [
                                    _hoisted_361,
                                    (_ctx.getConversionUsedForDisplay(_ctx.formData.methosIndustryTHPT3, 4, 3))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_362, [
                                          _createElementVNode("span", _hoisted_363, [
                                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                          ]),
                                          _createElementVNode("div", _hoisted_364, [
                                            _createElementVNode("div", null, " Đã áp dụng quy đổi điểm Tiếng Anh (" + _toDisplayString(_ctx.englishCertResult.convertedScore) + " điểm) có lợi hơn điểm thi thực tế. ", 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("strong", _hoisted_365, _toDisplayString(_ctx.getGPAForDisplay(_ctx.GPAIndustryTHPT3, _ctx.formData.methosIndustryTHPT3, 4, 3)), 1)
                                ]),
                                (_ctx.getIncentiveForDisplay(_ctx.GPAIndustryTHPT3, _ctx.formData.methosIndustryTHPT3, 4, 3) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_366, [
                                      _hoisted_367,
                                      _createElementVNode("strong", _hoisted_368, "+" + _toDisplayString(_ctx.getIncentiveForDisplay(_ctx.GPAIndustryTHPT3, _ctx.formData.methosIndustryTHPT3, 4, 3)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_369, [
                                  _createElementVNode("div", _hoisted_370, [
                                    _hoisted_371,
                                    (_ctx.isPriorityReducedForDisplay(_ctx.formData.methosIndustryTHPT3, 4, 3))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_372, [
                                          _createElementVNode("span", _hoisted_373, [
                                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                          ]),
                                          _hoisted_374
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("strong", _hoisted_375, _toDisplayString(_ctx.getPriorityForDisplay(_ctx.GPAIndustryTHPT3, _ctx.formData.methosIndustryTHPT3, 4, 3)), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_376, [
                                _hoisted_377,
                                _createElementVNode("span", _hoisted_378, [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.getTotalForDisplay(_ctx.GPAIndustryTHPT3, _ctx.formData.methosIndustryTHPT3, 4, 3)), 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.method == 6)
                ? (_openBlock(), _createElementBlock("div", _hoisted_379, [
                    _createElementVNode("div", _hoisted_380, [
                      _hoisted_381,
                      _createElementVNode("div", _hoisted_382, [
                        _createElementVNode("div", _hoisted_383, [
                          _createElementVNode("div", _hoisted_384, [
                            _hoisted_385,
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.dgnlHN_math,
                              "onUpdate:modelValue": _cache[107] || (_cache[107] = ($event: any) => ((_ctx.formData.dgnlHN_math) = $event)),
                              placeholder: "0-150",
                              onKeypress: _cache[108] || (_cache[108] = ($event: any) => (_ctx.isNumber($event)))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_386, [
                            _hoisted_387,
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.dgnlHN_literature,
                              "onUpdate:modelValue": _cache[109] || (_cache[109] = ($event: any) => ((_ctx.formData.dgnlHN_literature) = $event)),
                              placeholder: "0-150",
                              onKeypress: _cache[110] || (_cache[110] = ($event: any) => (_ctx.isNumber($event)))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_388, [
                            _hoisted_389,
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.dgnlHN_english,
                              "onUpdate:modelValue": _cache[111] || (_cache[111] = ($event: any) => ((_ctx.formData.dgnlHN_english) = $event)),
                              placeholder: "0-150",
                              onKeypress: _cache[112] || (_cache[112] = ($event: any) => (_ctx.isNumber($event)))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_390, [
                            _hoisted_391,
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.dgnlHN_physics,
                              "onUpdate:modelValue": _cache[113] || (_cache[113] = ($event: any) => ((_ctx.formData.dgnlHN_physics) = $event)),
                              placeholder: "0-150",
                              onKeypress: _cache[114] || (_cache[114] = ($event: any) => (_ctx.isNumber($event)))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_392, [
                            _hoisted_393,
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.dgnlHN_chemistry,
                              "onUpdate:modelValue": _cache[115] || (_cache[115] = ($event: any) => ((_ctx.formData.dgnlHN_chemistry) = $event)),
                              placeholder: "0-150",
                              onKeypress: _cache[116] || (_cache[116] = ($event: any) => (_ctx.isNumber($event)))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_394, [
                            _hoisted_395,
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.dgnlHN_biology,
                              "onUpdate:modelValue": _cache[117] || (_cache[117] = ($event: any) => ((_ctx.formData.dgnlHN_biology) = $event)),
                              placeholder: "0-150",
                              onKeypress: _cache[118] || (_cache[118] = ($event: any) => (_ctx.isNumber($event)))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_396, [
                            _hoisted_397,
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.dgnlHN_history,
                              "onUpdate:modelValue": _cache[119] || (_cache[119] = ($event: any) => ((_ctx.formData.dgnlHN_history) = $event)),
                              placeholder: "0-150",
                              onKeypress: _cache[120] || (_cache[120] = ($event: any) => (_ctx.isNumber($event)))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_398, [
                            _hoisted_399,
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.dgnlHN_geography,
                              "onUpdate:modelValue": _cache[121] || (_cache[121] = ($event: any) => ((_ctx.formData.dgnlHN_geography) = $event)),
                              placeholder: "0-150",
                              onKeypress: _cache[122] || (_cache[122] = ($event: any) => (_ctx.isNumber($event)))
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_400, [
                        _createElementVNode("div", _hoisted_401, [
                          _createElementVNode("div", _hoisted_402, [
                            _hoisted_403,
                            _createElementVNode("span", _hoisted_404, _toDisplayString(_ctx.GPAIndustryDGNL_HN.toFixed(2)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_405, [
                            _hoisted_406,
                            _createElementVNode("span", _hoisted_407, _toDisplayString(_ctx.cacuPointPriority(_ctx.GPAIndustryDGNL_HN).toFixed(2)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_408, [
                            _hoisted_409,
                            _createElementVNode("span", _hoisted_410, _toDisplayString(_ctx.certIncentiveResult.total), 1)
                          ]),
                          _hoisted_411,
                          _createElementVNode("div", _hoisted_412, [
                            _hoisted_413,
                            _createElementVNode("span", _hoisted_414, _toDisplayString(_ctx.totalScoreDGNL_HN.toFixed(2)), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_415, [
                        _hoisted_416,
                        _hoisted_417,
                        _createElementVNode("div", _hoisted_418, [
                          _createElementVNode("div", _hoisted_419, [
                            _hoisted_420,
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              modelValue: _ctx.formData.majorDGNL_HN,
                              "onUpdate:modelValue": _cache[123] || (_cache[123] = ($event: any) => ((_ctx.formData.majorDGNL_HN) = $event)),
                              placeholder: "Chọn ngành",
                              class: "w-100",
                              filterable: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajors, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_421, [
                            _hoisted_422,
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              modelValue: _ctx.formData.majorDGNL_HN2,
                              "onUpdate:modelValue": _cache[124] || (_cache[124] = ($event: any) => ((_ctx.formData.majorDGNL_HN2) = $event)),
                              placeholder: "Chọn ngành",
                              class: "w-100",
                              filterable: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajors.filter(i => i.value != _ctx.formData.majorDGNL_HN), (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_423, [
                            _hoisted_424,
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              modelValue: _ctx.formData.majorDGNL_HN3,
                              "onUpdate:modelValue": _cache[125] || (_cache[125] = ($event: any) => ((_ctx.formData.majorDGNL_HN3) = $event)),
                              placeholder: "Chọn ngành",
                              class: "w-100",
                              filterable: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajors.filter(i => i.value != _ctx.formData.majorDGNL_HN && i.value != _ctx.formData.majorDGNL_HN2), (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.method == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_425, [
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.formData.formOfMethod == '3YS' ? '' : 'hide')
                    }, [
                      _hoisted_426,
                      _createElementVNode("div", _hoisted_427, [
                        _createElementVNode("div", _hoisted_428, [
                          _hoisted_429,
                          _createVNode(_component_el_input, {
                            type: "text",
                            modelValue: _ctx.formData.all10,
                            "onUpdate:modelValue": _cache[126] || (_cache[126] = ($event: any) => ((_ctx.formData.all10) = $event)),
                            onKeypress: _cache[127] || (_cache[127] = ($event: any) => (_ctx.isNumber($event))),
                            disabled: !_ctx.isPermission,
                            onChange: _ctx.methosIndustryAutoChange,
                            placeholder: "Điểm TB"
                          }, null, 8, ["modelValue", "disabled", "onChange"])
                        ]),
                        _createElementVNode("div", _hoisted_430, [
                          _hoisted_431,
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.all11,
                            "onUpdate:modelValue": _cache[128] || (_cache[128] = ($event: any) => ((_ctx.formData.all11) = $event)),
                            type: "text",
                            onKeypress: _cache[129] || (_cache[129] = ($event: any) => (_ctx.isNumber($event))),
                            disabled: !_ctx.isPermission,
                            onChange: _ctx.methosIndustryAutoChange,
                            placeholder: "Điểm TB"
                          }, null, 8, ["modelValue", "disabled", "onChange"])
                        ]),
                        _createElementVNode("div", _hoisted_432, [
                          _hoisted_433,
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.all12,
                                "onUpdate:modelValue": _cache[130] || (_cache[130] = ($event: any) => ((_ctx.formData.all12) = $event)),
                                type: "text",
                                onKeypress: _cache[131] || (_cache[131] = ($event: any) => (_ctx.isNumber($event))),
                                disabled: !_ctx.isPermission,
                                onChange: _ctx.methosIndustryAutoChange,
                                placeholder: "Điểm TB"
                              }, null, 8, ["modelValue", "disabled", "onChange"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ], 2),
                    (_ctx.formData.formOfMethod == 'THM')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_434,
                          _createElementVNode("div", _hoisted_435, [
                            _createElementVNode("div", _hoisted_436, [
                              _hoisted_437,
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.mathHKII,
                                    "onUpdate:modelValue": _cache[132] || (_cache[132] = ($event: any) => ((_ctx.formData.mathHKII) = $event)),
                                    type: "text",
                                    onKeypress: _cache[133] || (_cache[133] = ($event: any) => (_ctx.isNumber($event))),
                                    disabled: !_ctx.isPermission,
                                    onChange: _ctx.methosIndustryAutoChange,
                                    placeholder: "Điểm TB"
                                  }, null, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_438, [
                              _hoisted_439,
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.physicsHKII,
                                    "onUpdate:modelValue": _cache[134] || (_cache[134] = ($event: any) => ((_ctx.formData.physicsHKII) = $event)),
                                    type: "text",
                                    onKeypress: _cache[135] || (_cache[135] = ($event: any) => (_ctx.isNumber($event))),
                                    disabled: !_ctx.isPermission,
                                    onChange: _ctx.methosIndustryAutoChange,
                                    placeholder: "Điểm TB"
                                  }, null, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_440, [
                              _hoisted_441,
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.chemistryHKII,
                                    "onUpdate:modelValue": _cache[136] || (_cache[136] = ($event: any) => ((_ctx.formData.chemistryHKII) = $event)),
                                    type: "text",
                                    onKeypress: _cache[137] || (_cache[137] = ($event: any) => (_ctx.isNumber($event))),
                                    disabled: !_ctx.isPermission,
                                    onChange: _ctx.methosIndustryAutoChange,
                                    placeholder: "Điểm TB"
                                  }, null, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_442, [
                              _hoisted_443,
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.englishHKII,
                                    "onUpdate:modelValue": _cache[138] || (_cache[138] = ($event: any) => ((_ctx.formData.englishHKII) = $event)),
                                    type: "text",
                                    onKeypress: _cache[139] || (_cache[139] = ($event: any) => (_ctx.isNumber($event))),
                                    disabled: !_ctx.isPermission,
                                    onChange: _ctx.methosIndustryAutoChange,
                                    placeholder: "Điểm TB"
                                  }, null, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_444, [
                              _hoisted_445,
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.frenchHKII,
                                    "onUpdate:modelValue": _cache[140] || (_cache[140] = ($event: any) => ((_ctx.formData.frenchHKII) = $event)),
                                    type: "text",
                                    onKeypress: _cache[141] || (_cache[141] = ($event: any) => (_ctx.isNumber($event))),
                                    disabled: !_ctx.isPermission,
                                    onChange: _ctx.methosIndustryAutoChange,
                                    placeholder: "Điểm TB"
                                  }, null, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_446, [
                              _hoisted_447,
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.literatureHKII,
                                    "onUpdate:modelValue": _cache[142] || (_cache[142] = ($event: any) => ((_ctx.formData.literatureHKII) = $event)),
                                    type: "text",
                                    onKeypress: _cache[143] || (_cache[143] = ($event: any) => (_ctx.isNumber($event))),
                                    disabled: !_ctx.isPermission,
                                    onChange: _ctx.methosIndustryAutoChange,
                                    placeholder: "Điểm TB"
                                  }, null, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_448, [
                              _hoisted_449,
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.historyHKII,
                                    "onUpdate:modelValue": _cache[144] || (_cache[144] = ($event: any) => ((_ctx.formData.historyHKII) = $event)),
                                    type: "text",
                                    onKeypress: _cache[145] || (_cache[145] = ($event: any) => (_ctx.isNumber($event))),
                                    disabled: !_ctx.isPermission,
                                    onChange: _ctx.methosIndustryAutoChange,
                                    placeholder: "Điểm TB"
                                  }, null, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_450, [
                              _hoisted_451,
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.geographyHKII,
                                    "onUpdate:modelValue": _cache[146] || (_cache[146] = ($event: any) => ((_ctx.formData.geographyHKII) = $event)),
                                    type: "text",
                                    onKeypress: _cache[147] || (_cache[147] = ($event: any) => (_ctx.isNumber($event))),
                                    disabled: !_ctx.isPermission,
                                    onChange: _ctx.methosIndustryAutoChange,
                                    placeholder: "Điểm TB"
                                  }, null, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_452, [
                              _hoisted_453,
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.biologicalHKII,
                                    "onUpdate:modelValue": _cache[148] || (_cache[148] = ($event: any) => ((_ctx.formData.biologicalHKII) = $event)),
                                    type: "text",
                                    onKeypress: _cache[149] || (_cache[149] = ($event: any) => (_ctx.isNumber($event))),
                                    disabled: !_ctx.isPermission,
                                    onChange: _ctx.methosIndustryAutoChange,
                                    placeholder: "Điểm TB"
                                  }, null, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_454, [
                              _hoisted_455,
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.civicEducationHKII,
                                    "onUpdate:modelValue": _cache[150] || (_cache[150] = ($event: any) => ((_ctx.formData.civicEducationHKII) = $event)),
                                    type: "text",
                                    onKeypress: _cache[151] || (_cache[151] = ($event: any) => (_ctx.isNumber($event))),
                                    disabled: !_ctx.isPermission,
                                    onChange: _ctx.methosIndustryAutoChange,
                                    placeholder: "Điểm TB"
                                  }, null, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_456, [
                              _hoisted_457,
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.informationTechnologyHKII,
                                    "onUpdate:modelValue": _cache[152] || (_cache[152] = ($event: any) => ((_ctx.formData.informationTechnologyHKII) = $event)),
                                    type: "text",
                                    onKeypress: _cache[153] || (_cache[153] = ($event: any) => (_ctx.isNumber($event))),
                                    disabled: !_ctx.isPermission,
                                    onChange: _ctx.methosIndustryAutoChange,
                                    placeholder: "Điểm TB"
                                  }, null, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_458, [
                              _hoisted_459,
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.artHKII,
                                    "onUpdate:modelValue": _cache[154] || (_cache[154] = ($event: any) => ((_ctx.formData.artHKII) = $event)),
                                    type: "text",
                                    onKeypress: _cache[155] || (_cache[155] = ($event: any) => (_ctx.isNumber($event))),
                                    disabled: !_ctx.isPermission,
                                    onChange: _ctx.methosIndustryAutoChange,
                                    placeholder: "Điểm TB"
                                  }, null, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_460, [
                              _hoisted_461,
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.economicsAndLawEducationHKII,
                                    "onUpdate:modelValue": _cache[156] || (_cache[156] = ($event: any) => ((_ctx.formData.economicsAndLawEducationHKII) = $event)),
                                    type: "text",
                                    onKeypress: _cache[157] || (_cache[157] = ($event: any) => (_ctx.isNumber($event))),
                                    disabled: !_ctx.isPermission,
                                    onChange: _ctx.methosIndustryAutoChange,
                                    placeholder: "Điểm TB"
                                  }, null, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    _hoisted_462,
                    (_ctx.formData.method == 1 && _ctx.formData.formOfMethod == '9CR')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_463, [
                          (_ctx.transcriptMismatch)
                            ? (_openBlock(), _createBlock(_component_el_alert, {
                                key: 0,
                                type: "warning",
                                closable: false,
                                class: "umt-warn-banner mb-4"
                              }, {
                                title: _withCtx(() => [
                                  _hoisted_464,
                                  _createTextVNode(" Phát hiện điểm trong hồ sơ "),
                                  _hoisted_465,
                                  _createTextVNode(" Bảng điểm học bạ (tab Thông tin học tập). "),
                                  (_ctx.hasDirtyScores)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode("Điểm sẽ được "),
                                        _hoisted_466,
                                        _createTextVNode(" vào bảng điểm khi "),
                                        _hoisted_467,
                                        _createTextVNode(".")
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (_ctx.isPermission && !_ctx.isAppraised && !_ctx.hasDirtyScores)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("span", {
                                          class: "text-primary fw-bold cursor-pointer text-decoration-underline ms-1",
                                          onClick: _cache[158] || (_cache[158] = 
//@ts-ignore
(...args) => (_ctx.syncFromTranscript && _ctx.syncFromTranscript(...args)))
                                        }, "Đồng bộ theo bảng điểm"),
                                        _hoisted_468,
                                        _createElementVNode("span", {
                                          class: "text-primary fw-bold cursor-pointer text-decoration-underline",
                                          onClick: _cache[159] || (_cache[159] = 
//@ts-ignore
(...args) => (_ctx.writeFormScoresToTranscript && _ctx.writeFormScoresToTranscript(...args)))
                                        }, "Ghi điểm hồ sơ vào bảng điểm")
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : (_ctx.transcriptCanFill)
                              ? (_openBlock(), _createBlock(_component_el_alert, {
                                  key: 1,
                                  type: "warning",
                                  closable: false,
                                  class: "umt-warn-banner mb-4"
                                }, {
                                  title: _withCtx(() => [
                                    _hoisted_469,
                                    _createTextVNode(" Hồ sơ đang "),
                                    _hoisted_470,
                                    _createTextVNode(" ở nguyện vọng đã chọn, trong khi "),
                                    _hoisted_471,
                                    _createTextVNode(" có sẵn điểm. "),
                                    (_ctx.isPermission && !_ctx.isAppraised)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "text-primary fw-bold cursor-pointer text-decoration-underline ms-1",
                                          onClick: _cache[160] || (_cache[160] = 
//@ts-ignore
(...args) => (_ctx.syncFromTranscript && _ctx.syncFromTranscript(...args)))
                                        }, "Đổ điểm từ bảng điểm"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : (!_ctx.studentTranscript)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_472, [
                                    _createVNode(_component_el_alert, {
                                      type: "error",
                                      closable: false,
                                      "show-icon": "",
                                      class: "umt-hint-banner"
                                    }, {
                                      title: _withCtx(() => [
                                        _createTextVNode(" Chưa có "),
                                        _hoisted_473,
                                        _createTextVNode(" (tab Thông tin học tập) — nhập để hệ tự chọn tổ hợp tốt nhất và tự đổ điểm. "),
                                        (_ctx.isPermission && !_ctx.isAppraised)
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 0,
                                              class: "text-primary fw-bold cursor-pointer text-decoration-underline ms-1",
                                              onClick: _cache[161] || (_cache[161] = 
//@ts-ignore
(...args) => (_ctx.writeFormScoresToTranscript && _ctx.writeFormScoresToTranscript(...args)))
                                            }, "Ghi điểm trong hồ sơ vào bảng điểm"))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_474, [
                            _createElementVNode("div", _hoisted_475, [
                              _hoisted_476,
                              _createVNode(_component_el_form_item, { prop: "admissionsIndustry" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    "popper-class": "umt-form-dd",
                                    class: "form-select-solid w-100",
                                    modelValue: _ctx.formData.admissionsIndustry,
                                    "onUpdate:modelValue": _cache[162] || (_cache[162] = ($event: any) => ((_ctx.formData.admissionsIndustry) = $event)),
                                    placeholder: "Ưu tiên 1",
                                    disabled: !_ctx.isPermission,
                                    onChange: _ctx.admissionsIndustryChange,
                                    filterable: true
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajors, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_477, [
                              _createElementVNode("label", _hoisted_478, [
                                _createElementVNode("div", null, [
                                  _hoisted_479,
                                  (_ctx.isMaxGPA)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_480, "(Đây là lựa chọn tốt nhất)"))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.getEnglishConvertedScoreForDisplay(_ctx.formData.methosIndustry, 1, 1) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_481, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input me-2",
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[163] || (_cache[163] = ($event: any) => ((_ctx.formData.isUseEnglish1) = $event)),
                                        id: "isUseEnglish1_9cr"
                                      }, null, 512), [
                                        [_vModelCheckbox, _ctx.formData.isUseEnglish1]
                                      ]),
                                      _hoisted_482
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode(_component_el_form_item, { prop: "methosIndustry" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    "popper-class": "umt-form-dd",
                                    class: "form-select-solid w-100",
                                    placeholder: "Hình thức xét",
                                    filterable: true,
                                    modelValue: _ctx.formData.methosIndustry,
                                    "onUpdate:modelValue": _cache[164] || (_cache[164] = ($event: any) => ((_ctx.formData.methosIndustry) = $event)),
                                    disabled: !_ctx.isPermission,
                                    onChange: _cache[165] || (_cache[165] = ($event: any) => (_ctx.methosIndustryAutoChange($event)))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allArrMethosIndustry, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            (_ctx.getGPAForDisplay(_ctx.GPAIndustry, _ctx.formData.methosIndustry, 1, 1) > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_483, [
                                  _createElementVNode("div", _hoisted_484, [
                                    _createElementVNode("div", _hoisted_485, [
                                      _createElementVNode("div", _hoisted_486, [
                                        _hoisted_487,
                                        (_ctx.getConversionUsedForDisplay(_ctx.formData.methosIndustry, 1, 1))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_488, [
                                              _createElementVNode("span", _hoisted_489, [
                                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                              ]),
                                              _createElementVNode("div", _hoisted_490, [
                                                _createElementVNode("div", null, " Đã áp dụng quy đổi điểm Tiếng Anh (" + _toDisplayString(_ctx.englishCertResult.convertedScore) + " điểm) có lợi hơn điểm thi thực tế. ", 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("strong", _hoisted_491, _toDisplayString(_ctx.getGPAForDisplay(_ctx.GPAIndustry, _ctx.formData.methosIndustry, 1, 1)), 1)
                                    ]),
                                    (_ctx.getIncentiveForDisplay(_ctx.GPAIndustry, _ctx.formData.methosIndustry, 1, 1) > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_492, [
                                          _hoisted_493,
                                          _createElementVNode("strong", _hoisted_494, "+" + _toDisplayString(_ctx.getIncentiveForDisplay(_ctx.GPAIndustry, _ctx.formData.methosIndustry, 1, 1)), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_495, [
                                      _createElementVNode("div", _hoisted_496, [
                                        _hoisted_497,
                                        (_ctx.isPriorityReducedForDisplay(_ctx.formData.methosIndustry, 1, 1))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_498, [
                                              _createElementVNode("span", _hoisted_499, [
                                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                              ]),
                                              _hoisted_500
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("strong", _hoisted_501, _toDisplayString(_ctx.getPriorityForDisplay(_ctx.GPAIndustry, _ctx.formData.methosIndustry, 1, 1)), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_502, [
                                    _hoisted_503,
                                    _createElementVNode("span", _hoisted_504, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.getTotalForDisplay(_ctx.GPAIndustry, _ctx.formData.methosIndustry, 1, 1)), 1)
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.formData.methosIndustry)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_505, [
                                  _createElementVNode("div", _hoisted_506, [
                                    (_ctx.slotTypeMismatch('subjectpoint', _ctx.formData.methosIndustry).length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_507, [
                                          _hoisted_508,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slotTypeMismatch('subjectpoint', _ctx.formData.methosIndustry), (m, mi) => {
                                            return (_openBlock(), _createElementBlock("div", { key: mi }, "• " + _toDisplayString(m), 1))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.comboBetterSuggestion(1))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_509, [
                                          _hoisted_510,
                                          _createElementVNode("span", null, [
                                            _createTextVNode("Theo học bạ, tổ hợp "),
                                            _createElementVNode("b", null, _toDisplayString(_ctx.comboBetterSuggestion(1).code), 1),
                                            _createTextVNode(" đạt "),
                                            _createElementVNode("b", null, _toDisplayString(_ctx.comboBetterSuggestion(1).score), 1),
                                            _createTextVNode(" điểm — cao hơn tổ hợp đang chọn"),
                                            (_ctx.comboBetterSuggestion(1).cur !== null)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(" (" + _toDisplayString(_ctx.comboBetterSuggestion(1).cur) + ")", 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(".")
                                          ]),
                                          (_ctx.isPermission && !_ctx.isAppraised)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: "btn btn-sm btn-light-primary py-1 px-2 ms-auto text-nowrap",
                                                onClick: _cache[166] || (_cache[166] = ($event: any) => (_ctx.applyBestCombo(1)))
                                              }, "Đổi sang " + _toDisplayString(_ctx.comboBetterSuggestion(1).code), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renderSubject(_ctx.formData.methosIndustry), (subjectKey, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "d-flex gap-5 mb-2",
                                        key: index
                                      }, [
                                        _createElementVNode("div", _hoisted_511, [
                                          _createElementVNode("label", _hoisted_512, [
                                            _createElementVNode("span", _hoisted_513, _toDisplayString(_ctx.renderTitleSubject(subjectKey)), 1)
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.formData.subjectpoint[index].data), (pointKey, classIndex) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: `${index}_${pointKey}`,
                                              class: "mb-2 d-flex1 w-100"
                                            }, [
                                              _createVNode(_component_el_form_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_input, {
                                                    name: `${pointKey}_${index}`,
                                                    modelValue: _ctx.formData.subjectpoint[index].data[pointKey],
                                                    "onUpdate:modelValue": ($event: any) => ((_ctx.formData.subjectpoint[index].data[pointKey]) = $event),
                                                    type: "text",
                                                    disabled: !_ctx.isPermission,
                                                    onInput: ($event: any) => (_ctx.markScoreDirty('subjectpoint', index, pointKey)),
                                                    onKeypress: _cache[167] || (_cache[167] = ($event: any) => (_ctx.isNumber($event))),
                                                    placeholder: `TB cả năm lớp ${10 + classIndex}`
                                                  }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "disabled", "onInput", "placeholder"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.formData.methosIndustry2)
                            ? (_openBlock(), _createElementBlock("hr", _hoisted_514))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass(["row p-0 mb-2 item-major", _ctx.formData.admissionsIndustry?'':'disabled'])
                          }, [
                            _createElementVNode("div", _hoisted_515, [
                              _hoisted_516,
                              _createVNode(_component_el_form_item, { prop: "admissionsIndustry2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    "popper-class": "umt-form-dd",
                                    class: "form-select-solid w-100",
                                    modelValue: _ctx.formData.admissionsIndustry2,
                                    "onUpdate:modelValue": _cache[168] || (_cache[168] = ($event: any) => ((_ctx.formData.admissionsIndustry2) = $event)),
                                    placeholder: "Ưu tiên 2",
                                    disabled: !_ctx.isPermission,
                                    onChange: _ctx.admissionsIndustryChange2,
                                    filterable: true
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajors2, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_517, [
                              _createElementVNode("label", _hoisted_518, [
                                _createElementVNode("div", null, [
                                  _hoisted_519,
                                  (_ctx.isMaxGPA2)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_520, "(Đây là lựa chọn tốt nhất)"))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.getEnglishConvertedScoreForDisplay(_ctx.formData.methosIndustry2, 1, 2) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_521, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input me-2",
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[169] || (_cache[169] = ($event: any) => ((_ctx.formData.isUseEnglish2) = $event)),
                                        id: "isUseEnglish2_9cr"
                                      }, null, 512), [
                                        [_vModelCheckbox, _ctx.formData.isUseEnglish2]
                                      ]),
                                      _hoisted_522
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode(_component_el_form_item, { prop: "methosIndustry2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    "popper-class": "umt-form-dd",
                                    class: "form-select-solid w-100",
                                    placeholder: "Hình thức xét",
                                    filterable: true,
                                    modelValue: _ctx.formData.methosIndustry2,
                                    "onUpdate:modelValue": _cache[170] || (_cache[170] = ($event: any) => ((_ctx.formData.methosIndustry2) = $event)),
                                    disabled: !_ctx.isPermission,
                                    onChange: _cache[171] || (_cache[171] = ($event: any) => (_ctx.methosIndustryAutoChange($event,'2')))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allArrMethosIndustry2, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            (_ctx.getGPAForDisplay(_ctx.GPAIndustry2, _ctx.formData.methosIndustry2, 1, 2) > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_523, [
                                  _createElementVNode("div", _hoisted_524, [
                                    _createElementVNode("div", _hoisted_525, [
                                      _createElementVNode("div", _hoisted_526, [
                                        _hoisted_527,
                                        (_ctx.getConversionUsedForDisplay(_ctx.formData.methosIndustry2, 1, 2))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_528, [
                                              _createElementVNode("span", _hoisted_529, [
                                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                              ]),
                                              _createElementVNode("div", _hoisted_530, [
                                                _createElementVNode("div", null, " Đã áp dụng quy đổi điểm Tiếng Anh (" + _toDisplayString(_ctx.englishCertResult.convertedScore) + " điểm) có lợi hơn điểm thi thực tế. ", 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("strong", _hoisted_531, _toDisplayString(_ctx.getGPAForDisplay(_ctx.GPAIndustry2, _ctx.formData.methosIndustry2, 1, 2)), 1)
                                    ]),
                                    (_ctx.getIncentiveForDisplay(_ctx.GPAIndustry2, _ctx.formData.methosIndustry2, 1, 2) > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_532, [
                                          _hoisted_533,
                                          _createElementVNode("strong", _hoisted_534, "+" + _toDisplayString(_ctx.getIncentiveForDisplay(_ctx.GPAIndustry2, _ctx.formData.methosIndustry2, 1, 2)), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_535, [
                                      _createElementVNode("div", _hoisted_536, [
                                        _hoisted_537,
                                        (_ctx.isPriorityReducedForDisplay(_ctx.formData.methosIndustry2, 1, 2))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_538, [
                                              _createElementVNode("span", _hoisted_539, [
                                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                              ]),
                                              _hoisted_540
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("strong", _hoisted_541, _toDisplayString(_ctx.getPriorityForDisplay(_ctx.GPAIndustry2, _ctx.formData.methosIndustry2, 1, 2)), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_542, [
                                    _hoisted_543,
                                    _createElementVNode("span", _hoisted_544, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.getTotalForDisplay(_ctx.GPAIndustry2, _ctx.formData.methosIndustry2, 1, 2)), 1)
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.formData.methosIndustry2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_545, [
                                  _createElementVNode("div", _hoisted_546, [
                                    (_ctx.slotTypeMismatch('subjectpoint2', _ctx.formData.methosIndustry2).length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_547, [
                                          _hoisted_548,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slotTypeMismatch('subjectpoint2', _ctx.formData.methosIndustry2), (m, mi) => {
                                            return (_openBlock(), _createElementBlock("div", { key: mi }, "• " + _toDisplayString(m), 1))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.comboBetterSuggestion(2))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_549, [
                                          _hoisted_550,
                                          _createElementVNode("span", null, [
                                            _createTextVNode("Theo học bạ, tổ hợp "),
                                            _createElementVNode("b", null, _toDisplayString(_ctx.comboBetterSuggestion(2).code), 1),
                                            _createTextVNode(" đạt "),
                                            _createElementVNode("b", null, _toDisplayString(_ctx.comboBetterSuggestion(2).score), 1),
                                            _createTextVNode(" điểm — cao hơn tổ hợp đang chọn"),
                                            (_ctx.comboBetterSuggestion(2).cur !== null)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(" (" + _toDisplayString(_ctx.comboBetterSuggestion(2).cur) + ")", 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(".")
                                          ]),
                                          (_ctx.isPermission && !_ctx.isAppraised)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: "btn btn-sm btn-light-primary py-1 px-2 ms-auto text-nowrap",
                                                onClick: _cache[172] || (_cache[172] = ($event: any) => (_ctx.applyBestCombo(2)))
                                              }, "Đổi sang " + _toDisplayString(_ctx.comboBetterSuggestion(2).code), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renderSubject(_ctx.formData.methosIndustry2), (subjectKey, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "d-flex gap-5 mb-2",
                                        key: index
                                      }, [
                                        _createElementVNode("div", _hoisted_551, [
                                          _createElementVNode("label", _hoisted_552, [
                                            _createElementVNode("span", _hoisted_553, _toDisplayString(_ctx.renderTitleSubject(subjectKey)), 1)
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.formData.subjectpoint2[index].data), (pointKey, classIndex) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: `${index}_${pointKey}`,
                                              class: "mb-2 d-flex1 w-100"
                                            }, [
                                              _createVNode(_component_el_form_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_input, {
                                                    type: "text",
                                                    class: "",
                                                    name: `${pointKey}_${index}_2`,
                                                    modelValue: _ctx.formData.subjectpoint2[index].data[pointKey],
                                                    "onUpdate:modelValue": ($event: any) => ((_ctx.formData.subjectpoint2[index].data[pointKey]) = $event),
                                                    onInput: ($event: any) => (_ctx.markScoreDirty('subjectpoint2', index, pointKey)),
                                                    onKeypress: _cache[173] || (_cache[173] = ($event: any) => (_ctx.isNumber($event))),
                                                    placeholder: `Điểm lớp ${10 + classIndex}`
                                                  }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onInput", "placeholder"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 2),
                          (_ctx.formData.methosIndustry3)
                            ? (_openBlock(), _createElementBlock("hr", _hoisted_554))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass(["row p-0 mb-2 item-major", _ctx.formData.admissionsIndustry2?'':'disabled'])
                          }, [
                            _createElementVNode("div", _hoisted_555, [
                              _hoisted_556,
                              _createVNode(_component_el_form_item, { prop: "admissionsIndustry3" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    "popper-class": "umt-form-dd",
                                    class: "form-select-solid w-100",
                                    modelValue: _ctx.formData.admissionsIndustry3,
                                    "onUpdate:modelValue": _cache[174] || (_cache[174] = ($event: any) => ((_ctx.formData.admissionsIndustry3) = $event)),
                                    placeholder: "Ưu tiên 3",
                                    disabled: !_ctx.isPermission,
                                    onChange: _ctx.admissionsIndustryChange3,
                                    filterable: true
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajors3, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_557, [
                              _createElementVNode("label", _hoisted_558, [
                                _createElementVNode("div", null, [
                                  _hoisted_559,
                                  (_ctx.isMaxGPA3)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_560, "(Đây là lựa chọn tốt nhất)"))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.getEnglishConvertedScoreForDisplay(_ctx.formData.methosIndustry3, 1, 3) > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_561, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input me-2",
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[175] || (_cache[175] = ($event: any) => ((_ctx.formData.isUseEnglish3) = $event)),
                                        id: "isUseEnglish3_9cr"
                                      }, null, 512), [
                                        [_vModelCheckbox, _ctx.formData.isUseEnglish3]
                                      ]),
                                      _hoisted_562
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode(_component_el_form_item, { prop: "methosIndustry3" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    "popper-class": "umt-form-dd",
                                    class: "form-select-solid w-100",
                                    placeholder: "Hình thức xét",
                                    filterable: true,
                                    modelValue: _ctx.formData.methosIndustry3,
                                    "onUpdate:modelValue": _cache[176] || (_cache[176] = ($event: any) => ((_ctx.formData.methosIndustry3) = $event)),
                                    disabled: !_ctx.isPermission,
                                    onChange: _cache[177] || (_cache[177] = ($event: any) => (_ctx.methosIndustryAutoChange($event,'3')))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allArrMethosIndustry3, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            (_ctx.getGPAForDisplay(_ctx.GPAIndustry3, _ctx.formData.methosIndustry3, 1, 3) > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_563, [
                                  _createElementVNode("div", _hoisted_564, [
                                    _createElementVNode("div", _hoisted_565, [
                                      _createElementVNode("div", _hoisted_566, [
                                        _hoisted_567,
                                        (_ctx.getConversionUsedForDisplay(_ctx.formData.methosIndustry3, 1, 3))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_568, [
                                              _createElementVNode("span", _hoisted_569, [
                                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                              ]),
                                              _createElementVNode("div", _hoisted_570, [
                                                _createElementVNode("div", null, " Đã áp dụng quy đổi điểm Tiếng Anh (" + _toDisplayString(_ctx.englishCertResult.convertedScore) + " điểm) có lợi hơn điểm thi thực tế. ", 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("strong", _hoisted_571, _toDisplayString(_ctx.getGPAForDisplay(_ctx.GPAIndustry3, _ctx.formData.methosIndustry3, 1, 3)), 1)
                                    ]),
                                    (_ctx.getIncentiveForDisplay(_ctx.GPAIndustry3, _ctx.formData.methosIndustry3, 1, 3) > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_572, [
                                          _hoisted_573,
                                          _createElementVNode("strong", _hoisted_574, "+" + _toDisplayString(_ctx.getIncentiveForDisplay(_ctx.GPAIndustry3, _ctx.formData.methosIndustry3, 1, 3)), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_575, [
                                      _createElementVNode("div", _hoisted_576, [
                                        _hoisted_577,
                                        (_ctx.isPriorityReducedForDisplay(_ctx.formData.methosIndustry3, 1, 3))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_578, [
                                              _createElementVNode("span", _hoisted_579, [
                                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                              ]),
                                              _hoisted_580
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("strong", _hoisted_581, _toDisplayString(_ctx.getPriorityForDisplay(_ctx.GPAIndustry3, _ctx.formData.methosIndustry3, 1, 3)), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_582, [
                                    _hoisted_583,
                                    _createElementVNode("span", _hoisted_584, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.getTotalForDisplay(_ctx.GPAIndustry3, _ctx.formData.methosIndustry3, 1, 3)), 1)
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.formData.methosIndustry3)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_585, [
                                  _createElementVNode("div", _hoisted_586, [
                                    (_ctx.slotTypeMismatch('subjectpoint3', _ctx.formData.methosIndustry3).length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_587, [
                                          _hoisted_588,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slotTypeMismatch('subjectpoint3', _ctx.formData.methosIndustry3), (m, mi) => {
                                            return (_openBlock(), _createElementBlock("div", { key: mi }, "• " + _toDisplayString(m), 1))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.comboBetterSuggestion(3))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_589, [
                                          _hoisted_590,
                                          _createElementVNode("span", null, [
                                            _createTextVNode("Theo học bạ, tổ hợp "),
                                            _createElementVNode("b", null, _toDisplayString(_ctx.comboBetterSuggestion(3).code), 1),
                                            _createTextVNode(" đạt "),
                                            _createElementVNode("b", null, _toDisplayString(_ctx.comboBetterSuggestion(3).score), 1),
                                            _createTextVNode(" điểm — cao hơn tổ hợp đang chọn"),
                                            (_ctx.comboBetterSuggestion(3).cur !== null)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(" (" + _toDisplayString(_ctx.comboBetterSuggestion(3).cur) + ")", 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(".")
                                          ]),
                                          (_ctx.isPermission && !_ctx.isAppraised)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: "btn btn-sm btn-light-primary py-1 px-2 ms-auto text-nowrap",
                                                onClick: _cache[178] || (_cache[178] = ($event: any) => (_ctx.applyBestCombo(3)))
                                              }, "Đổi sang " + _toDisplayString(_ctx.comboBetterSuggestion(3).code), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renderSubject(_ctx.formData.methosIndustry3), (subjectKey, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "d-flex gap-5 mb-2",
                                        key: index
                                      }, [
                                        _createElementVNode("div", _hoisted_591, [
                                          _createElementVNode("label", _hoisted_592, [
                                            _createElementVNode("span", _hoisted_593, _toDisplayString(_ctx.renderTitleSubject(subjectKey)), 1)
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.formData.subjectpoint3[index].data), (pointKey, classIndex) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: `${index}_${pointKey}`,
                                              class: "mb-2 d-flex1 w-100"
                                            }, [
                                              _createVNode(_component_el_form_item, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_input, {
                                                    type: "text",
                                                    class: "",
                                                    name: `${pointKey}_${index}_3`,
                                                    modelValue: _ctx.formData.subjectpoint3[index].data[pointKey],
                                                    "onUpdate:modelValue": ($event: any) => ((_ctx.formData.subjectpoint3[index].data[pointKey]) = $event),
                                                    onInput: ($event: any) => (_ctx.markScoreDirty('subjectpoint3', index, pointKey)),
                                                    onKeypress: _cache[179] || (_cache[179] = ($event: any) => (_ctx.isNumber($event))),
                                                    placeholder: `Điểm lớp ${10 + classIndex}`
                                                  }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onInput", "placeholder"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_594, [
                          _createElementVNode("div", _hoisted_595, [
                            _createElementVNode("div", _hoisted_596, [
                              _createElementVNode("div", _hoisted_597, [
                                _hoisted_598,
                                _createVNode(_component_el_form_item, { prop: "admissionsIndustry" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      "popper-class": "umt-form-dd",
                                      class: "form-select-solid w-100",
                                      modelValue: _ctx.formData.admissionsIndustry,
                                      "onUpdate:modelValue": _cache[180] || (_cache[180] = ($event: any) => ((_ctx.formData.admissionsIndustry) = $event)),
                                      placeholder: "Ưu tiên 1",
                                      disabled: !_ctx.isPermission,
                                      onChange: _ctx.admissionsIndustryChange,
                                      filterable: true
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajors, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.value,
                                            label: item.label,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "disabled", "onChange"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_599, [
                              _createElementVNode("div", _hoisted_600, [
                                _createElementVNode("label", _hoisted_601, [
                                  _createElementVNode("div", null, [
                                    _createTextVNode(" Hình thức xét "),
                                    (_ctx.isMaxGPA)
                                      ? (_openBlock(), _createElementBlock("i", _hoisted_602, "(Đây là lựa chọn tốt nhất)"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (_ctx.getEnglishConvertedScoreForDisplay(_ctx.formData.methosIndustry, 1, 1) > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_603, [
                                        _withDirectives(_createElementVNode("input", {
                                          class: "form-check-input me-2",
                                          type: "checkbox",
                                          "onUpdate:modelValue": _cache[181] || (_cache[181] = ($event: any) => ((_ctx.formData.isUseEnglish1) = $event)),
                                          id: "isUseEnglish1_hb"
                                        }, null, 512), [
                                          [_vModelCheckbox, _ctx.formData.isUseEnglish1]
                                        ]),
                                        _hoisted_604
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(_component_el_form_item, { prop: "methosIndustry" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      "popper-class": "umt-form-dd",
                                      class: "form-select-solid w-100",
                                      placeholder: "Hình thức xét",
                                      filterable: true,
                                      modelValue: _ctx.formData.methosIndustry,
                                      "onUpdate:modelValue": _cache[182] || (_cache[182] = ($event: any) => ((_ctx.formData.methosIndustry) = $event)),
                                      disabled: _ctx.arrMethosIndustry.length == 0 || !_ctx.isPermission
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMethosIndustry, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.value,
                                            label: item.label,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            (_ctx.getGPAForDisplay(_ctx.GPAIndustry, _ctx.formData.methosIndustry, 1, 1) > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_605, [
                                  _createElementVNode("div", _hoisted_606, [
                                    _createElementVNode("div", _hoisted_607, [
                                      _createElementVNode("div", _hoisted_608, [
                                        _hoisted_609,
                                        (_ctx.getConversionUsedForDisplay(_ctx.formData.methosIndustry, 1, 1))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_610, [
                                              _createElementVNode("span", _hoisted_611, [
                                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                              ]),
                                              _createElementVNode("div", _hoisted_612, [
                                                _createElementVNode("div", null, " Đã áp dụng quy đổi điểm Tiếng Anh (" + _toDisplayString(_ctx.englishCertResult.convertedScore) + " điểm) có lợi hơn điểm thi thực tế. ", 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("strong", _hoisted_613, _toDisplayString(_ctx.getGPAForDisplay(_ctx.GPAIndustry, _ctx.formData.methosIndustry, 1, 1)), 1)
                                    ]),
                                    (_ctx.getIncentiveForDisplay(_ctx.GPAIndustry, _ctx.formData.methosIndustry, 1, 1) > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_614, [
                                          _hoisted_615,
                                          _createElementVNode("strong", _hoisted_616, "+" + _toDisplayString(_ctx.getIncentiveForDisplay(_ctx.GPAIndustry, _ctx.formData.methosIndustry, 1, 1)), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_617, [
                                      _createElementVNode("div", _hoisted_618, [
                                        _hoisted_619,
                                        (_ctx.isPriorityReducedForDisplay(_ctx.formData.methosIndustry, 1, 1))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_620, [
                                              _createElementVNode("span", _hoisted_621, [
                                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                              ]),
                                              _hoisted_622
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("strong", _hoisted_623, _toDisplayString(_ctx.getPriorityForDisplay(_ctx.GPAIndustry, _ctx.formData.methosIndustry, 1, 1)), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_624, [
                                    _hoisted_625,
                                    _createElementVNode("span", _hoisted_626, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.getTotalForDisplay(_ctx.GPAIndustry, _ctx.formData.methosIndustry, 1, 1)), 1)
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_627, [
                            _createElementVNode("div", _hoisted_628, [
                              _createElementVNode("div", _hoisted_629, [
                                _hoisted_630,
                                _createVNode(_component_el_select, {
                                  "popper-class": "umt-form-dd",
                                  class: "form-select-solid w-100",
                                  modelValue: _ctx.formData.admissionsIndustry2,
                                  "onUpdate:modelValue": _cache[183] || (_cache[183] = ($event: any) => ((_ctx.formData.admissionsIndustry2) = $event)),
                                  placeholder: "Ưu tiên 2",
                                  disabled: !_ctx.isPermission,
                                  onChange: _ctx.admissionsIndustryChange2,
                                  filterable: true
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajors2, (major) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: major.value,
                                        label: `${major.label}`,
                                        value: major.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled", "onChange"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_631, [
                              _createElementVNode("div", _hoisted_632, [
                                _createElementVNode("label", _hoisted_633, [
                                  _createElementVNode("div", null, [
                                    _createTextVNode(" Hình thức xét "),
                                    (_ctx.isMaxGPA2)
                                      ? (_openBlock(), _createElementBlock("i", _hoisted_634, "(Đây là lựa chọn tốt nhất)"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (_ctx.getEnglishConvertedScoreForDisplay(_ctx.formData.methosIndustry2, 1, 2) > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_635, [
                                        _withDirectives(_createElementVNode("input", {
                                          class: "form-check-input me-2",
                                          type: "checkbox",
                                          "onUpdate:modelValue": _cache[184] || (_cache[184] = ($event: any) => ((_ctx.formData.isUseEnglish2) = $event)),
                                          id: "isUseEnglish2_hb"
                                        }, null, 512), [
                                          [_vModelCheckbox, _ctx.formData.isUseEnglish2]
                                        ]),
                                        _hoisted_636
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(_component_el_select, {
                                  "popper-class": "umt-form-dd",
                                  class: "form-select-solid w-100",
                                  placeholder: "Hình thức xét",
                                  filterable: true,
                                  modelValue: _ctx.formData.methosIndustry2,
                                  "onUpdate:modelValue": _cache[185] || (_cache[185] = ($event: any) => ((_ctx.formData.methosIndustry2) = $event)),
                                  disabled: _ctx.arrMethosIndustry2.length == 0 || !_ctx.isPermission
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMethosIndustry2, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled"])
                              ])
                            ]),
                            (_ctx.getGPAForDisplay(_ctx.GPAIndustry2, _ctx.formData.methosIndustry2, 1, 2) > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_637, [
                                  _createElementVNode("div", _hoisted_638, [
                                    _createElementVNode("div", _hoisted_639, [
                                      _createElementVNode("div", _hoisted_640, [
                                        _hoisted_641,
                                        (_ctx.getConversionUsedForDisplay(_ctx.formData.methosIndustry2, 1, 2))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_642, [
                                              _createElementVNode("span", _hoisted_643, [
                                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                              ]),
                                              _createElementVNode("div", _hoisted_644, [
                                                _createElementVNode("div", null, " Đã áp dụng quy đổi điểm Tiếng Anh (" + _toDisplayString(_ctx.englishCertResult.convertedScore) + " điểm) có lợi hơn điểm thi thực tế. ", 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("strong", _hoisted_645, _toDisplayString(_ctx.getGPAForDisplay(_ctx.GPAIndustry2, _ctx.formData.methosIndustry2, 1, 2)), 1)
                                    ]),
                                    (_ctx.getIncentiveForDisplay(_ctx.GPAIndustry2, _ctx.formData.methosIndustry2, 1, 2) > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_646, [
                                          _hoisted_647,
                                          _createElementVNode("strong", _hoisted_648, "+" + _toDisplayString(_ctx.getIncentiveForDisplay(_ctx.GPAIndustry2, _ctx.formData.methosIndustry2, 1, 2)), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_649, [
                                      _createElementVNode("div", _hoisted_650, [
                                        _hoisted_651,
                                        (_ctx.isPriorityReducedForDisplay(_ctx.formData.methosIndustry2, 1, 2))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_652, [
                                              _createElementVNode("span", _hoisted_653, [
                                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                              ]),
                                              _hoisted_654
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("strong", _hoisted_655, _toDisplayString(_ctx.getPriorityForDisplay(_ctx.GPAIndustry2, _ctx.formData.methosIndustry2, 1, 2)), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_656, [
                                    _hoisted_657,
                                    _createElementVNode("span", _hoisted_658, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.getTotalForDisplay(_ctx.GPAIndustry2, _ctx.formData.methosIndustry2, 1, 2)), 1)
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_659, [
                            _createElementVNode("div", _hoisted_660, [
                              _createElementVNode("div", _hoisted_661, [
                                _hoisted_662,
                                _createVNode(_component_el_select, {
                                  "popper-class": "umt-form-dd",
                                  class: "form-select-solid w-100",
                                  modelValue: _ctx.formData.admissionsIndustry3,
                                  "onUpdate:modelValue": _cache[186] || (_cache[186] = ($event: any) => ((_ctx.formData.admissionsIndustry3) = $event)),
                                  placeholder: "Ưu tiên 3",
                                  disabled: !_ctx.isPermission,
                                  onChange: _ctx.admissionsIndustryChange3,
                                  filterable: true
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajors3, (major) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: major.value,
                                        label: `${major.label}`,
                                        value: major.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled", "onChange"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_663, [
                              _createElementVNode("div", _hoisted_664, [
                                _createElementVNode("label", _hoisted_665, [
                                  _createElementVNode("div", null, [
                                    _createTextVNode(" Hình thức xét "),
                                    (_ctx.isMaxGPA3)
                                      ? (_openBlock(), _createElementBlock("i", _hoisted_666, "(Đây là lựa chọn tốt nhất)"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (_ctx.getEnglishConvertedScoreForDisplay(_ctx.formData.methosIndustry3, 1, 3) > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_667, [
                                        _withDirectives(_createElementVNode("input", {
                                          class: "form-check-input me-2",
                                          type: "checkbox",
                                          "onUpdate:modelValue": _cache[187] || (_cache[187] = ($event: any) => ((_ctx.formData.isUseEnglish3) = $event)),
                                          id: "isUseEnglish3_hb"
                                        }, null, 512), [
                                          [_vModelCheckbox, _ctx.formData.isUseEnglish3]
                                        ]),
                                        _hoisted_668
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(_component_el_select, {
                                  "popper-class": "umt-form-dd",
                                  class: "form-select-solid w-100",
                                  placeholder: "Hình thức xét",
                                  filterable: true,
                                  modelValue: _ctx.formData.methosIndustry3,
                                  "onUpdate:modelValue": _cache[188] || (_cache[188] = ($event: any) => ((_ctx.formData.methosIndustry3) = $event)),
                                  disabled: _ctx.arrMethosIndustry3.length == 0 || !_ctx.isPermission
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMethosIndustry3, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled"])
                              ])
                            ]),
                            (_ctx.getGPAForDisplay(_ctx.GPAIndustry3, _ctx.formData.methosIndustry3, 1, 3) > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_669, [
                                  _createElementVNode("div", _hoisted_670, [
                                    _createElementVNode("div", _hoisted_671, [
                                      _createElementVNode("div", _hoisted_672, [
                                        _hoisted_673,
                                        (_ctx.getConversionUsedForDisplay(_ctx.formData.methosIndustry3, 1, 3))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_674, [
                                              _createElementVNode("span", _hoisted_675, [
                                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                              ]),
                                              _createElementVNode("div", _hoisted_676, [
                                                _createElementVNode("div", null, " Đã áp dụng quy đổi điểm Tiếng Anh (" + _toDisplayString(_ctx.englishCertResult.convertedScore) + " điểm) có lợi hơn điểm thi thực tế. ", 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("strong", _hoisted_677, _toDisplayString(_ctx.getGPAForDisplay(_ctx.GPAIndustry3, _ctx.formData.methosIndustry3, 1, 3)), 1)
                                    ]),
                                    (_ctx.getIncentiveForDisplay(_ctx.GPAIndustry3, _ctx.formData.methosIndustry3, 1, 3) > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_678, [
                                          _hoisted_679,
                                          _createElementVNode("strong", _hoisted_680, "+" + _toDisplayString(_ctx.getIncentiveForDisplay(_ctx.GPAIndustry3, _ctx.formData.methosIndustry3, 1, 3)), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_681, [
                                      _createElementVNode("div", _hoisted_682, [
                                        _hoisted_683,
                                        (_ctx.isPriorityReducedForDisplay(_ctx.formData.methosIndustry3, 1, 3))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_684, [
                                              _createElementVNode("span", _hoisted_685, [
                                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                              ]),
                                              _hoisted_686
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("strong", _hoisted_687, _toDisplayString(_ctx.getPriorityForDisplay(_ctx.GPAIndustry3, _ctx.formData.methosIndustry3, 1, 3)), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_688, [
                                    _hoisted_689,
                                    _createElementVNode("span", _hoisted_690, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.getTotalForDisplay(_ctx.GPAIndustry3, _ctx.formData.methosIndustry3, 1, 3)), 1)
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.method == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_691, [
                    _hoisted_692,
                    _createElementVNode("div", _hoisted_693, [
                      _createElementVNode("div", _hoisted_694, [
                        _hoisted_695,
                        _createVNode(_component_el_form_item, { prop: "aptitudeTest" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_696, [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.aptitudeTest,
                                "onUpdate:modelValue": _cache[189] || (_cache[189] = ($event: any) => ((_ctx.formData.aptitudeTest) = $event)),
                                class: "w-200px",
                                type: "text",
                                onKeypress: _cache[190] || (_cache[190] = ($event: any) => (_ctx.isNumber($event))),
                                disabled: !_ctx.isPermission,
                                placeholder: "Điểm thi"
                              }, null, 8, ["modelValue", "disabled"]),
                              (_ctx.formData.aptitudeTest)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_697, [
                                    _createTextVNode("Quy đổi (Thang điểm 30): "),
                                    _createElementVNode("span", _hoisted_698, _toDisplayString((_ctx.formData.aptitudeTest*30/1200).toFixed(1)), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      (_ctx.formData.aptitudeTest)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_699, [
                            _createElementVNode("div", _hoisted_700, [
                              _createElementVNode("div", _hoisted_701, [
                                _hoisted_702,
                                _createElementVNode("strong", _hoisted_703, _toDisplayString(_ctx.GPAIndustryDGNL), 1)
                              ]),
                              _createElementVNode("div", _hoisted_704, [
                                _createElementVNode("div", _hoisted_705, [
                                  _hoisted_706,
                                  (_ctx.GPAIndustryDGNL + _ctx.certIncentiveResult.total >= 22.5)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_707, [
                                        _createElementVNode("span", _hoisted_708, [
                                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                        ]),
                                        _hoisted_709
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("strong", _hoisted_710, _toDisplayString(_ctx.cacuPointPriority(_ctx.GPAIndustryDGNL + _ctx.certIncentiveResult.total).toFixed(2)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_711, [
                                _hoisted_712,
                                _createElementVNode("strong", _hoisted_713, "+" + _toDisplayString(_ctx.certIncentiveResult.total), 1)
                              ]),
                              _hoisted_714,
                              _createElementVNode("div", _hoisted_715, [
                                _hoisted_716,
                                _createElementVNode("span", _hoisted_717, [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.totalScoreDGNL), 1)
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_718,
                    _createElementVNode("div", _hoisted_719, [
                      _createElementVNode("div", _hoisted_720, [
                        _hoisted_721,
                        _createVNode(_component_el_form_item, { prop: "majorForAptitudeTest" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "form-select-solid w-100",
                              modelValue: _ctx.formData.majorForAptitudeTest,
                              "onUpdate:modelValue": _cache[191] || (_cache[191] = ($event: any) => ((_ctx.formData.majorForAptitudeTest) = $event)),
                              onChange: _ctx.majorForAptitudeTestChange,
                              disabled: !_ctx.isPermission,
                              filterable: true,
                              placeholder: "Ưu tiên 1"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajors, (major) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: major.value,
                                    label: `${major.label}`,
                                    value: major.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_722, [
                        _hoisted_723,
                        _createVNode(_component_el_form_item, { prop: "majorForAptitudeTest2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "form-select-solid w-100",
                              modelValue: _ctx.formData.majorForAptitudeTest2,
                              "onUpdate:modelValue": _cache[192] || (_cache[192] = ($event: any) => ((_ctx.formData.majorForAptitudeTest2) = $event)),
                              onChange: _ctx.majorForAptitudeTestChange2,
                              disabled: !_ctx.isPermission,
                              filterable: true,
                              placeholder: "Ưu tiên 2"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajorsForAptitudeTest2, (major) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: major.value,
                                    label: `${major.label}`,
                                    value: major.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_724, [
                        _hoisted_725,
                        _createVNode(_component_el_form_item, { prop: "majorForAptitudeTest3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "form-select-solid w-100",
                              modelValue: _ctx.formData.majorForAptitudeTest3,
                              "onUpdate:modelValue": _cache[193] || (_cache[193] = ($event: any) => ((_ctx.formData.majorForAptitudeTest3) = $event)),
                              filterable: true,
                              disabled: !_ctx.isPermission,
                              placeholder: "Ưu tiên 3"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajorsForAptitudeTest3, (major) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: major.value,
                                    label: `${major.label}`,
                                    value: major.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.method == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_726, [
                    _hoisted_727,
                    _createElementVNode("div", _hoisted_728, [
                      _createElementVNode("div", _hoisted_729, [
                        _createElementVNode("label", _hoisted_730, [
                          _createElementVNode("span", _hoisted_731, [
                            _createVNode(_component_el_radio, {
                              class: "",
                              modelValue: _ctx.formData.typeIsCert,
                              "onUpdate:modelValue": _cache[194] || (_cache[194] = ($event: any) => ((_ctx.formData.typeIsCert) = $event)),
                              onChange: _ctx.typeIsCertChange,
                              value: "isEnglishCertificate",
                              id: "isEnglishCertificate",
                              label: "isEnglishCertificate",
                              disabled: _ctx.isEdit || !_ctx.isPermission
                            }, null, 8, ["modelValue", "onChange", "disabled"]),
                            _hoisted_732
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["row ms-7", _ctx.formData.typeIsCert == 'isEnglishCertificate' ? '' : 'hide'])
                        }, [
                          _createElementVNode("div", _hoisted_733, [
                            _hoisted_734,
                            _createElementVNode("div", _hoisted_735, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    placeholder: "IELTS",
                                    modelValue: _ctx.formData.ielts,
                                    "onUpdate:modelValue": _cache[195] || (_cache[195] = ($event: any) => ((_ctx.formData.ielts) = $event)),
                                    disabled: _ctx.isEdit || !_ctx.isPermission,
                                    onKeypress: _cache[196] || (_cache[196] = ($event: any) => (_ctx.isNumber($event)))
                                  }, null, 8, ["modelValue", "disabled"])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_736, [
                            _hoisted_737,
                            _createElementVNode("div", _hoisted_738, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    placeholder: "TOEFL",
                                    modelValue: _ctx.formData.toefl,
                                    "onUpdate:modelValue": _cache[197] || (_cache[197] = ($event: any) => ((_ctx.formData.toefl) = $event)),
                                    disabled: _ctx.isEdit || !_ctx.isPermission,
                                    onKeypress: _cache[198] || (_cache[198] = ($event: any) => (_ctx.isNumber($event)))
                                  }, null, 8, ["modelValue", "disabled"])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_739, [
                            _hoisted_740,
                            _createElementVNode("div", _hoisted_741, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    placeholder: "TOEIC",
                                    modelValue: _ctx.formData.toeic,
                                    "onUpdate:modelValue": _cache[199] || (_cache[199] = ($event: any) => ((_ctx.formData.toeic) = $event)),
                                    disabled: _ctx.isEdit || !_ctx.isPermission,
                                    onKeypress: _cache[200] || (_cache[200] = ($event: any) => (_ctx.isNumber($event)))
                                  }, null, 8, ["modelValue", "disabled"])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_742, [
                            _hoisted_743,
                            _createElementVNode("div", _hoisted_744, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    type: "text",
                                    placeholder: "sat",
                                    modelValue: _ctx.formData.sat,
                                    "onUpdate:modelValue": _cache[201] || (_cache[201] = ($event: any) => ((_ctx.formData.sat) = $event)),
                                    disabled: _ctx.isEdit || !_ctx.isPermission,
                                    onKeypress: _cache[202] || (_cache[202] = ($event: any) => (_ctx.isNumber($event)))
                                  }, null, 8, ["modelValue", "disabled"])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_745, [
                        _createElementVNode("label", _hoisted_746, [
                          _createElementVNode("span", _hoisted_747, [
                            _createVNode(_component_el_radio, {
                              class: "",
                              modelValue: _ctx.formData.typeIsCert,
                              "onUpdate:modelValue": _cache[203] || (_cache[203] = ($event: any) => ((_ctx.formData.typeIsCert) = $event)),
                              onChange: _ctx.typeIsCertChange,
                              value: "isCollegeOrInterDegree",
                              id: "isCollegeOrInterDegree",
                              disabled: _ctx.isEdit || !_ctx.isPermission,
                              label: "isCollegeOrInterDegree"
                            }, null, 8, ["modelValue", "onChange", "disabled"]),
                            _hoisted_748
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_749, [
                        _createElementVNode("label", _hoisted_750, [
                          _createElementVNode("span", _hoisted_751, [
                            _createVNode(_component_el_radio, {
                              class: "",
                              modelValue: _ctx.formData.typeIsCert,
                              "onUpdate:modelValue": _cache[204] || (_cache[204] = ($event: any) => ((_ctx.formData.typeIsCert) = $event)),
                              onChange: _ctx.typeIsCertChange,
                              value: "isInternationalCertificate",
                              id: "isInternationalCertificate",
                              disabled: _ctx.isEdit || !_ctx.isPermission,
                              label: "isInternationalCertificate"
                            }, null, 8, ["modelValue", "onChange", "disabled"]),
                            _hoisted_752
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_753, [
                        _createElementVNode("label", _hoisted_754, [
                          _createElementVNode("span", _hoisted_755, [
                            _createVNode(_component_el_radio, {
                              class: "",
                              modelValue: _ctx.formData.typeIsCert,
                              "onUpdate:modelValue": _cache[205] || (_cache[205] = ($event: any) => ((_ctx.formData.typeIsCert) = $event)),
                              onChange: _ctx.typeIsCertChange,
                              value: "isAthleteCertOrPreMaster",
                              id: "isAthleteCertOrPreMaster",
                              disabled: _ctx.isEdit || !_ctx.isPermission,
                              label: "isAthleteCertOrPreMaster"
                            }, null, 8, ["modelValue", "onChange", "disabled"]),
                            _hoisted_756
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_757, [
                        _createElementVNode("label", _hoisted_758, [
                          _createElementVNode("span", _hoisted_759, [
                            _createVNode(_component_el_radio, {
                              class: "",
                              modelValue: _ctx.formData.typeIsCert,
                              "onUpdate:modelValue": _cache[206] || (_cache[206] = ($event: any) => ((_ctx.formData.typeIsCert) = $event)),
                              onChange: _ctx.typeIsCertChange,
                              value: "isPrize",
                              id: "isPrize",
                              disabled: _ctx.isEdit || !_ctx.isPermission,
                              label: "isPrize"
                            }, null, 8, ["modelValue", "onChange", "disabled"]),
                            _hoisted_760
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_761, [
                        _createElementVNode("label", _hoisted_762, [
                          _createElementVNode("span", _hoisted_763, [
                            _createVNode(_component_el_radio, {
                              class: "",
                              modelValue: _ctx.formData.typeIsCert,
                              "onUpdate:modelValue": _cache[207] || (_cache[207] = ($event: any) => ((_ctx.formData.typeIsCert) = $event)),
                              value: "isGoodStanding",
                              onChange: _ctx.typeIsCertChange,
                              id: "isGoodStanding",
                              disabled: !_ctx.isPermission,
                              label: "isGoodStanding"
                            }, null, 8, ["modelValue", "onChange", "disabled"]),
                            _hoisted_764
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_765,
                    _createElementVNode("div", _hoisted_766, [
                      _createElementVNode("div", _hoisted_767, [
                        _hoisted_768,
                        _createVNode(_component_el_form_item, { prop: "majorForUmt" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "form-select-solid w-100",
                              modelValue: _ctx.formData.majorForUmt,
                              "onUpdate:modelValue": _cache[208] || (_cache[208] = ($event: any) => ((_ctx.formData.majorForUmt) = $event)),
                              onChange: _ctx.majorForUmtChange,
                              disabled: !_ctx.isPermission,
                              filterable: true,
                              placeholder: "Ưu tiên 1"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajorsForUmt, (major) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: major.value,
                                    label: `${major.label}`,
                                    value: major.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_769, [
                        _hoisted_770,
                        _createVNode(_component_el_form_item, { prop: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "form-select-solid w-100",
                              modelValue: _ctx.formData.majorForUmt2,
                              "onUpdate:modelValue": _cache[209] || (_cache[209] = ($event: any) => ((_ctx.formData.majorForUmt2) = $event)),
                              onChange: _ctx.majorForUmtChange2,
                              disabled: !_ctx.isPermission,
                              filterable: true,
                              placeholder: "Ưu tiên 2"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajorsForUmt2, (major) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: major.value,
                                    label: `${major.label}`,
                                    value: major.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_771, [
                        _hoisted_772,
                        _createVNode(_component_el_form_item, { prop: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "form-select-solid w-100",
                              modelValue: _ctx.formData.majorForUmt3,
                              "onUpdate:modelValue": _cache[210] || (_cache[210] = ($event: any) => ((_ctx.formData.majorForUmt3) = $event)),
                              disabled: !_ctx.isPermission,
                              filterable: true,
                              placeholder: "Ưu tiên 3"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajorsForUmt3, (major) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: major.value,
                                    label: `${major.label}`,
                                    value: major.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.method == 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_773, [
                    _createElementVNode("div", _hoisted_774, [
                      _createElementVNode("div", _hoisted_775, [
                        _hoisted_776,
                        _createElementVNode("div", _hoisted_777, [
                          _createElementVNode("div", _hoisted_778, [
                            _createElementVNode("div", _hoisted_779, [
                              _hoisted_780,
                              _createVNode(_component_el_select, {
                                "popper-class": "umt-form-dd",
                                modelValue: _ctx.formData.formOfMethodMethod5,
                                "onUpdate:modelValue": _cache[211] || (_cache[211] = ($event: any) => ((_ctx.formData.formOfMethodMethod5) = $event)),
                                placeholder: "Chọn tiêu chí",
                                class: "w-100",
                                size: "large",
                                disabled: (_ctx.isEdit && _ctx.formData.pt5CriteriaLocked === true) || !_ctx.isPermission,
                                onChange: _ctx.resetValuesPt05
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "Xét tuyển theo chứng chỉ SAT",
                                    value: "SAT"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Xét tuyển theo chứng chỉ ACT",
                                    value: "ACT"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Xét tuyển tốt nghiệp trung cấp trở lên",
                                    value: "TC01"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled", "onChange"])
                            ]),
                            (_ctx.formData.formOfMethodMethod5 === 'SAT')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_781, [
                                  _hoisted_782,
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.sat,
                                    "onUpdate:modelValue": _cache[212] || (_cache[212] = ($event: any) => ((_ctx.formData.sat) = $event)),
                                    placeholder: "Nhập điểm SAT (1000 - 1600)",
                                    size: "large",
                                    onKeypress: _cache[213] || (_cache[213] = ($event: any) => (_ctx.isNumber($event))),
                                    disabled: !_ctx.isPermission
                                  }, null, 8, ["modelValue", "disabled"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.formData.formOfMethodMethod5 === 'ACT')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_783, [
                                  _hoisted_784,
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.actScore,
                                    "onUpdate:modelValue": _cache[214] || (_cache[214] = ($event: any) => ((_ctx.formData.actScore) = $event)),
                                    placeholder: "Nhập điểm ACT (18 - 36)",
                                    size: "large",
                                    onKeypress: _cache[215] || (_cache[215] = ($event: any) => (_ctx.isNumber($event))),
                                    disabled: !_ctx.isPermission
                                  }, null, 8, ["modelValue", "disabled"])
                                ]))
                              : _createCommentVNode("", true),
                            (['SAT', 'ACT'].includes(_ctx.formData.formOfMethodMethod5))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_785, [
                                  _hoisted_786,
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: _ctx.formData.satDate,
                                    "onUpdate:modelValue": _cache[216] || (_cache[216] = ($event: any) => ((_ctx.formData.satDate) = $event)),
                                    type: "date",
                                    placeholder: "Chọn ngày",
                                    class: "w-100",
                                    size: "large",
                                    format: "DD/MM/YYYY",
                                    disabled: !_ctx.isPermission
                                  }, null, 8, ["modelValue", "disabled"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      (_ctx.formData.formOfMethodMethod5 === 'TC01')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_787, [
                            _createElementVNode("div", _hoisted_788, [
                              _hoisted_789,
                              _createElementVNode("div", _hoisted_790, [
                                _createVNode(_component_el_radio, {
                                  modelValue: _ctx.formData.tcCriteria,
                                  "onUpdate:modelValue": _cache[217] || (_cache[217] = ($event: any) => ((_ctx.formData.tcCriteria) = $event)),
                                  label: "1",
                                  disabled: _ctx.isEdit || !_ctx.isPermission,
                                  onChange: _ctx.resetValuesTcCriteria
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Tiêu chí 1: Xét điểm TBC 03 môn văn hóa THPT ")
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled", "onChange"]),
                                _hoisted_791,
                                _createVNode(_component_el_radio, {
                                  modelValue: _ctx.formData.tcCriteria,
                                  "onUpdate:modelValue": _cache[218] || (_cache[218] = ($event: any) => ((_ctx.formData.tcCriteria) = $event)),
                                  label: "2",
                                  disabled: _ctx.isEdit || !_ctx.isPermission,
                                  onChange: _ctx.resetValuesTcCriteria
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Tiêu chí 2: Xét tuyển bằng điểm trung bình cả năm lớp 12 tổ hợp 3 môn ")
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled", "onChange"])
                              ])
                            ]),
                            (_ctx.formData.tcCriteria)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_792, [
                                  _createElementVNode("h6", _hoisted_793, _toDisplayString(_ctx.formData.tcCriteria === '1' ? 'Nhập điểm TBC của ít nhất 03 môn học (tối đa 12):' : 'Nhập điểm trung bình môn học lớp 12:'), 1),
                                  _createElementVNode("div", _hoisted_794, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['mathTHPT', 'physicsTHPT', 'chemistryTHPT', 'englishTHPT', 'frenchTHPT', 'literatureTHPT', 'historyTHPT', 'geographyTHPT', 'biologicalTHPT', 'informationTechnologyTHPT', 'artTHPT', 'economicsAndLawEducationTHPT'], (sub) => {
                                      return _createElementVNode("div", {
                                        class: "fv-row mb-2",
                                        key: sub,
                                        style: {"width":"16.66%","min-width":"120px"}
                                      }, [
                                        _createElementVNode("label", _hoisted_795, _toDisplayString(_ctx.renderTitleSubject(sub)), 1),
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.formData['pt05' + sub],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.formData['pt05' + sub]) = $event),
                                          type: "text",
                                          size: "small",
                                          onKeypress: _cache[219] || (_cache[219] = ($event: any) => (_ctx.isNumber($event))),
                                          disabled: !_ctx.isPermission,
                                          placeholder: "Điểm THPT",
                                          onChange: _ctx.methosIndustryAutoChangeTHPT
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                                      ])
                                    }), 64))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.formData.formOfMethodMethod5)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_796, [
                            _hoisted_797,
                            _hoisted_798,
                            (_ctx.missingComboScores.length)
                              ? (_openBlock(), _createBlock(_component_el_alert, {
                                  key: 0,
                                  type: "warning",
                                  closable: false,
                                  class: "umt-warn-banner mb-4 mt-3"
                                }, {
                                  title: _withCtx(() => [
                                    _hoisted_799,
                                    _hoisted_800,
                                    _createTextVNode(" tổ hợp ở " + _toDisplayString(_ctx.missingComboScores.join(', ')) + " chưa nhập đủ điểm các môn — hồ sơ vẫn lưu được nhưng chưa tính được điểm xét tuyển.", 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              class: _normalizeClass(_ctx.pt5IsSatAct ? 'row mt-4 g-4' : '')
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(_ctx.pt5IsSatAct ? 'col-md-4' : 'row mt-4 align-items-start')
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(_ctx.pt5IsSatAct ? 'mb-4' : 'col-md-4 mb-4')
                                }, [
                                  _hoisted_801,
                                  _createVNode(_component_el_form_item, { prop: "admissionsIndustryTHPT" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        "popper-class": "umt-form-dd",
                                        modelValue: _ctx.formData.admissionsIndustryTHPT,
                                        "onUpdate:modelValue": _cache[220] || (_cache[220] = ($event: any) => ((_ctx.formData.admissionsIndustryTHPT) = $event)),
                                        placeholder: "Chọn ngành",
                                        class: "w-100",
                                        disabled: !_ctx.isPermission,
                                        onChange: _ctx.admissionsIndustryChangeTHPT,
                                        filterable: ""
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajors, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.value,
                                              label: item.label,
                                              value: item.value
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "disabled", "onChange"])
                                    ]),
                                    _: 1
                                  })
                                ], 2),
                                (_ctx.formData.formOfMethodMethod5 === 'TC01')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_802, [
                                      _createElementVNode("label", _hoisted_803, [
                                        _createElementVNode("div", null, [
                                          _createTextVNode(" Hình thức xét "),
                                          (_ctx.isMaxGPATHPT)
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_804, "(Đây là lựa chọn tốt nhất)"))
                                            : _createCommentVNode("", true)
                                        ]),
                                        (_ctx.getEnglishConvertedScoreForDisplay(_ctx.formData.methosIndustryTHPT, 5, 1) > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_805, [
                                              _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input me-2",
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[221] || (_cache[221] = ($event: any) => ((_ctx.formData.isUseEnglish1) = $event)),
                                                id: "isUseEnglish1_tc01"
                                              }, null, 512), [
                                                [_vModelCheckbox, _ctx.formData.isUseEnglish1]
                                              ]),
                                              _hoisted_806
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createVNode(_component_el_form_item, { prop: "methosIndustryTHPT" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            "popper-class": "umt-form-dd",
                                            modelValue: _ctx.formData.methosIndustryTHPT,
                                            "onUpdate:modelValue": _cache[222] || (_cache[222] = ($event: any) => ((_ctx.formData.methosIndustryTHPT) = $event)),
                                            placeholder: "Chọn hình thức",
                                            class: "w-100",
                                            disabled: !_ctx.isPermission || _ctx.arrMethosIndustryTHPT.length==0 || !_ctx.formData.admissionsIndustryTHPT,
                                            onChange: _ctx.methosIndustryManualChangeTHPT
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMethosIndustryTHPT, (m) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: m.value,
                                                  label: m.label,
                                                  value: m.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue", "disabled", "onChange"])
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.formData.admissionsIndustryTHPT && (_ctx.formData.formOfMethodMethod5 !== 'TC01' || _ctx.formData.methosIndustryTHPT))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: _normalizeClass(_ctx.pt5IsSatAct ? 'mb-4 text-left' : 'col-md-3 mb-4 text-left')
                                    }, [
                                      _createElementVNode("div", _hoisted_807, [
                                        (_ctx.formData.formOfMethodMethod5 === 'TC01')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createElementVNode("div", _hoisted_808, [
                                                _createElementVNode("div", _hoisted_809, [
                                                  _hoisted_810,
                                                  (_ctx.getConversionUsedForDisplay(_ctx.formData.methosIndustryTHPT, 5, 1))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_811, [
                                                        _createElementVNode("span", _hoisted_812, [
                                                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                                        ]),
                                                        _createElementVNode("div", _hoisted_813, [
                                                          _createElementVNode("div", null, " Đã áp dụng quy đổi điểm Tiếng Anh (" + _toDisplayString(_ctx.englishCertResult.convertedScore) + " điểm) có lợi hơn điểm thi thực tế. ", 1)
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("strong", _hoisted_814, _toDisplayString(_ctx.getGPAForDisplay(_ctx.GPAIndustryTHPT, _ctx.formData.methosIndustryTHPT, 5, 1)), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_815, [
                                                _createElementVNode("div", _hoisted_816, [
                                                  _hoisted_817,
                                                  (_ctx.isPriorityReducedForDisplay(_ctx.formData.methosIndustryTHPT, 5, 1))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_818, [
                                                        _createElementVNode("span", _hoisted_819, [
                                                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                                        ]),
                                                        _hoisted_820
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("strong", _hoisted_821, _toDisplayString(_ctx.getPriorityForDisplay(_ctx.GPAIndustryTHPT, _ctx.formData.methosIndustryTHPT, 5, 1)), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_822, [
                                                _hoisted_823,
                                                _createElementVNode("strong", _hoisted_824, "+" + _toDisplayString(_ctx.getIncentiveForDisplay(_ctx.GPAIndustryTHPT, _ctx.formData.methosIndustryTHPT, 5, 1)), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_825, [
                                                _hoisted_826,
                                                _createElementVNode("span", _hoisted_827, [
                                                  _createElementVNode("strong", null, _toDisplayString(_ctx.getTotalForDisplay(_ctx.GPAIndustryTHPT, _ctx.formData.methosIndustryTHPT, 5, 1)), 1)
                                                ])
                                              ]),
                                              (_ctx.formData.tcCriteria === '2')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_828, " (TBC cả năm lớp 12: " + _toDisplayString(_ctx.calculatedAvgGrade12) + ") ", 1))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createElementVNode("div", _hoisted_829, [
                                                _hoisted_830,
                                                _createElementVNode("strong", _hoisted_831, _toDisplayString((_ctx.formData.formOfMethodMethod5 === 'SAT' ? (+_ctx.formData.sat*30/1600).toFixed(2) : (+_ctx.formData.actScore*30/36).toFixed(2))), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_832, [
                                                _hoisted_833,
                                                _createElementVNode("strong", _hoisted_834, _toDisplayString(_ctx.cacuPointPriority((_ctx.formData.formOfMethodMethod5 === 'SAT' ? +_ctx.formData.sat*30/1600 : +_ctx.formData.actScore*30/36) + _ctx.certIncentiveResult.total).toFixed(2)), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_835, [
                                                _hoisted_836,
                                                _createElementVNode("strong", _hoisted_837, "+" + _toDisplayString(_ctx.certIncentiveResult.total), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_838, [
                                                _hoisted_839,
                                                _createElementVNode("span", _hoisted_840, [
                                                  _createElementVNode("strong", null, _toDisplayString(((_ctx.formData.formOfMethodMethod5 === 'SAT' ? +_ctx.formData.sat*30/1600 : +_ctx.formData.actScore*30/36) + _ctx.certIncentiveResult.total + _ctx.cacuPointPriority((_ctx.formData.formOfMethodMethod5 === 'SAT' ? +_ctx.formData.sat*30/1600 : +_ctx.formData.actScore*30/36) + _ctx.certIncentiveResult.total)).toFixed(2)), 1)
                                                ])
                                              ])
                                            ], 64))
                                      ])
                                    ], 2))
                                  : _createCommentVNode("", true)
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass([_ctx.pt5IsSatAct ? 'col-md-4' : 'row align-items-start border-top pt-4', _ctx.formData.admissionsIndustryTHPT?'':'disabled'])
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(_ctx.pt5IsSatAct ? 'mb-4' : 'col-md-4 mb-4')
                                }, [
                                  _hoisted_841,
                                  _createVNode(_component_el_select, {
                                    "popper-class": "umt-form-dd",
                                    modelValue: _ctx.formData.admissionsIndustryTHPT2,
                                    "onUpdate:modelValue": _cache[223] || (_cache[223] = ($event: any) => ((_ctx.formData.admissionsIndustryTHPT2) = $event)),
                                    placeholder: "Chọn ngành",
                                    class: "w-100",
                                    disabled: !_ctx.isPermission || !_ctx.formData.admissionsIndustryTHPT,
                                    onChange: _ctx.admissionsIndustryChangeTHPT2,
                                    filterable: ""
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajorsTHPT2, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "disabled", "onChange"])
                                ], 2),
                                (_ctx.formData.formOfMethodMethod5 === 'TC01')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_842, [
                                      _createElementVNode("label", _hoisted_843, [
                                        _createElementVNode("div", null, [
                                          _createTextVNode(" Hình thức xét "),
                                          (_ctx.isMaxGPATHPT2)
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_844, "(Đây là lựa chọn tốt nhất)"))
                                            : _createCommentVNode("", true)
                                        ]),
                                        (_ctx.getEnglishConvertedScoreForDisplay(_ctx.formData.methosIndustryTHPT2, 5, 2) > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_845, [
                                              _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input me-2",
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[224] || (_cache[224] = ($event: any) => ((_ctx.formData.isUseEnglish2) = $event)),
                                                id: "isUseEnglish2_tc01"
                                              }, null, 512), [
                                                [_vModelCheckbox, _ctx.formData.isUseEnglish2]
                                              ]),
                                              _hoisted_846
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createVNode(_component_el_select, {
                                        "popper-class": "umt-form-dd",
                                        modelValue: _ctx.formData.methosIndustryTHPT2,
                                        "onUpdate:modelValue": _cache[225] || (_cache[225] = ($event: any) => ((_ctx.formData.methosIndustryTHPT2) = $event)),
                                        placeholder: "Chọn hình thức",
                                        class: "w-100",
                                        disabled: !_ctx.isPermission || _ctx.arrMethosIndustryTHPT2.length==0 || !_ctx.formData.admissionsIndustryTHPT2,
                                        onChange: _ctx.methosIndustryManualChangeTHPT
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMethosIndustryTHPT2, (m) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: m.value,
                                              label: m.label,
                                              value: m.value
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "disabled", "onChange"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.formData.admissionsIndustryTHPT2 && (_ctx.formData.formOfMethodMethod5 !== 'TC01' || _ctx.formData.methosIndustryTHPT2))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: _normalizeClass(_ctx.pt5IsSatAct ? 'mb-4 text-left' : 'col-md-3 mb-4 text-left')
                                    }, [
                                      _createElementVNode("div", _hoisted_847, [
                                        (_ctx.formData.formOfMethodMethod5 === 'TC01')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createElementVNode("div", _hoisted_848, [
                                                _createElementVNode("div", _hoisted_849, [
                                                  _hoisted_850,
                                                  (_ctx.getConversionUsedForDisplay(_ctx.formData.methosIndustryTHPT2, 5, 2))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_851, [
                                                        _createElementVNode("span", _hoisted_852, [
                                                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                                        ]),
                                                        _createElementVNode("div", _hoisted_853, [
                                                          _createElementVNode("div", null, " Đã áp dụng quy đổi điểm Tiếng Anh (" + _toDisplayString(_ctx.englishCertResult.convertedScore) + " điểm) có lợi hơn điểm thi thực tế. ", 1)
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("strong", _hoisted_854, _toDisplayString(_ctx.getGPAForDisplay(_ctx.GPAIndustryTHPT2, _ctx.formData.methosIndustryTHPT2, 5, 2)), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_855, [
                                                _createElementVNode("div", _hoisted_856, [
                                                  _hoisted_857,
                                                  (_ctx.isPriorityReducedForDisplay(_ctx.formData.methosIndustryTHPT2, 5, 2))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_858, [
                                                        _createElementVNode("span", _hoisted_859, [
                                                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                                        ]),
                                                        _hoisted_860
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("strong", _hoisted_861, _toDisplayString(_ctx.getPriorityForDisplay(_ctx.GPAIndustryTHPT2, _ctx.formData.methosIndustryTHPT2, 5, 2)), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_862, [
                                                _hoisted_863,
                                                _createElementVNode("strong", _hoisted_864, "+" + _toDisplayString(_ctx.getIncentiveForDisplay(_ctx.GPAIndustryTHPT2, _ctx.formData.methosIndustryTHPT2, 5, 2)), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_865, [
                                                _hoisted_866,
                                                _createElementVNode("span", _hoisted_867, [
                                                  _createElementVNode("strong", null, _toDisplayString(_ctx.getTotalForDisplay(_ctx.GPAIndustryTHPT2, _ctx.formData.methosIndustryTHPT2, 5, 2)), 1)
                                                ])
                                              ])
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createElementVNode("div", _hoisted_868, [
                                                _hoisted_869,
                                                _createElementVNode("strong", _hoisted_870, _toDisplayString((_ctx.formData.formOfMethodMethod5 === 'SAT' ? (+_ctx.formData.sat*30/1600).toFixed(2) : (+_ctx.formData.actScore*30/36).toFixed(2))), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_871, [
                                                _hoisted_872,
                                                _createElementVNode("strong", _hoisted_873, _toDisplayString(_ctx.cacuPointPriority((_ctx.formData.formOfMethodMethod5 === 'SAT' ? +_ctx.formData.sat*30/1600 : +_ctx.formData.actScore*30/36) + _ctx.certIncentiveResult.total).toFixed(2)), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_874, [
                                                _hoisted_875,
                                                _createElementVNode("strong", _hoisted_876, "+" + _toDisplayString(_ctx.certIncentiveResult.total), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_877, [
                                                _hoisted_878,
                                                _createElementVNode("span", _hoisted_879, [
                                                  _createElementVNode("strong", null, _toDisplayString(((_ctx.formData.formOfMethodMethod5 === 'SAT' ? +_ctx.formData.sat*30/1600 : +_ctx.formData.actScore*30/36) + _ctx.certIncentiveResult.total + _ctx.cacuPointPriority((_ctx.formData.formOfMethodMethod5 === 'SAT' ? +_ctx.formData.sat*30/1600 : +_ctx.formData.actScore*30/36) + _ctx.certIncentiveResult.total)).toFixed(2)), 1)
                                                ])
                                              ])
                                            ], 64))
                                      ])
                                    ], 2))
                                  : _createCommentVNode("", true)
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass([_ctx.pt5IsSatAct ? 'col-md-4' : 'row align-items-start border-top pt-4', _ctx.formData.admissionsIndustryTHPT2?'':'disabled'])
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(_ctx.pt5IsSatAct ? 'mb-4' : 'col-md-4 mb-4')
                                }, [
                                  _hoisted_880,
                                  _createVNode(_component_el_select, {
                                    "popper-class": "umt-form-dd",
                                    modelValue: _ctx.formData.admissionsIndustryTHPT3,
                                    "onUpdate:modelValue": _cache[226] || (_cache[226] = ($event: any) => ((_ctx.formData.admissionsIndustryTHPT3) = $event)),
                                    placeholder: "Chọn ngành",
                                    class: "w-100",
                                    disabled: !_ctx.isPermission || !_ctx.formData.admissionsIndustryTHPT2,
                                    onChange: _ctx.admissionsIndustryChangeTHPT3,
                                    filterable: ""
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMajorsTHPT3, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "disabled", "onChange"])
                                ], 2),
                                (_ctx.formData.formOfMethodMethod5 === 'TC01')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_881, [
                                      _createElementVNode("label", _hoisted_882, [
                                        _createElementVNode("div", null, [
                                          _createTextVNode(" Hình thức xét "),
                                          (_ctx.isMaxGPATHPT3)
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_883, "(Đây là lựa chọn tốt nhất)"))
                                            : _createCommentVNode("", true)
                                        ]),
                                        (_ctx.getEnglishConvertedScoreForDisplay(_ctx.formData.methosIndustryTHPT3, 5, 3) > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_884, [
                                              _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input me-2",
                                                type: "checkbox",
                                                "onUpdate:modelValue": _cache[227] || (_cache[227] = ($event: any) => ((_ctx.formData.isUseEnglish3) = $event)),
                                                id: "isUseEnglish3_tc01"
                                              }, null, 512), [
                                                [_vModelCheckbox, _ctx.formData.isUseEnglish3]
                                              ]),
                                              _hoisted_885
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createVNode(_component_el_select, {
                                        "popper-class": "umt-form-dd",
                                        modelValue: _ctx.formData.methosIndustryTHPT3,
                                        "onUpdate:modelValue": _cache[228] || (_cache[228] = ($event: any) => ((_ctx.formData.methosIndustryTHPT3) = $event)),
                                        placeholder: "Chọn hình thức",
                                        class: "w-100",
                                        disabled: !_ctx.isPermission || _ctx.arrMethosIndustryTHPT3.length==0 || !_ctx.formData.admissionsIndustryTHPT3,
                                        onChange: _ctx.methosIndustryManualChangeTHPT
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrMethosIndustryTHPT3, (m) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: m.value,
                                              label: m.label,
                                              value: m.value
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "disabled", "onChange"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.formData.admissionsIndustryTHPT3 && (_ctx.formData.formOfMethodMethod5 !== 'TC01' || _ctx.formData.methosIndustryTHPT3))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: _normalizeClass(_ctx.pt5IsSatAct ? 'mb-4 text-left' : 'col-md-3 mb-4 text-left')
                                    }, [
                                      _createElementVNode("div", _hoisted_886, [
                                        (_ctx.formData.formOfMethodMethod5 === 'TC01')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createElementVNode("div", _hoisted_887, [
                                                _createElementVNode("div", _hoisted_888, [
                                                  _hoisted_889,
                                                  (_ctx.getConversionUsedForDisplay(_ctx.formData.methosIndustryTHPT3, 5, 3))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_890, [
                                                        _createElementVNode("span", _hoisted_891, [
                                                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                                        ]),
                                                        _createElementVNode("div", _hoisted_892, [
                                                          _createElementVNode("div", null, " Đã áp dụng quy đổi điểm Tiếng Anh (" + _toDisplayString(_ctx.englishCertResult.convertedScore) + " điểm) có lợi hơn điểm thi thực tế. ", 1)
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("strong", _hoisted_893, _toDisplayString(_ctx.getGPAForDisplay(_ctx.GPAIndustryTHPT3, _ctx.formData.methosIndustryTHPT3, 5, 3)), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_894, [
                                                _createElementVNode("div", _hoisted_895, [
                                                  _hoisted_896,
                                                  (_ctx.isPriorityReducedForDisplay(_ctx.formData.methosIndustryTHPT3, 5, 3))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_897, [
                                                        _createElementVNode("span", _hoisted_898, [
                                                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                                        ]),
                                                        _hoisted_899
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("strong", _hoisted_900, _toDisplayString(_ctx.getPriorityForDisplay(_ctx.GPAIndustryTHPT3, _ctx.formData.methosIndustryTHPT3, 5, 3)), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_901, [
                                                _hoisted_902,
                                                _createElementVNode("strong", _hoisted_903, "+" + _toDisplayString(_ctx.getIncentiveForDisplay(_ctx.GPAIndustryTHPT3, _ctx.formData.methosIndustryTHPT3, 5, 3)), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_904, [
                                                _hoisted_905,
                                                _createElementVNode("span", _hoisted_906, [
                                                  _createElementVNode("strong", null, _toDisplayString(_ctx.getTotalForDisplay(_ctx.GPAIndustryTHPT3, _ctx.formData.methosIndustryTHPT3, 5, 3)), 1)
                                                ])
                                              ])
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createElementVNode("div", _hoisted_907, [
                                                _hoisted_908,
                                                _createElementVNode("strong", _hoisted_909, _toDisplayString((_ctx.formData.formOfMethodMethod5 === 'SAT' ? (+_ctx.formData.sat*30/1600).toFixed(2) : (+_ctx.formData.actScore*30/36).toFixed(2))), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_910, [
                                                _hoisted_911,
                                                _createElementVNode("strong", _hoisted_912, _toDisplayString(_ctx.cacuPointPriority((_ctx.formData.formOfMethodMethod5 === 'SAT' ? +_ctx.formData.sat*30/1600 : +_ctx.formData.actScore*30/36) + _ctx.certIncentiveResult.total).toFixed(2)), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_913, [
                                                _hoisted_914,
                                                _createElementVNode("strong", _hoisted_915, "+" + _toDisplayString(_ctx.certIncentiveResult.total), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_916, [
                                                _hoisted_917,
                                                _createElementVNode("span", _hoisted_918, [
                                                  _createElementVNode("strong", null, _toDisplayString(((_ctx.formData.formOfMethodMethod5 === 'SAT' ? +_ctx.formData.sat*30/1600 : +_ctx.formData.actScore*30/36) + _ctx.certIncentiveResult.total + _ctx.cacuPointPriority((_ctx.formData.formOfMethodMethod5 === 'SAT' ? +_ctx.formData.sat*30/1600 : +_ctx.formData.actScore*30/36) + _ctx.certIncentiveResult.total)).toFixed(2)), 1)
                                                ])
                                              ])
                                            ], 64))
                                      ])
                                    ], 2))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ], 2)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["col-12 my-5", _ctx.fromProfile?'d-flex flex-column flex-md-row gap-5 text-start':'text-center'])
              }, [
                _createElementVNode("div", _hoisted_919, [
                  _createElementVNode("div", _hoisted_920, [
                    false
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_921, [
                            _createElementVNode("div", _hoisted_922, [
                              _hoisted_923,
                              _createVNode(_component_el_select, {
                                "popper-class": "umt-form-dd",
                                class: _normalizeClass(["form-select-solid", [_ctx.formData.status == 'rejected'?'w-100':'',_ctx.formData.status == 'processing'?'select-danger':'',_ctx.formData.status == 'reviewing'?'select-info':'']]),
                                placeholder: "Chọn",
                                modelValue: _ctx.formData.status,
                                "onUpdate:modelValue": _cache[229] || (_cache[229] = ($event: any) => ((_ctx.formData.status) = $event)),
                                onChange: _ctx.checkHighschoolGraduation,
                                disabled: _ctx.isAppraised,
                                filterable: true
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "Mới",
                                    value: "new"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Mới")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Đã xác thực",
                                    value: "verified"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Đã xác thực")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Chưa hoàn tất",
                                    value: "processing"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Chưa hoàn tất")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Đang xem xét",
                                    value: "reviewing"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Đang xem xét")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Không hợp lệ",
                                    value: "rejected"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Không hợp lệ")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Từ chối",
                                    value: "denied"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Từ chối")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class", "modelValue", "onChange", "disabled"])
                            ])
                          ]),
                          (_ctx.formData.status =='rejected')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_924, [
                                _hoisted_925,
                                _withDirectives(_createElementVNode("textarea", {
                                  name: "",
                                  class: "area-custom",
                                  "onUpdate:modelValue": _cache[230] || (_cache[230] = ($event: any) => ((_ctx.comment_profile) = $event)),
                                  id: "",
                                  style: {"width":"100%","height":"40px"}
                                }, null, 512), [
                                  [_vModelText, _ctx.comment_profile]
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2)), [
                [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_EDIT_STATUS,_ctx.Permission.ADMISSION_REGISTER]]
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_926, [
              (_ctx.arpros)
                ? (_openBlock(), _createElementBlock("div", _hoisted_927, [
                    _hoisted_928,
                    _createTextVNode(" Đính kèm hồ sơ")
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_929, [
                    _hoisted_930,
                    _createTextVNode("Đính kèm hồ sơ")
                  ])),
              _createElementVNode("div", _hoisted_931, [
                _createElementVNode("div", _hoisted_932, [
                  _createElementVNode("div", _hoisted_933, [
                    _createElementVNode("div", _hoisted_934, [
                      _createElementVNode("span", _hoisted_935, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil003.svg" })
                      ]),
                      _createElementVNode("div", _hoisted_936, [
                        _hoisted_937,
                        (_ctx.articulationCreate)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(['Bằng tốt nghiệp Cao đẳng/Trung cấp','Bảng điểm quá trình học','Bằng tốt nghiệp THPT hoặc Giấy chứng nhận tốt nghiệp tạm thời'], (item, index) => {
                              return _createElementVNode("div", {
                                class: "d-flex align-items-start mb-2",
                                key: index
                              }, [
                                _createElementVNode("span", _hoisted_938, [
                                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr085.svg" })
                                ]),
                                _createElementVNode("span", _hoisted_939, _toDisplayString(item), 1)
                              ])
                            }), 64))
                          : (_ctx.textFile.filter(i => i.id == _ctx.formData.method).length != 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textFile.filter(i => i.id == _ctx.formData.method)[0]?.label, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "text-gray-700 fs-7 mb-2",
                                    key: 'l'+index
                                  }, _toDisplayString(item), 1))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textFile.filter(i => i.id == _ctx.formData.method)[0]?.value, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "d-flex align-items-start mb-2",
                                    key: index
                                  }, [
                                    _createElementVNode("span", _hoisted_940, [
                                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr085.svg" })
                                    ]),
                                    _createElementVNode("span", _hoisted_941, _toDisplayString(item), 1)
                                  ]))
                                }), 128))
                              ], 64))
                            : (_openBlock(), _createElementBlock("div", _hoisted_942, "Chọn phương thức xét tuyển để xem danh sách tệp cần nộp."))
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_943, [
                _createElementVNode("h5", _hoisted_944, [
                  _createTextVNode("Tệp đính kèm "),
                  _createElementVNode("span", _hoisted_945, "(" + _toDisplayString(_ctx.tableData.length) + " tệp)", 1)
                ]),
                (_ctx.articulationCreate && !_ctx.adCode)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_946, [
                      _createTextVNode("Bấm "),
                      _hoisted_947,
                      _createTextVNode(" để bật tải tệp minh chứng.")
                    ]))
                  : (!_ctx.isAppraised && _ctx.checkPermission([_ctx.Permission.ADMISSION_REGISTER_ATTACHMENT,_ctx.Permission.ADMISSION_REGISTER]))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-sm btn-light-primary",
                        onClick: _cache[231] || (_cache[231] = ($event: any) => (_ctx.showUploadPopup = true))
                      }, [
                        _createElementVNode("span", _hoisted_948, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen055.svg" })
                        ]),
                        _createTextVNode(" Cập nhật tệp đính kèm ")
                      ]))
                    : _createCommentVNode("", true)
              ]),
              (_ctx.tableData.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileTypes, (t) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: t.value
                      }, [
                        (_ctx.tableData.filter(f => f.label == t.value).length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_949, [
                              _createElementVNode("div", _hoisted_950, [
                                _createTextVNode(_toDisplayString(t.label) + " ", 1),
                                _createElementVNode("span", _hoisted_951, _toDisplayString(_ctx.tableData.filter(f => f.label == t.value).length), 1)
                              ]),
                              _createElementVNode("div", _hoisted_952, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData.filter(f => f.label == t.value), (customer, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "position-relative flex-18 hover-file",
                                    key: index
                                  }, [
                                    (customer.processing)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_953, [
                                          _createElementVNode("div", _hoisted_954, [
                                            _createElementVNode("img", {
                                              src: `/media/svg/files/${_ctx.getTypeFile(customer?.type)}.svg`,
                                              alt: ""
                                            }, null, 8, _hoisted_955)
                                          ]),
                                          _createElementVNode("div", _hoisted_956, [
                                            _createElementVNode("div", {
                                              class: "progress-bar progress-bar-primary data-dz-uploadprogress",
                                              role: "progressbar",
                                              id: customer.id
                                            }, _hoisted_959, 8, _hoisted_957)
                                          ])
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_960, [
                                          _createElementVNode("span", _hoisted_961, [
                                            (_ctx.getTypeFile(customer?.type) == 'image')
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  src: customer.file?.url,
                                                  alt: customer.file?.name,
                                                  title: customer.file?.name
                                                }, null, 8, _hoisted_962))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_963, [
                                                  _createElementVNode("img", {
                                                    src: `/media/svg/files/${_ctx.getTypeFile(customer?.type)}.svg`,
                                                    alt: ""
                                                  }, null, 8, _hoisted_964)
                                                ]))
                                          ])
                                        ])),
                                    (!_ctx.isAppraised)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_965, [
                                          _createElementVNode("span", {
                                            class: "cursor-pointer",
                                            onClick: ($event: any) => (_ctx.deleteFile(customer)),
                                            title: "Xóa"
                                          }, [
                                            _createElementVNode("span", _hoisted_967, [
                                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr015.svg" })
                                            ])
                                          ], 8, _hoisted_966)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_968, [
                                      _createElementVNode("a", {
                                        href: customer.file?.url,
                                        target: "_blank",
                                        class: "bg-cirle-white cursor-pointer",
                                        title: "Xem"
                                      }, [
                                        _createElementVNode("span", _hoisted_970, [
                                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen57.svg" })
                                        ])
                                      ], 8, _hoisted_969)
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128)),
                    (_ctx.tableData.filter(f => !_ctx.fileTypes.some(t => t.value == f.label)).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_971, [
                          _createElementVNode("div", _hoisted_972, [
                            _createTextVNode("Chưa phân loại "),
                            _createElementVNode("span", _hoisted_973, _toDisplayString(_ctx.tableData.filter(f => !_ctx.fileTypes.some(t => t.value == f.label)).length), 1)
                          ]),
                          _createElementVNode("div", _hoisted_974, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData.filter(f => !_ctx.fileTypes.some(t => t.value == f.label)), (customer, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "position-relative flex-18 hover-file",
                                key: index
                              }, [
                                (customer.processing)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_975, [
                                      _createElementVNode("div", _hoisted_976, [
                                        _createElementVNode("img", {
                                          src: `/media/svg/files/${_ctx.getTypeFile(customer?.type)}.svg`,
                                          alt: ""
                                        }, null, 8, _hoisted_977)
                                      ]),
                                      _createElementVNode("div", _hoisted_978, [
                                        _createElementVNode("div", {
                                          class: "progress-bar progress-bar-primary data-dz-uploadprogress",
                                          role: "progressbar",
                                          id: customer.id
                                        }, _hoisted_981, 8, _hoisted_979)
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_982, [
                                      _createElementVNode("span", _hoisted_983, [
                                        (_ctx.getTypeFile(customer?.type) == 'image')
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: customer.file?.url,
                                              alt: customer.file?.name,
                                              title: customer.file?.name
                                            }, null, 8, _hoisted_984))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_985, [
                                              _createElementVNode("img", {
                                                src: `/media/svg/files/${_ctx.getTypeFile(customer?.type)}.svg`,
                                                alt: ""
                                              }, null, 8, _hoisted_986)
                                            ]))
                                      ])
                                    ])),
                                (!_ctx.isAppraised)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_987, [
                                      _createElementVNode("span", {
                                        class: "cursor-pointer",
                                        onClick: ($event: any) => (_ctx.deleteFile(customer)),
                                        title: "Xóa"
                                      }, [
                                        _createElementVNode("span", _hoisted_989, [
                                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr015.svg" })
                                        ])
                                      ], 8, _hoisted_988)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_990, [
                                  _createElementVNode("a", {
                                    href: customer.file?.url,
                                    target: "_blank",
                                    class: "bg-cirle-white cursor-pointer",
                                    title: "Xem"
                                  }, [
                                    _createElementVNode("span", _hoisted_992, [
                                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen57.svg" })
                                    ])
                                  ], 8, _hoisted_991)
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_993, [
                    _createTextVNode(" Chưa có tệp đính kèm."),
                    (!_ctx.isAppraised)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_994, [
                          _createTextVNode(" Bấm "),
                          _hoisted_995,
                          _createTextVNode(" để tải lên.")
                        ]))
                      : _createCommentVNode("", true)
                  ])),
              _withDirectives(_createElementVNode("div", _hoisted_996, [
                _createElementVNode("div", {
                  class: "adm-file-popup__backdrop",
                  onClick: _cache[232] || (_cache[232] = ($event: any) => (_ctx.showUploadPopup = false))
                }),
                _createElementVNode("div", _hoisted_997, [
                  _createElementVNode("div", _hoisted_998, [
                    _hoisted_999,
                    _createElementVNode("span", {
                      class: "btn btn-icon btn-sm btn-active-light-primary",
                      onClick: _cache[233] || (_cache[233] = ($event: any) => (_ctx.showUploadPopup = false))
                    }, [
                      _createElementVNode("span", _hoisted_1000, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                      ])
                    ])
                  ]),
                  _hoisted_1001,
                  _createElementVNode("div", _hoisted_1002, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileTypes, (t) => {
                      return (_openBlock(), _createElementBlock("button", {
                        type: "button",
                        key: t.value,
                        class: _normalizeClass(["btn btn-sm", _ctx.tabFile == t.value ? 'btn-primary' : 'btn-light']),
                        onClick: ($event: any) => (_ctx.tabFile = t.value)
                      }, _toDisplayString(t.label), 11, _hoisted_1003))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_1004, [
                    _createTextVNode("2. Kéo–thả / nhấn để tải lên "),
                    (_ctx.tabFile)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_1005, "— " + _toDisplayString((_ctx.fileTypes.find(t => t.value == _ctx.tabFile) || {}).label), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_1006, "(hãy chọn loại tệp ở bước 1)"))
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(!_ctx.isAppraised && _ctx.tabFile && _ctx.checkPermission([_ctx.Permission.ADMISSION_REGISTER_ATTACHMENT,_ctx.Permission.ADMISSION_REGISTER]) ? '' : 'opacity-50 pe-none')
                  }, [
                    _createElementVNode("div", _hoisted_1007, [
                      _createElementVNode("form", _hoisted_1008, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "hide",
                          name: "idAdReg",
                          "onUpdate:modelValue": _cache[234] || (_cache[234] = ($event: any) => ((_ctx.idAdReg) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.idAdReg]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "hide",
                          name: "adCode",
                          "onUpdate:modelValue": _cache[235] || (_cache[235] = ($event: any) => ((_ctx.adCode) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.adCode]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "hide",
                          name: "label",
                          "onUpdate:modelValue": _cache[236] || (_cache[236] = ($event: any) => ((_ctx.tabFile) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.tabFile]
                        ]),
                        (_ctx.arpros)
                          ? (_openBlock(), _createElementBlock("input", _hoisted_1009))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 2),
                  (_ctx.tabFile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1010, [
                        _createElementVNode("div", _hoisted_1011, [
                          _createTextVNode("Tệp đã tải — " + _toDisplayString((_ctx.fileTypes.find(t => t.value == _ctx.tabFile) || {}).label) + " ", 1),
                          _createElementVNode("span", _hoisted_1012, _toDisplayString(_ctx.tableData.filter(f => f.label == _ctx.tabFile).length), 1)
                        ]),
                        _createElementVNode("div", _hoisted_1013, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData.filter(f => f.label == _ctx.tabFile), (customer, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "position-relative flex-18 hover-file",
                              key: index
                            }, [
                              (customer.processing)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_1014, [
                                    _createElementVNode("div", _hoisted_1015, [
                                      _createElementVNode("img", {
                                        src: `/media/svg/files/${_ctx.getTypeFile(customer?.type)}.svg`,
                                        alt: ""
                                      }, null, 8, _hoisted_1016)
                                    ]),
                                    _createElementVNode("div", _hoisted_1017, [
                                      _createElementVNode("div", {
                                        class: "progress-bar progress-bar-primary data-dz-uploadprogress",
                                        role: "progressbar",
                                        id: customer.id
                                      }, _hoisted_1020, 8, _hoisted_1018)
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_1021, [
                                    _createElementVNode("span", _hoisted_1022, [
                                      (_ctx.getTypeFile(customer?.type) == 'image')
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: customer.file?.url,
                                            alt: customer.file?.name,
                                            title: customer.file?.name
                                          }, null, 8, _hoisted_1023))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_1024, [
                                            _createElementVNode("img", {
                                              src: `/media/svg/files/${_ctx.getTypeFile(customer?.type)}.svg`,
                                              alt: ""
                                            }, null, 8, _hoisted_1025)
                                          ]))
                                    ])
                                  ])),
                              (!_ctx.isAppraised)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_1026, [
                                    _createElementVNode("span", {
                                      class: "cursor-pointer",
                                      onClick: ($event: any) => (_ctx.deleteFile(customer)),
                                      title: "Xóa"
                                    }, [
                                      _createElementVNode("span", _hoisted_1028, [
                                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr015.svg" })
                                      ])
                                    ], 8, _hoisted_1027)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_1029, [
                                _createElementVNode("a", {
                                  href: customer.file?.url,
                                  target: "_blank",
                                  class: "bg-cirle-white cursor-pointer",
                                  title: "Xem"
                                }, [
                                  _createElementVNode("span", _hoisted_1031, [
                                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen57.svg" })
                                  ])
                                ], 8, _hoisted_1030)
                              ])
                            ]))
                          }), 128)),
                          (!_ctx.tableData.filter(f => f.label == _ctx.tabFile).length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1032, "Chưa có tệp loại này."))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_1033,
                  _createElementVNode("div", _hoisted_1034, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      onClick: _cache[237] || (_cache[237] = ($event: any) => (_ctx.showUploadPopup = false))
                    }, "Xong")
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.showUploadPopup]
              ])
            ], 512), [
              [_vShow, _ctx.isEdit || _ctx.isAddFiles]
            ])
          ]),
          _createElementVNode("div", _hoisted_1035, [
            _createElementVNode("div", _hoisted_1036, [
              (_ctx.articulationCreate)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_1037,
                    _createTextVNode(": tạo hồ sơ "),
                    _hoisted_1038,
                    _createTextVNode(" (ngành & quá trình học CĐ).  ·  Sau khi tạo, tải "),
                    _hoisted_1039,
                    _createTextVNode(" rồi bấm "),
                    _hoisted_1040,
                    _createTextVNode(".  ·  "),
                    _hoisted_1041,
                    _createTextVNode(": quay lại danh sách hồ sơ ứng viên.  ·  ")
                  ], 64))
                : (_ctx.isAddProfile)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_1042,
                      _createTextVNode(": lưu "),
                      _hoisted_1043,
                      _createTextVNode(" rồi tải tệp.  ·  "),
                      _hoisted_1044,
                      _createTextVNode(": mở trang hồ sơ vừa tạo.  ·  "),
                      _hoisted_1045,
                      _createTextVNode(": về danh sách ứng viên.  ·  ")
                    ], 64))
                  : (!_ctx.fromProfile)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _hoisted_1046,
                        _createTextVNode(" / "),
                        _hoisted_1047,
                        _createTextVNode(": lưu "),
                        _hoisted_1048,
                        _createTextVNode(".  ·  "),
                        _hoisted_1049,
                        _createTextVNode(" / "),
                        _hoisted_1050,
                        _createTextVNode(": đóng cửa sổ.  ·  ")
                      ], 64))
                    : (_ctx.isAppraised)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _hoisted_1051,
                          _createTextVNode(" — chỉ xem, không chỉnh sửa.  ·  "),
                          _hoisted_1052,
                          _createTextVNode(": quay lại " + _toDisplayString(_ctx.$route.query.from == 'ungvien' ? 'trang chi tiết ứng viên' : 'danh sách hồ sơ') + ".  ·  ", 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          _hoisted_1053,
                          _createTextVNode(": lưu "),
                          _hoisted_1054,
                          _createTextVNode(".  ·  "),
                          _hoisted_1055,
                          _createTextVNode(": quay lại " + _toDisplayString(_ctx.$route.query.from == 'ungvien' ? 'trang chi tiết ứng viên' : 'danh sách hồ sơ') + ".  ·  ", 1)
                        ], 64)),
              (!_ctx.isAppraised)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _hoisted_1056,
                    _createTextVNode(" tự lưu NGAY khi thêm/xóa, không cần bấm nút lưu.")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    _createTextVNode("Tệp đính kèm chỉ xem/tải, không thêm/xóa được.")
                  ], 64))
            ]),
            _createElementVNode("div", _hoisted_1057, [
              (!_ctx.isAddProfile && !_ctx.fromProfile)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "btn btn-lg btn-light umt-btn-32",
                    onClick: _cache[238] || (_cache[238] = 
//@ts-ignore
(...args) => (_ctx.hiddenModal && _ctx.hiddenModal(...args)))
                  }, "Hủy bỏ"))
                : _createCommentVNode("", true),
              (_ctx.fromProfile)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: _ctx.profileBackTo,
                    class: _normalizeClass(["btn btn-lg umt-btn-32", _ctx.isAppraised ? 'btn-primary' : 'btn-light'])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.isAppraised ? 'Đóng' : 'Hủy bỏ'), 1)
                    ]),
                    _: 1
                  }, 8, ["to", "class"]))
                : (_ctx.isAddProfile)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 2,
                      to: { path: `/danhsachungvien/${_ctx.idStudent}`, hash: '#tab3' },
                      class: "btn btn-lg btn-light umt-btn-32"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Hủy bỏ")
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true),
              (!(_ctx.fromProfile && _ctx.isAppraised))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    "data-kt-indicator": _ctx.loading ? 'on' : null,
                    disabled: _ctx.loading,
                    class: "btn btn-lg btn-primary umt-btn-32",
                    type: "submit"
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_1059, [
                          (_ctx.isPermission)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.isAddFiles?"Hoàn tất":_ctx.isEdit?"Lưu hồ sơ":"Lưu và tiếp tục cập nhật file đính kèm"), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (!_ctx.isAppraised)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_1060))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_1061, "Đóng"))
                              ], 64)),
                          _createElementVNode("span", _hoisted_1062, [
                            _createVNode(_component_inline_svg, { src: "/icons/duotune/arrows/arr064.svg" })
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_1058))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}